// // UserDashboard.jsx
// import { useEffect, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { selectUser, setUser, clearUser } from "../redux/authSlice";
// import { useToast } from "../context/ToastContext";
// import { useSettings } from "../context/SettingsContext";
// import { useWishlist } from "../hooks/useWishlist";
// import { apiJson } from "../api/apiClient";
// import { apiUrl } from "../apiUrl";
// import WishlistTab from "./WishlistTab";
// import MessagesTab from "./MessagesTab";
// import InvoicesTab from "./InvoicesTab";
// import PaymentsTab from "./PaymentsTab";
// import "../styles/UserDashboard.css";

// const API_BASE = `${apiUrl}/api`;

// // ── Formatters ─────────────────────────────────────────────
// const makeFmt =
//   (symbol = "₹", position = "before") =>
//   (n) => {
//     if (n == null) return "—";
//     const num = new Intl.NumberFormat("en-IN", {
//       maximumFractionDigits: 0,
//     }).format(n);
//     return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
//   };

// const makeFmtExact =
//   (symbol = "₹", position = "before") =>
//   (n) => {
//     if (n == null) return "—";
//     const num = new Intl.NumberFormat("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }).format(n);
//     return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
//   };

// const STATUS_CFG = {
//   confirmed: {
//     color: "#16a34a",
//     bg: "rgba(22,163,74,0.10)",
//     label: "Confirmed",
//   },
//   pending: {
//     color: "#d97706",
//     bg: "rgba(217,119,6,0.10)",
//     label: "Pending Payment",
//   },
//   cancelled: {
//     color: "#dc2626",
//     bg: "rgba(220,38,38,0.10)",
//     label: "Cancelled",
//   },
//   refunded: {
//     color: "#94a3b8",
//     bg: "rgba(148,163,184,0.10)",
//     label: "Refunded",
//   },
// };

// const COMM_CFG = {
//   pending: { color: "#d97706", label: "Pending Approval" },
//   approved: { color: "#2563eb", label: "Approved" },
//   paid: { color: "#16a34a", label: "Paid" },
//   rejected: { color: "#dc2626", label: "Rejected" },
//   refunded: { color: "#94a3b8", label: "Refunded" },
// };

// const msAmount = (m) => parseFloat(m.total_with_tax ?? m.amount ?? 0);

// // ── Role label helper ───────────────────────────────────────
// const roleLabel = (role) =>
//   role === "broker" ? "Broker" : role === "sales" ? "Sales Agent" : "Buyer";

// // ── Elegant Card Component ─────────────────────────────────
// const ElegantCard = ({ children, noPadding, hover, onClick, className }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <div
//       className={`elegant-card ${hover ? "elegant-card-hover" : ""} ${noPadding ? "elegant-card-no-padding" : "elegant-card-padding"} ${onClick ? "elegant-card-clickable" : ""} ${className || ""}`}
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       {children}
//     </div>
//   );
// };

// // ── Elegant Button ─────────────────────────────────────────
// const ElegantButton = ({
//   children,
//   variant = "primary",
//   onClick,
//   disabled,
//   loading,
//   size = "md",
// }) => {
//   const sizeClass = `elegant-btn-${size}`;
//   const variantClass = `elegant-btn-${variant}`;

//   return (
//     <button
//       className={`elegant-btn ${sizeClass} ${variantClass}`}
//       onClick={onClick}
//       disabled={disabled || loading}
//     >
//       {loading && <span className="elegant-btn-spinner"></span>}
//       {children}
//     </button>
//   );
// };

// // ── Elegant Stat Card ──────────────────────────────────────
// const StatCard = ({ icon, label, value, color }) => (
//   <div className="stat-card">
//     <div className="stat-card-content">
//       <div
//         className="stat-card-icon"
//         style={{
//           background: `linear-gradient(135deg, ${color}15, ${color}08)`,
//         }}
//       >
//         {icon}
//       </div>
//       <div>
//         <div className="stat-card-value" style={{ color }}>
//           {value}
//         </div>
//         <div className="stat-card-label">{label}</div>
//       </div>
//     </div>
//   </div>
// );

// // ── Tab Button ─────────────────────────────────────────────
// const TabButton = ({ active, onClick, label, count, primaryColor }) => (
//   <button
//     onClick={onClick}
//     className={`dashboard-tab ${active ? "dashboard-tab-active" : "dashboard-tab-inactive"}`}
//   >
//     {label}
//     {count > 0 && (
//       <span
//         className={`dashboard-tab-count ${active ? "dashboard-tab-count-active" : "dashboard-tab-count-inactive"}`}
//       >
//         {count}
//       </span>
//     )}
//   </button>
// );

// // ── Milestone Row Component ─────────────────────────────────
// const MilestoneRow = ({
//   label,
//   percentage,
//   amount,
//   baseAmount,
//   taxAmount,
//   extraFees,
//   taxLabel,
//   taxRate,
//   hasTax,
//   isPaid,
//   isDue,
//   isOverdue,
//   isWaived,
//   isRefunded,
//   dueDate,
//   paidAt,
//   index,
//   fmtExact,
//   primaryColor,
// }) => {
//   const [showTax, setShowTax] = useState(false);

//   let textColor = "var(--text-muted)";
//   let dotBackground = "transparent";
//   let dotBorder = "var(--card-border)";
//   let dotColor = "var(--text-muted)";

//   if (isRefunded) {
//     textColor = "var(--text-muted)";
//     dotBackground = "transparent";
//     dotBorder = "#94a3b8";
//     dotColor = "#94a3b8";
//   } else if (isPaid) {
//     textColor = primaryColor;
//     dotBackground = primaryColor;
//     dotBorder = primaryColor;
//     dotColor = "#fff";
//   } else if (isOverdue) {
//     textColor = "#dc2626";
//     dotBackground = "transparent";
//     dotBorder = "#dc2626";
//     dotColor = "#dc2626";
//   } else if (isDue) {
//     textColor = "var(--text-dark)";
//     dotBackground = "transparent";
//     dotBorder = primaryColor;
//     dotColor = primaryColor;
//   }

//   const dotContent = isRefunded
//     ? "↺"
//     : isPaid
//       ? "✓"
//       : isWaived
//         ? "–"
//         : index + 1;

//   return (
//     <div className="milestone-row">
//       <div
//         className="milestone-dot"
//         style={{
//           background: dotBackground,
//           border: `2px solid ${dotBorder}`,
//           color: dotColor,
//         }}
//       >
//         {dotContent}
//       </div>
//       <div
//         className="milestone-content"
//         style={{
//           background: isPaid
//             ? `${primaryColor}06`
//             : isRefunded
//               ? "rgba(148,163,184,0.06)"
//               : "var(--page-bg)",
//           border: `1px solid ${isPaid ? primaryColor + "20" : isRefunded ? "#94a3b820" : isOverdue ? "#dc262620" : isDue ? primaryColor + "18" : "var(--card-border)"}`,
//         }}
//       >
//         <div className="milestone-header">
//           <div className="milestone-info">
//             <div className="milestone-label" style={{ color: textColor }}>
//               {label}
//             </div>
//             <div className="milestone-meta">
//               {percentage ? `${percentage}% of total` : ""}
//               {dueDate && !isPaid && !isRefunded && (
//                 <span style={{ marginLeft: percentage ? 8 : 0 }}>
//                   Due: {dueDate}
//                   {isOverdue && (
//                     <span
//                       style={{
//                         color: "#dc2626",
//                         fontWeight: 700,
//                         marginLeft: 6,
//                       }}
//                     >
//                       ⚠ Overdue
//                     </span>
//                   )}
//                 </span>
//               )}
//               {isPaid && paidAt && (
//                 <span style={{ color: "#16a34a", marginLeft: 6 }}>
//                   ✓ Paid {paidAt}
//                 </span>
//               )}
//               {isRefunded && (
//                 <span style={{ color: "#94a3b8", marginLeft: 6 }}>
//                   ↺ Refunded
//                 </span>
//               )}
//               {isDue && !isOverdue && !isRefunded && (
//                 <span style={{ color: "#d97706", marginLeft: 6 }}>
//                   ← Due now
//                 </span>
//               )}
//               {isWaived && (
//                 <span style={{ color: "var(--text-muted)", marginLeft: 6 }}>
//                   Waived
//                 </span>
//               )}
//             </div>
//           </div>
//           <div className="milestone-amount">
//             <div
//               className="milestone-amount-value"
//               style={{ color: textColor }}
//             >
//               {isRefunded ? `−${fmtExact(amount)}` : fmtExact(amount)}
//             </div>
//             {hasTax && !isRefunded && (
//               <button
//                 type="button"
//                 className="milestone-tax-btn"
//                 onClick={() => setShowTax((s) => !s)}
//               >
//                 {taxLabel || "Tax"}
//                 {taxRate > 0 ? ` ${taxRate}%` : ""} {showTax ? "▲" : "▼"}
//               </button>
//             )}
//           </div>
//         </div>

//         {hasTax && showTax && !isRefunded && (
//           <div className="milestone-tax-details">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: "var(--text-muted)",
//                 marginBottom: 4,
//               }}
//             >
//               <span>Base amount</span>
//               <span>{fmtExact(baseAmount)}</span>
//             </div>
//             {(extraFees || 0) > 0 && (
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   color: "var(--text-muted)",
//                   marginBottom: 4,
//                 }}
//               >
//                 <span>Additional fees</span>
//                 <span>{fmtExact(extraFees)}</span>
//               </div>
//             )}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: "#d97706",
//               }}
//             >
//               <span>
//                 {taxLabel || "Tax"}
//                 {taxRate > 0 ? ` (${taxRate}%)` : ""}
//               </span>
//               <span>{fmtExact(taxAmount)}</span>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: primaryColor,
//                 fontWeight: 700,
//                 borderTop: `1px solid ${primaryColor}20`,
//                 paddingTop: 8,
//                 marginTop: 8,
//               }}
//             >
//               <span>Total payable</span>
//               <span>{fmtExact(amount)}</span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // ── Milestone Tracker ───────────────────────────────────────
// const MilestoneTracker = ({
//   bookingId,
//   token,
//   fmtExact,
//   booking,
//   primaryColor,
//   tenant,
// }) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const isBookingRefunded = booking?.booking_status === "refunded";

//   useEffect(() => {
//     if (!bookingId || !token || !tenant) return;

//     const fetchMilestones = async () => {
//       try {
//         const result = await apiJson(
//           tenant,
//           `/bookings/${bookingId}/milestones`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//             },
//           },
//         );
//         setData(result);
//       } catch (err) {
//         console.error("Error fetching milestones:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMilestones();
//   }, [bookingId, token, tenant]);

//   // Show refunded message if booking is refunded
//   if (isBookingRefunded) {
//     return (
//       <div className="milestone-tracker">
//         <div
//           className="refunded-banner"
//           style={{
//             background: "rgba(148,163,184,0.08)",
//             border: "1px solid rgba(148,163,184,0.2)",
//             borderRadius: "12px",
//             padding: "16px",
//             textAlign: "center",
//           }}
//         >
//           <div style={{ fontSize: "32px", marginBottom: "8px" }}>↺</div>
//           <div
//             style={{
//               fontSize: "14px",
//               fontWeight: "700",
//               color: "#64748b",
//               marginBottom: "4px",
//             }}
//           >
//             Booking Refunded
//           </div>
//           <div style={{ fontSize: "12px", color: "var(--text-muted)" }}>
//             This booking has been cancelled and fully refunded.
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!loading && (!data || !data.milestones?.length)) {
//     const plan = booking?.payment_plan;
//     const price = parseFloat(booking?.price || 0);
//     if (!plan?.milestones?.length) {
//       return (
//         <div className="milestone-tracker">
//           <div
//             className="booking-card-expanded"
//             style={{
//               color: "var(--text-muted)",
//               fontSize: 13,
//               padding: "12px 16px",
//               background: "var(--page-bg)",
//               borderRadius: "14px",
//             }}
//           >
//             Full payment — no instalment plan selected
//           </div>
//         </div>
//       );
//     }
//     const isConfirmed = booking.booking_status === "confirmed";
//     const grandTotal = parseFloat(booking.total_amount || price);
//     return (
//       <div className="milestone-tracker">
//         <div className="booking-card-expanded">
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               fontWeight: 700,
//               letterSpacing: "0.8px",
//               textTransform: "uppercase",
//               marginBottom: 12,
//             }}
//           >
//             Payment Schedule — {plan.name}
//           </div>
//           {plan.milestones.map((m, i) => {
//             const amt = m.percentage
//               ? (grandTotal * m.percentage) / 100
//               : m.fixed_amount;
//             const isPaid = i === 0 && isConfirmed;
//             const isDue = i === 0 && !isConfirmed;
//             return (
//               <MilestoneRow
//                 key={i}
//                 label={m.label}
//                 percentage={m.percentage}
//                 amount={amt}
//                 isPaid={isPaid}
//                 isDue={isDue}
//                 isRefunded={false}
//                 index={i}
//                 fmtExact={fmtExact}
//                 primaryColor={primaryColor}
//               />
//             );
//           })}
//         </div>
//       </div>
//     );
//   }

//   if (loading)
//     return (
//       <div className="milestone-tracker">
//         <div
//           className="booking-card-expanded"
//           style={{ color: "var(--text-muted)", fontSize: 12, padding: 12 }}
//         >
//           Loading payment schedule...
//         </div>
//       </div>
//     );

//   const { milestones } = data;
//   const totalAmount = milestones.reduce((s, m) => s + msAmount(m), 0);
//   const paidAmount = milestones
//     .filter((m) => m.status === "paid")
//     .reduce((s, m) => s + msAmount(m), 0);
//   const refundedAmount = milestones
//     .filter((m) => m.status === "refunded")
//     .reduce((s, m) => s + msAmount(m), 0);
//   const balanceDue = totalAmount - paidAmount - refundedAmount;
//   const pct =
//     totalAmount > 0
//       ? Math.round(((paidAmount + refundedAmount) / totalAmount) * 100)
//       : 0;
//   const isFullyRefunded = refundedAmount > 0 && refundedAmount >= totalAmount;

//   return (
//     <div className="milestone-tracker">
//       <div className="milestone-progress">
//         <div className="milestone-progress-header">
//           <span>Payment Progress (incl. taxes)</span>
//           <span className="milestone-progress-percent">{pct}% complete</span>
//         </div>
//         <div className="milestone-progress-bar">
//           <div
//             className="milestone-progress-fill"
//             style={{
//               width: `${pct}%`,
//               background: isFullyRefunded ? "#94a3b8" : primaryColor,
//             }}
//           />
//         </div>
//         <div className="milestone-progress-stats">
//           <span className="milestone-progress-paid">
//             Paid: {fmtExact(paidAmount)}
//           </span>
//           {refundedAmount > 0 && (
//             <span
//               className="milestone-progress-refunded"
//               style={{ color: "#94a3b8" }}
//             >
//               Refunded: {fmtExact(refundedAmount)}
//             </span>
//           )}
//           <span
//             className="milestone-progress-balance"
//             style={{
//               color:
//                 balanceDue > 0
//                   ? "#d97706"
//                   : isFullyRefunded
//                     ? "#94a3b8"
//                     : "#16a34a",
//             }}
//           >
//             {balanceDue > 0
//               ? `Balance: ${fmtExact(balanceDue)}`
//               : isFullyRefunded
//                 ? "✓ Fully Refunded"
//                 : "✓ Fully Paid"}
//           </span>
//         </div>
//       </div>

//       {milestones.map((m, i) => {
//         const isPaid = m.status === "paid";
//         const isOverdue = m.status === "overdue";
//         const isWaived = m.status === "waived";
//         const isRefunded = m.status === "refunded";
//         const isDue =
//           !isPaid &&
//           !isWaived &&
//           !isRefunded &&
//           i ===
//             milestones.findIndex(
//               (x) => x.status === "pending" || x.status === "overdue",
//             );
//         return (
//           <MilestoneRow
//             key={m.id}
//             label={m.label}
//             percentage={m.percentage}
//             amount={msAmount(m)}
//             baseAmount={m.amount}
//             taxAmount={m.tax_amount}
//             extraFees={m.extra_fees}
//             taxLabel={m.tax_label}
//             taxRate={m.tax_rate}
//             hasTax={(m.tax_amount || 0) > 0}
//             isPaid={isPaid}
//             isDue={isDue}
//             isOverdue={isOverdue}
//             isWaived={isWaived}
//             isRefunded={isRefunded}
//             dueDate={m.due_date}
//             paidAt={m.paid_at}
//             index={i}
//             fmtExact={fmtExact}
//             primaryColor={primaryColor}
//           />
//         );
//       })}
//     </div>
//   );
// };

// // ── Inline Manual Payment Form (used in DuesBanner + BookingCard) ──────
// // Always submits as PENDING; admin approval required before it counts as paid.
// const ManualPaymentInline = ({
//   amountDue,
//   fmtExact,
//   submitting,
//   onSubmit,
//   onCancel,
// }) => {
//   const [mode, setMode] = useState("cash");
//   const [reference, setReference] = useState("");
//   const [notes, setNotes] = useState("");

//   return (
//     <div
//       style={{
//         marginTop: 10,
//         padding: 12,
//         borderRadius: 12,
//         background: "var(--page-bg)",
//         border: "1px solid var(--card-border)",
//       }}
//     >
//       <div
//         style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}
//       >
//         <select
//           value={mode}
//           onChange={(e) => setMode(e.target.value)}
//           style={{
//             flex: 1,
//             minWidth: 130,
//             padding: 8,
//             borderRadius: 8,
//             border: "1px solid var(--card-border)",
//             background: "var(--card-bg)",
//             color: "var(--text-dark)",
//           }}
//         >
//           <option value="cash">💵 Cash</option>
//           <option value="cheque">📄 Cheque</option>
//           <option value="bank_transfer">🏦 Bank Transfer</option>
//         </select>
//         <input
//           type="text"
//           placeholder="Reference number (optional)"
//           value={reference}
//           onChange={(e) => setReference(e.target.value)}
//           style={{
//             flex: 1,
//             minWidth: 160,
//             padding: 8,
//             borderRadius: 8,
//             border: "1px solid var(--card-border)",
//             background: "var(--card-bg)",
//             color: "var(--text-dark)",
//           }}
//         />
//       </div>
//       <textarea
//         placeholder="Notes (optional)"
//         value={notes}
//         onChange={(e) => setNotes(e.target.value)}
//         rows={2}
//         style={{
//           width: "100%",
//           padding: 8,
//           borderRadius: 8,
//           border: "1px solid var(--card-border)",
//           background: "var(--card-bg)",
//           color: "var(--text-dark)",
//           marginBottom: 8,
//           resize: "vertical",
//           boxSizing: "border-box",
//         }}
//       />
//       <div
//         style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 10 }}
//       >
//         Amount: <strong>{fmtExact(amountDue)}</strong> · Submitted for admin
//         approval — won't be marked as paid immediately.
//       </div>
//       <div style={{ display: "flex", gap: 8 }}>
//         <ElegantButton
//           size="sm"
//           onClick={() =>
//             onSubmit({ payment_mode: mode, reference_number: reference, notes })
//           }
//           loading={submitting}
//         >
//           Submit for Approval
//         </ElegantButton>
//         <ElegantButton
//           size="sm"
//           variant="ghost"
//           onClick={onCancel}
//           disabled={submitting}
//         >
//           Cancel
//         </ElegantButton>
//       </div>
//     </div>
//   );
// };

// // ── Individual Due Item — Send Link / Pay Online / Record Manual ───────
// const DueItemRow = ({
//   due,
//   fmtExact,
//   onNavigate,
//   isAgent,
//   onSendLink,
//   onManualSubmit,
//   sendingLinkId,
//   sendingLinkKey, 
//   accentColor,
// }) => {
//   const [showManual, setShowManual] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   // const isSendingThis = sendingLinkId === due.bookingId;

//   const isSendingThis = sendingLinkKey === `${due.bookingId}-${due.id}`;

//   const handleManualSubmit = async (payload) => {
//     setSubmitting(true);
//     const ok = await onManualSubmit(due.bookingId, due.id, {
//       ...payload,
//       amount: due.displayAmount,
//     });
//     setSubmitting(false);
//     if (ok) {
//       setSubmitted(true);
//       setShowManual(false);
//     }
//   };

//   return (
//     <div
//       className="dues-item"
//       style={{
//         flexDirection: "column",
//         alignItems: "stretch",
//         borderColor: `${accentColor}30`,
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//         }}
//       >
//         <div>
//           <div className="dues-item-title">{due.label}</div>
//           <div className="dues-item-details">
//             {due.due_date ? `Due: ${due.due_date}` : "No due date set"}
//             {due.status === "overdue" && (
//               <span className="dues-item-overdue">⚠ Overdue</span>
//             )}
//             <span style={{ marginLeft: 8 }}>· Booking #{due.bookingId}</span>
//             {(due.tax_amount || 0) > 0 && (
//               <span className="dues-item-tax">incl. tax</span>
//             )}
//           </div>
//         </div>
//         <div className="dues-item-amount" style={{ color: accentColor }}>
//           <div style={{ fontSize: 18, fontWeight: 800 }}>
//             {fmtExact(due.displayAmount)}
//           </div>
//         </div>
//       </div>

//       {submitted ? (
//         <div
//           style={{
//             marginTop: 10,
//             padding: "8px 12px",
//             borderRadius: 10,
//             background: "rgba(34,197,94,0.08)",
//             border: "1px solid rgba(34,197,94,0.25)",
//             color: "#16a34a",
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           ✓ Submitted — awaiting admin confirmation.
//         </div>
//       ) : (
//         <>
//           <div
//             style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}
//           >
//             {!isAgent && (
//               <ElegantButton
//                 size="sm"
//                 onClick={() =>
//                   onNavigate(`/payment/${due.bookingId}?milestone=${due.id}`)
//                 }
//               >
//                 💳 Pay Online
//               </ElegantButton>
//             )}
//             {isAgent && (
//               <ElegantButton
//                 size="sm"
//                 onClick={() => onSendLink(due.bookingId, due.id)}
//                 loading={isSendingThis}
//               >
//                 ✉️ Send Payment Link
//               </ElegantButton>
//             )}
//             <ElegantButton
//               size="sm"
//               variant="secondary"
//               onClick={() => setShowManual((s) => !s)}
//             >
//               🏦 {showManual ? "Cancel" : "Record Manual Payment"}
//             </ElegantButton>
//           </div>

//           {showManual && (
//             <ManualPaymentInline
//               amountDue={due.displayAmount}
//               fmtExact={fmtExact}
//               submitting={submitting}
//               onSubmit={handleManualSubmit}
//               onCancel={() => setShowManual(false)}
//             />
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// // ── Dues Banner ─────────────────────────────────────────────
// const DuesBanner = ({
//   milestoneMap,
//   fmtExact,
//   onNavigate,
//   primaryColor,
//   isAgent,
//   onSendLink,
//   onManualSubmit,
//   sendingLinkKey,
// }) => {
//   const dues = Object.entries(milestoneMap)
//     .flatMap(([bookingId, data]) =>
//       (data.milestones || [])
//         .filter((m) => m.status === "pending" || m.status === "overdue")
//         .map((m) => ({ ...m, bookingId, displayAmount: msAmount(m) })),
//     )
//     .sort((a, b) => {
//       if (!a.due_date && !b.due_date) return 0;
//       if (!a.due_date) return 1;
//       if (!b.due_date) return -1;
//       return new Date(a.due_date) - new Date(b.due_date);
//     });

//   if (!dues.length) return null;
//   const overdueCount = dues.filter((d) => d.status === "overdue").length;
//   const accentColor = overdueCount > 0 ? "#dc2626" : "#d97706";

//   return (
//     <div className="dues-banner">
//       <ElegantCard hover>
//         <div className="dues-banner-header">
//           <div className="dues-banner-title" style={{ color: accentColor }}>
//             <span style={{ fontSize: 20 }}>⏰</span>
//             Upcoming Payments
//             {overdueCount > 0 && (
//               <span className="dues-banner-badge">{overdueCount} overdue</span>
//             )}
//           </div>
//           <div className="dues-banner-count">
//             {dues.length} payment{dues.length > 1 ? "s" : ""} remaining
//           </div>
//         </div>
//         <div className="dues-list">
//           {dues.map((d, i) => (
//             <DueItemRow
//               key={i}
//               due={d}
//               fmtExact={fmtExact}
//               onNavigate={onNavigate}
//               isAgent={isAgent}
//               onSendLink={onSendLink}
//               onManualSubmit={onManualSubmit}
//               sendingLinkKey={sendingLinkKey} 
//               accentColor={d.status === "overdue" ? "#dc2626" : "#d97706"}
//             />
//           ))}
//         </div>
//       </ElegantCard>
//     </div>
//   );
// };

// // ── Booking Card ────────────────────────────────────────────
// const BookingCard = ({
//   booking,
//   onPay,
//   onCancel,
//   onSendPaymentLink,
//   onManualSubmit,
//   sendingLinkKey,
//   isAgent,
//   fmtExact,
//   token,
//   primaryColor,
//   milestoneMap,
//   tenant,
// }) => {
//   const [expanded, setExpanded] = useState(false);
//   const [cancelling, setCancelling] = useState(false);
//   const [confirmCancel, setConfirmCancel] = useState(false);

//   const [showManualForm, setShowManualForm] = useState(false);
//   const [manualSubmitting, setManualSubmitting] = useState(false);
//   const [manualSubmitted, setManualSubmitted] = useState(false);

//   const isRefunded = booking.booking_status === "refunded";
//   const cfg = STATUS_CFG[booking.booking_status] || STATUS_CFG.pending;
//   const plan = booking.payment_plan;
//   const isConfirmed = booking.booking_status === "confirmed";
//   const isPending = booking.booking_status === "pending";

//   // const isSendingThisLink = sendingLinkKey === `${booking.id}-${resolvedMilestoneId || "main"}`;

//   const paidMilestones = (booking.milestones || []).filter(
//     (m) => m.status === "paid",
//   );
//   const refundedMilestones = (booking.milestones || []).filter(
//     (m) => m.status === "refunded",
//   );
//   const paidTotal = paidMilestones.reduce((sum, m) => sum + msAmount(m), 0);
//   const refundedTotal = refundedMilestones.reduce(
//     (sum, m) => sum + msAmount(m),
//     0,
//   );
//   const allMilestones = booking.milestones || [];
//   const totalFromMs = allMilestones.reduce((sum, m) => sum + msAmount(m), 0);
//   const grandTotal = parseFloat(booking.total_amount || 0) || totalFromMs;

//   const displayAmt = (() => {
//     if (isRefunded) return refundedTotal;
//     if (isConfirmed && paidTotal > 0) return paidTotal;
//     if (isConfirmed) return grandTotal;
//     const dp = parseFloat(booking.down_payment_amount || 0);
//     if (dp > 0) return dp;
//     return grandTotal;
//   })();

//   const amountLabel = isRefunded
//     ? "Refunded Amount"
//     : isPending
//       ? "Down Payment Due"
//       : isConfirmed && paidTotal > 0
//         ? `Paid (${paidMilestones.length} milestone${paidMilestones.length > 1 ? "s" : ""})`
//         : isConfirmed
//           ? "Total Amount"
//           : "Amount";

//   // const isSendingThisLink = sendingLinkId === booking.id;

//   // Resolve which milestone / amount a manual payment recorded here applies to
//   const getManualTarget = () => {
//     const msData = milestoneMap?.[booking.id];
//     const firstPending = msData?.milestones?.find(
//       (m) => m.status === "pending" || m.status === "overdue",
//     );
//     const amount = firstPending
//       ? msAmount(firstPending)
//       : parseFloat(booking.down_payment_amount || booking.total_amount || 0);
//     return { milestoneId: firstPending?.id || null, amount };
//   };

//   return (
//     <ElegantCard hover>
//       <div className="booking-card-header">
//         <div className="booking-card-info">
//           <div className="booking-card-title">
//             <span className="booking-card-unit">
//               Unit {booking.plot_number}
//             </span>
//             <span
//               className="booking-card-status"
//               style={{
//                 background: cfg.bg,
//                 color: cfg.color,
//                 border: `1px solid ${cfg.color}33`,
//               }}
//             >
//               {cfg.label}
//             </span>
//           </div>
//           <div className="booking-card-details">
//             <span>{booking.plot_type}</span>
//             {booking.area && <span>· {booking.area} sqft</span>}
//             {booking.direction && <span>· {booking.direction}</span>}
//           </div>
//           {isAgent && (booking.client_name || booking.client_phone) && (
//             <div
//               className="booking-card-client"
//               style={{
//                 background: `${primaryColor}06`,
//                 border: `1px solid ${primaryColor}18`,
//               }}
//             >
//               <span style={{ color: "var(--text-muted)" }}>Client: </span>
//               <span style={{ color: primaryColor, fontWeight: 600 }}>
//                 {booking.client_name}
//               </span>
//               {booking.client_phone && (
//                 <span style={{ color: "var(--text-muted)" }}>
//                   {" "}
//                   · {booking.client_phone}
//                 </span>
//               )}
//               {booking.client_email && (
//                 <span style={{ color: "var(--text-muted)" }}>
//                   {" "}
//                   · {booking.client_email}
//                 </span>
//               )}
//             </div>
//           )}
//           <div className="booking-card-id">
//             #{booking.id} ·{" "}
//             {new Date(booking.created_at).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//               year: "numeric",
//             })}
//           </div>
//         </div>

//         <div className="booking-card-amount">
//           <div className="booking-card-amount-label">{amountLabel}</div>
//           <div
//             className="booking-card-amount-value"
//             style={{ color: isRefunded ? "#94a3b8" : primaryColor }}
//           >
//             {isRefunded ? `−${fmtExact(displayAmt)}` : fmtExact(displayAmt)}
//           </div>
//           {isConfirmed && plan && paidTotal > 0 && !isRefunded && (
//             <>
//               {refundedTotal > 0 && (
//                 <div
//                   className="booking-card-refunded"
//                   style={{
//                     fontSize: 12,
//                     color: "#94a3b8",
//                     marginTop: 4,
//                     fontWeight: 600,
//                   }}
//                 >
//                   Refunded: {fmtExact(refundedTotal)}
//                 </div>
//               )}
//               {grandTotal - paidTotal - refundedTotal > 0.01 && (
//                 <div className="booking-card-balance">
//                   Balance: {fmtExact(grandTotal - paidTotal - refundedTotal)}
//                 </div>
//               )}
//             </>
//           )}
//           {isConfirmed &&
//             plan &&
//             paidTotal > 0 &&
//             !isRefunded &&
//             grandTotal - paidTotal - refundedTotal <= 0.01 &&
//             refundedTotal === 0 && (
//               <div className="booking-card-paid">✓ Fully paid (incl. tax)</div>
//             )}
//           {isConfirmed &&
//             plan &&
//             refundedTotal > 0 &&
//             grandTotal - paidTotal - refundedTotal <= 0.01 && (
//               <div
//                 className="booking-card-refunded"
//                 style={{
//                   fontSize: 12,
//                   color: "#94a3b8",
//                   marginTop: 4,
//                   fontWeight: 600,
//                 }}
//               >
//                 ✓ Fully Refunded
//               </div>
//             )}
//           {isPending && grandTotal > 0 && (
//             <div className="booking-card-grand-total">
//               Grand total: {fmtExact(grandTotal)}
//             </div>
//           )}
//         </div>
//       </div>

//       {isAgent && booking.commission_amount && (
//         <div
//           className="booking-card-commission"
//           style={{
//             background: `${primaryColor}06`,
//             border: `1px solid ${primaryColor}18`,
//           }}
//         >
//           <span className="booking-card-commission-label">Commission:</span>
//           <span className="booking-card-commission-value">
//             {fmtExact(booking.commission_amount)}
//           </span>
//           {booking.commission_status &&
//             (() => {
//               const cs =
//                 COMM_CFG[booking.commission_status] || COMM_CFG.pending;
//               return (
//                 <span
//                   className="booking-card-commission-status"
//                   style={{ color: cs.color }}
//                 >
//                   {cs.label}
//                 </span>
//               );
//             })()}
//         </div>
//       )}

//       <div className="booking-card-actions">
//         {isPending && !isAgent && (
//           <ElegantButton
//             onClick={() => {
//               const { milestoneId } = getManualTarget();
//               onPay(booking.id, milestoneId);
//             }}
//             size="sm"
//           >
//             💳 Complete Payment
//           </ElegantButton>
//         )}
//         {isPending && isAgent && (
//           <ElegantButton
//             onClick={() => {
//               const { milestoneId } = getManualTarget();
//               onSendPaymentLink(booking.id, milestoneId);
//             }}
//             size="sm"
//             loading={isSendingThisLink}
//           >
//             ✉️ Send Payment Link
//           </ElegantButton>
//         )}
//         {isPending && !manualSubmitted && (
//           <ElegantButton
//             variant="secondary"
//             onClick={() => setShowManualForm((s) => !s)}
//             size="sm"
//           >
//             🏦 {showManualForm ? "Cancel" : "Record Manual Payment"}
//           </ElegantButton>
//         )}
//         <ElegantButton
//           variant="secondary"
//           onClick={() => setExpanded((e) => !e)}
//           size="sm"
//         >
//           {expanded ? "▲ Less" : "▼ Payment Schedule"}
//         </ElegantButton>
//         {isPending && !confirmCancel && !isRefunded && (
//           <ElegantButton
//             variant="ghost"
//             onClick={() => setConfirmCancel(true)}
//             size="sm"
//           >
//             ✕ Cancel
//           </ElegantButton>
//         )}
//         {isPending && confirmCancel && !isRefunded && (
//           <div className="booking-card-cancel-confirm">
//             <span className="booking-card-cancel-text">Are you sure?</span>
//             <ElegantButton
//               variant="secondary"
//               onClick={async () => {
//                 setCancelling(true);
//                 await onCancel(booking.id);
//                 setCancelling(false);
//                 setConfirmCancel(false);
//               }}
//               size="sm"
//               loading={cancelling}
//             >
//               Yes, Cancel
//             </ElegantButton>
//             <ElegantButton
//               variant="ghost"
//               onClick={() => setConfirmCancel(false)}
//               size="sm"
//             >
//               No
//             </ElegantButton>
//           </div>
//         )}
//       </div>

//       {showManualForm && !manualSubmitted && (
//         <ManualPaymentInline
//           amountDue={getManualTarget().amount}
//           fmtExact={fmtExact}
//           submitting={manualSubmitting}
//           onSubmit={async (payload) => {
//             const { milestoneId, amount } = getManualTarget();
//             setManualSubmitting(true);
//             const ok = await onManualSubmit(booking.id, milestoneId, {
//               ...payload,
//               amount,
//             });
//             setManualSubmitting(false);
//             if (ok) {
//               setManualSubmitted(true);
//               setShowManualForm(false);
//             }
//           }}
//           onCancel={() => setShowManualForm(false)}
//         />
//       )}
//       {manualSubmitted && (
//         <div
//           style={{
//             marginTop: 8,
//             padding: "8px 12px",
//             borderRadius: 10,
//             background: "rgba(34,197,94,0.08)",
//             border: "1px solid rgba(34,197,94,0.25)",
//             color: "#16a34a",
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           ✓ Manual payment submitted — awaiting admin confirmation.
//         </div>
//       )}

//       {isPending && isAgent && !booking.client_email && (
//         <div
//           style={{
//             marginTop: 8,
//             fontSize: 11,
//             color: "#d97706",
//             fontStyle: "italic",
//           }}
//         >
//           ⚠ No client email on file for this booking — the link will be sent
//           once an email is added.
//         </div>
//       )}

//       {expanded && (
//         <div className="booking-card-expanded">
//           <MilestoneTracker
//             bookingId={booking.id}
//             token={token}
//             fmtExact={fmtExact}
//             booking={booking}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         </div>
//       )}
//     </ElegantCard>
//   );
// };

// // ── Profile Panel ───────────────────────────────────────────
// const ProfilePanel = ({ user, onSaved, showToast, primaryColor, tenant }) => {
//   const [form, setForm] = useState({
//     name: user.name || "",
//     phone: user.phone || "",
//     current_password: "",
//     new_password: "",
//     confirm_password: "",
//   });
//   const [saving, setSaving] = useState(false);

//   const handleSave = async () => {
//     if (form.new_password && form.new_password !== form.confirm_password) {
//       showToast("⚠️ New passwords do not match", "warning", 3500);
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = { name: form.name, phone: form.phone };
//       if (form.new_password) {
//         payload.current_password = form.current_password;
//         payload.new_password = form.new_password;
//       }

//       const result = await apiJson(tenant, `/user/profile`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${user.token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       showToast("✅ Profile updated successfully", "success", 3500);
//       setForm((f) => ({
//         ...f,
//         current_password: "",
//         new_password: "",
//         confirm_password: "",
//       }));
//       onSaved({ ...user, name: form.name, phone: form.phone });
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//     setSaving(false);
//   };

//   const isAgent = user.role === "broker" || user.role === "sales";

//   return (
//     <div className="profile-panel">
//       <ElegantCard>
//         <div className="profile-header">
//           <div
//             className="profile-avatar"
//             style={{
//               background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//               boxShadow: `0 4px 14px ${primaryColor}30`,
//             }}
//           >
//             {user.name?.[0]?.toUpperCase()}
//           </div>
//           <div className="profile-info">
//             <div className="profile-name">{user.name}</div>
//             <div className="profile-email">{user.email}</div>
//             <div className="profile-role" style={{ color: primaryColor }}>
//               {isAgent
//                 ? `${roleLabel(user.role)}${user.broker_company ? " · " + user.broker_company : ""}`
//                 : "Buyer"}
//             </div>
//           </div>
//         </div>

//         {isAgent && (
//           <div className="profile-broker-stats">
//             {[
//               {
//                 label: "Commission Rate",
//                 value: `${user.commission_rate || 2}%`,
//               },
//               {
//                 label: "Account Status",
//                 value: user.status || "active",
//                 color: user.status === "active" ? "#16a34a" : "#dc2626",
//               },
//             ].map(({ label, value, color }) => (
//               <div
//                 key={label}
//                 className="profile-broker-stat"
//                 style={{
//                   background: `${primaryColor}06`,
//                   border: `1px solid ${primaryColor}15`,
//                 }}
//               >
//                 <div className="profile-broker-stat-label">{label}</div>
//                 <div
//                   className="profile-broker-stat-value"
//                   style={{ color: color || primaryColor }}
//                 >
//                   {value}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         <div className="profile-section-title">Edit Profile</div>

//         <input
//           type="text"
//           placeholder="Full Name *"
//           value={form.name}
//           onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           className="profile-input"
//         />
//         <input
//           value={user.email}
//           readOnly
//           placeholder="Email"
//           className="profile-input profile-input-readonly"
//         />
//         <input
//           type="tel"
//           placeholder="Phone Number"
//           value={form.phone}
//           onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           className="profile-input"
//         />

//         <div className="profile-password-title">
//           Change Password (leave blank to keep current)
//         </div>
//         <input
//           type="password"
//           placeholder="Current Password"
//           value={form.current_password}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, current_password: e.target.value }))
//           }
//           className="profile-input"
//         />
//         <div className="profile-password-grid">
//           <input
//             type="password"
//             placeholder="New Password"
//             value={form.new_password}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, new_password: e.target.value }))
//             }
//             className="profile-input"
//           />
//           <input
//             type="password"
//             placeholder="Confirm Password"
//             value={form.confirm_password}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, confirm_password: e.target.value }))
//             }
//             className="profile-input"
//           />
//         </div>

//         <ElegantButton
//           onClick={handleSave}
//           disabled={saving || !form.name}
//           loading={saving}
//           size="lg"
//           style={{ width: "100%", marginTop: 8 }}
//         >
//           Save Changes →
//         </ElegantButton>
//       </ElegantCard>
//     </div>
//   );
// };

// // ── Agent Stats (broker or sales) ───────────────────────────
// const AgentStats = ({ bookings, fmtExact, primaryColor }) => {
//   const commPending = bookings
//     .filter((b) => b.commission_status === "pending")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
//   const commApproved = bookings
//     .filter((b) => b.commission_status === "approved")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
//   const commPaid = bookings
//     .filter((b) => b.commission_status === "paid")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);

//   return (
//     <div className="broker-stats">
//       {[
//         {
//           label: "Pending Commission",
//           value: fmtExact(commPending),
//           color: "#d97706",
//           icon: "⏳",
//         },
//         {
//           label: "Approved Commission",
//           value: fmtExact(commApproved),
//           color: "#2563eb",
//           icon: "✓",
//         },
//         {
//           label: "Commission Paid",
//           value: fmtExact(commPaid),
//           color: "#16a34a",
//           icon: "💰",
//         },
//         {
//           label: "Total Clients",
//           value: bookings.length,
//           color: primaryColor,
//           icon: "👥",
//         },
//       ].map(({ label, value, color, icon }) => (
//         <div key={label} className="broker-stat-card">
//           <div className="broker-stat-content">
//             <span className="broker-stat-icon">{icon}</span>
//             <div className="broker-stat-value" style={{ color }}>
//               {value}
//             </div>
//           </div>
//           <div className="broker-stat-label">{label}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// // ── Notifications Tab ──────────────────────────────────────
// const NOTIF_CFG = {
//   payment_reminder: { color: "#d97706", label: "Payment Reminder" },
//   booking_confirmed: { color: "#16a34a", label: "Booking Confirmed" },
//   booking_cancelled: { color: "#dc2626", label: "Booking Cancelled" },
//   project_launch: { color: null, label: "Project Launch" },
//   offer: { color: "#7c3aed", label: "Special Offer" },
//   general: { color: null, label: "General" },
// };

// const NotificationModal = ({
//   notif,
//   onClose,
//   onMarkRead,
//   onNavigate,
//   onSwitchToBookings,
//   primaryColor,
// }) => {
//   const cfg = notif
//     ? { ...(NOTIF_CFG[notif.type] || NOTIF_CFG.general) }
//     : NOTIF_CFG.general;
//   if (!cfg.color) cfg.color = primaryColor;

//   useEffect(() => {
//     if (!notif) return;
//     if (!notif.is_read) onMarkRead(notif.id);
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [notif?.id, onMarkRead, onClose]);

//   if (!notif) return null;

//   const timeAgo = (dateStr) => {
//     const diff = Date.now() - new Date(dateStr).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 1) return "Just now";
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     const d = Math.floor(h / 24);
//     return d < 7
//       ? `${d}d ago`
//       : new Date(dateStr).toLocaleDateString("en-IN", {
//           day: "numeric",
//           month: "short",
//           year: "numeric",
//         });
//   };

//   const handleViewBooking = () => {
//     onClose();
//     if (notif.type === "payment_reminder")
//       onNavigate(`/payment/${notif.booking_id}`);
//     else onSwitchToBookings(notif.booking_id);
//   };

//   return (
//     <div onClick={onClose} className="notification-modal-overlay">
//       <div
//         onClick={(e) => e.stopPropagation()}
//         className="notification-modal"
//         style={{ borderTopColor: cfg.color }}
//       >
//         <div className="notification-modal-header">
//           <div
//             className="notification-modal-icon"
//             style={{
//               background: `${cfg.color}12`,
//               borderColor: `${cfg.color}25`,
//             }}
//           >
//             🔔
//           </div>
//           <div className="notification-modal-info">
//             <div className="notification-modal-title">{notif.title}</div>
//             <div className="notification-modal-meta">
//               <span
//                 className="notification-modal-category"
//                 style={{ background: `${cfg.color}12`, color: cfg.color }}
//               >
//                 {cfg.label}
//               </span>
//               <span className="notification-modal-time">
//                 {timeAgo(notif.created_at)}
//               </span>
//             </div>
//           </div>
//           <button onClick={onClose} className="notification-modal-close">
//             ×
//           </button>
//         </div>
//         <div className="notification-modal-body">
//           <div className="notification-modal-message">{notif.message}</div>
//           <div className="notification-modal-actions">
//             {notif.booking_id && (
//               <ElegantButton onClick={handleViewBooking}>
//                 {notif.type === "payment_reminder"
//                   ? "Complete Payment →"
//                   : "View Booking →"}
//               </ElegantButton>
//             )}
//             <ElegantButton variant="secondary" onClick={onClose}>
//               Close
//             </ElegantButton>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const NotificationsTab = ({
//   notifications,
//   loading,
//   unreadCount,
//   onMarkRead,
//   onMarkAllRead,
//   onNavigate,
//   onSwitchToBookings,
//   primaryColor,
//   tenant,
// }) => {
//   const [filter, setFilter] = useState("all");
//   const [selectedNotif, setSelectedNotif] = useState(null);

//   const filtered = notifications.filter((n) => {
//     if (filter === "unread") return !n.is_read;
//     if (filter === "read") return n.is_read;
//     return true;
//   });

//   const timeAgo = (dateStr) => {
//     const diff = Date.now() - new Date(dateStr).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 1) return "Just now";
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     const d = Math.floor(h / 24);
//     if (d < 7) return `${d}d ago`;
//     return new Date(dateStr).toLocaleDateString("en-IN", {
//       day: "numeric",
//       month: "short",
//     });
//   };

//   if (loading)
//     return (
//       <div className="dashboard-loading">
//         <div className="dashboard-loading-icon">⏳</div>
//         <div className="dashboard-loading-text">Loading notifications...</div>
//       </div>
//     );

//   return (
//     <div className="notifications-tab">
//       {selectedNotif && (
//         <NotificationModal
//           notif={selectedNotif}
//           onClose={() => setSelectedNotif(null)}
//           onMarkRead={onMarkRead}
//           onNavigate={onNavigate}
//           onSwitchToBookings={onSwitchToBookings}
//           primaryColor={primaryColor}
//         />
//       )}
//       <div className="notifications-filter">
//         <div className="notifications-filter-group">
//           {[
//             ["all", "All"],
//             ["unread", "Unread"],
//             ["read", "Read"],
//           ].map(([val, label]) => (
//             <button
//               key={val}
//               onClick={() => setFilter(val)}
//               className={`notifications-filter-btn ${filter === val ? "notifications-filter-active" : "notifications-filter-inactive"}`}
//             >
//               {label}
//               {val === "unread" && unreadCount > 0 && (
//                 <span
//                   className="notifications-badge"
//                   style={{ background: "#d97706", color: "#fff" }}
//                 >
//                   {unreadCount}
//                 </span>
//               )}
//             </button>
//           ))}
//         </div>
//         {unreadCount > 0 && (
//           <ElegantButton variant="secondary" onClick={onMarkAllRead} size="sm">
//             ✓ Mark all read
//           </ElegantButton>
//         )}
//       </div>

//       {filtered.length === 0 && (
//         <div className="dashboard-empty">
//           <div className="dashboard-empty-icon">🔔</div>
//           <div className="dashboard-empty-title">
//             {filter === "unread"
//               ? "No unread notifications"
//               : "No notifications yet"}
//           </div>
//           <div className="dashboard-empty-subtitle">
//             Payment reminders and booking updates will appear here.
//           </div>
//         </div>
//       )}

//       <div className="notifications-list">
//         {filtered.map((n) => {
//           const cfg = { ...(NOTIF_CFG[n.type] || NOTIF_CFG.general) };
//           if (!cfg.color) cfg.color = primaryColor;
//           return (
//             <div
//               key={n.id}
//               onClick={() => setSelectedNotif(n)}
//               className={`notification-item ${n.is_read ? "notification-item-read" : "notification-item-unread"}`}
//             >
//               {!n.is_read && (
//                 <div
//                   className="notification-dot"
//                   style={{ background: cfg.color }}
//                 />
//               )}
//               <div className="notification-content">
//                 <div className="notification-header">
//                   <span
//                     className={`notification-title ${n.is_read ? "notification-title-normal" : "notification-title-bold"}`}
//                   >
//                     {n.title}
//                   </span>
//                   <span
//                     className="notification-category"
//                     style={{ background: `${cfg.color}12`, color: cfg.color }}
//                   >
//                     {cfg.label}
//                   </span>
//                 </div>
//                 <div className="notification-message">
//                   {n.message.length > 100
//                     ? n.message.slice(0, 100) + "…"
//                     : n.message}
//                 </div>
//                 <div className="notification-footer">
//                   <span className="notification-time">
//                     {timeAgo(n.created_at)}
//                   </span>
//                   <span
//                     className="notification-action"
//                     style={{ color: cfg.color }}
//                   >
//                     Click to read →
//                   </span>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Feedback Tab ────────────────────────────────────────────
// const CATEGORY_CFG = {
//   general: { color: "#6b7280" },
//   service: { color: "#2563eb" },
//   unit: { color: null },
//   payment: { color: "#d97706" },
//   staff: { color: "#7c3aed" },
// };

// const StarRating = ({ value, onChange, primaryColor }) => (
//   <div className="feedback-rating-stars">
//     {[1, 2, 3, 4, 5].map((s) => (
//       <button
//         key={s}
//         type="button"
//         onClick={() => onChange(s)}
//         className="feedback-star"
//         style={{ color: s <= value ? primaryColor : "var(--card-border)" }}
//       >
//         ★
//       </button>
//     ))}
//   </div>
// );

// const FeedbackTab = ({
//   feedbacks,
//   bookings,
//   token,
//   onSubmitted,
//   showToast,
//   primaryColor,
//   tenant,
// }) => {
//   const [showForm, setShowForm] = useState(false);
//   const [form, setForm] = useState({
//     rating: 5,
//     category: "general",
//     subject: "",
//     message: "",
//     booking_id: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   const handleSubmit = async () => {
//     if (!form.subject.trim() || !form.message.trim()) {
//       showToast("⚠️ Subject and message are required", "warning", 3500);
//       return;
//     }
//     setSubmitting(true);
//     try {
//       const result = await apiJson(tenant, `/feedback`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           ...form,
//           booking_id: form.booking_id || undefined,
//         }),
//       });

//       showToast(
//         "🙏 Thank you! Your feedback has been submitted",
//         "success",
//         4000,
//       );
//       setForm({
//         rating: 5,
//         category: "general",
//         subject: "",
//         message: "",
//         booking_id: "",
//       });
//       setShowForm(false);
//       onSubmitted(result.feedback);
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//     setSubmitting(false);
//   };

//   const confirmedBookings = bookings.filter(
//     (b) => b.booking_status === "confirmed",
//   );

//   return (
//     <div>
//       <div className="feedback-header">
//         <div>
//           <div className="feedback-title">Your Feedback</div>
//           <div className="feedback-subtitle">Share your experience with us</div>
//         </div>
//         <ElegantButton onClick={() => setShowForm((f) => !f)}>
//           {showForm ? "✕ Cancel" : "+ New Feedback"}
//         </ElegantButton>
//       </div>

//       {showForm && (
//         <div className="feedback-form">
//           <ElegantCard>
//             <div className="feedback-form-title">New Feedback</div>

//             <div className="feedback-rating">
//               <div className="feedback-rating-label">Rating *</div>
//               <StarRating
//                 value={form.rating}
//                 onChange={(r) => setForm((f) => ({ ...f, rating: r }))}
//                 primaryColor={primaryColor}
//               />
//               <div className="feedback-rating-text">
//                 {
//                   ["", "Very Poor", "Poor", "Average", "Good", "Excellent"][
//                     form.rating
//                   ]
//                 }
//               </div>
//             </div>

//             <div className="feedback-category">
//               <div className="feedback-category-label">Category *</div>
//               <div className="feedback-category-group">
//                 {Object.entries(CATEGORY_CFG).map(([cat, cfg]) => {
//                   const catColor = cfg.color || primaryColor;
//                   const isActive = form.category === cat;
//                   return (
//                     <button
//                       key={cat}
//                       type="button"
//                       onClick={() => setForm((f) => ({ ...f, category: cat }))}
//                       className={`feedback-category-btn ${isActive ? "feedback-category-active" : "feedback-category-inactive"}`}
//                     >
//                       {cat}
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             {confirmedBookings.length > 0 && (
//               <select
//                 value={form.booking_id}
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, booking_id: e.target.value }))
//                 }
//                 className="feedback-select"
//               >
//                 <option value="">Select booking (optional)</option>
//                 {confirmedBookings.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     Unit {b.plot_number} — Booking #{b.id}
//                   </option>
//                 ))}
//               </select>
//             )}

//             <input
//               type="text"
//               placeholder="Subject *"
//               value={form.subject}
//               onChange={(e) =>
//                 setForm((f) => ({ ...f, subject: e.target.value }))
//               }
//               className="feedback-input"
//             />

//             <textarea
//               placeholder="Your message..."
//               value={form.message}
//               onChange={(e) =>
//                 setForm((f) => ({ ...f, message: e.target.value }))
//               }
//               rows={4}
//               className="feedback-textarea"
//             />

//             <div className="feedback-actions">
//               <ElegantButton onClick={handleSubmit} loading={submitting}>
//                 Submit Feedback →
//               </ElegantButton>
//               <ElegantButton
//                 variant="secondary"
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </ElegantButton>
//             </div>
//           </ElegantCard>
//         </div>
//       )}

//       {feedbacks.length === 0 && !showForm && (
//         <div className="feedback-empty">
//           <div className="feedback-empty-icon">💬</div>
//           <div className="feedback-empty-title">No feedback yet</div>
//           <div className="feedback-empty-text">
//             Share your experience to help us improve.
//           </div>
//         </div>
//       )}

//       <div className="feedback-list">
//         {feedbacks.map((fb) => {
//           const catColor = CATEGORY_CFG[fb.category]?.color || primaryColor;
//           const ratingColor =
//             fb.rating >= 4 ? "#16a34a" : fb.rating >= 3 ? "#d97706" : "#dc2626";
//           const statusColor =
//             fb.status === "resolved"
//               ? "#16a34a"
//               : fb.status === "reviewed"
//                 ? "#2563eb"
//                 : "#d97706";
//           return (
//             <div key={fb.id} className="feedback-card">
//               <div className="feedback-card-header">
//                 <div className="feedback-card-info">
//                   <div className="feedback-card-tags">
//                     <span className="feedback-card-subject">{fb.subject}</span>
//                     <span
//                       className="feedback-card-category"
//                       style={{ background: `${catColor}12`, color: catColor }}
//                     >
//                       {fb.category}
//                     </span>
//                     <span
//                       className="feedback-card-status"
//                       style={{
//                         background: `${statusColor}12`,
//                         color: statusColor,
//                       }}
//                     >
//                       {fb.status}
//                     </span>
//                   </div>
//                   <div className="feedback-card-date">
//                     {fb.booking ? `Unit ${fb.booking.plot_number} · ` : ""}
//                     {new Date(fb.created_at).toLocaleDateString("en-IN", {
//                       day: "numeric",
//                       month: "short",
//                       year: "numeric",
//                     })}
//                   </div>
//                 </div>
//                 <div
//                   className="feedback-card-rating"
//                   style={{ color: ratingColor }}
//                 >
//                   {"★".repeat(fb.rating)}
//                 </div>
//               </div>
//               <div className="feedback-card-message">{fb.message}</div>
//               {fb.admin_reply && (
//                 <div
//                   className="feedback-card-reply"
//                   style={{
//                     background: "#16a34a08",
//                     border: "1px solid #16a34a20",
//                   }}
//                 >
//                   <div
//                     className="feedback-card-reply-title"
//                     style={{ color: "#16a34a" }}
//                   >
//                     Admin Reply
//                   </div>
//                   <div className="feedback-card-reply-text">
//                     {fb.admin_reply}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Main Dashboard ──────────────────────────────────────────
// export default function UserDashboard() {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const user = useSelector(selectUser);
//   const { settings } = useSettings();
//   const { tenant } = useParams();

//   const primaryColor = settings?.primary_color || "#c9a96e";

//   const [bookings, setBookings] = useState([]);
//   const [milestoneMap, setMilestoneMap] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [activeTab, setActiveTab] = useState("bookings");
//   const [notifications, setNotifications] = useState([]);
//   const [notifsLoading, setNotifsLoading] = useState(false);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [feedbacks, setFeedbacks] = useState([]);
//   const [payments, setPayments] = useState([]);
//   const [paymentsLoading, setPaymentsLoading] = useState(false);
//   const [unreadMessages, setUnreadMessages] = useState(0);
//   const [invoices, setInvoices] = useState([]);
//   const [invoiceCount, setInvoiceCount] = useState(0);
//   const [sendingLinkId, setSendingLinkId] = useState(null);

//   const [sendingLinkKey, setSendingLinkKey] = useState(null);

//   const { showToast } = useToast();
//   const {
//     wishlist,
//     wishedIds,
//     toggle: toggleWishRaw,
//     loading: wishLoading,
//   } = useWishlist(tenant, user?.token);

//   const handleWishlistToggle = useCallback(
//     async (plotId) => {
//       const wasWished =
//         wishedIds instanceof Set && wishedIds.has(Number(plotId));
//       await toggleWishRaw(Number(plotId));
//       showToast(
//         wasWished ? "🤍 Removed from Wishlist" : "❤️ Added to Wishlist",
//         wasWished ? "wishlist_remove" : "wishlist_add",
//         2800,
//       );
//     },
//     [wishedIds, toggleWishRaw, showToast],
//   );

//   const [currency, setCurrency] = useState({
//     symbol: "₹",
//     code: "INR",
//     position: "before",
//   });

//   const fmt = useCallback(
//     (n) => makeFmt(currency.symbol, currency.position)(n),
//     [currency],
//   );
//   const fmtExact = useCallback(
//     (n) => makeFmtExact(currency.symbol, currency.position)(n),
//     [currency],
//   );

//   const isAgent = user?.role === "broker" || user?.role === "sales";

//   // ── Refresh the logged-in user's own record from the server ─────────
//   const fetchCurrentUser = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const fresh = await apiJson(tenant, `/user/me`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       dispatch(setUser({ ...user, ...fresh, token: user.token }));
//     } catch (_) {
//       // Non-fatal — dashboard still works with the cached user object.
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, user?.token, dispatch]);

//   const fetchMilestones = useCallback(
//     async (bookingsList) => {
//       const targets = bookingsList.filter(
//         (b) =>
//           (b.booking_status === "confirmed" ||
//             b.booking_status === "pending") &&
//           b.payment_plan_id,
//       );
//       if (!targets.length || !tenant) return;

//       const results = await Promise.all(
//         targets.map((b) =>
//           apiJson(tenant, `/bookings/${b.id}/milestones`, {
//             headers: {
//               Authorization: `Bearer ${user?.token}`,
//               Accept: "application/json",
//             },
//           }).catch(() => null),
//         ),
//       );
//       const map = {};
//       targets.forEach((b, i) => {
//         if (results[i]) map[b.id] = results[i];
//       });
//       setMilestoneMap(map);
//     },
//     [user?.token, tenant],
//   );

//   const switchToBookings = useCallback(
//     (bookingId) => {
//       setActiveTab("bookings");
//       if (!bookingId) return;
//       setTimeout(() => {
//         const el = document.getElementById(`booking-card-${bookingId}`);
//         if (el) {
//           el.scrollIntoView({ behavior: "smooth", block: "center" });
//           el.style.boxShadow = `0 0 0 2px ${primaryColor}, 0 0 24px ${primaryColor}30`;
//           el.style.transition = "box-shadow 0.3s";
//           setTimeout(() => {
//             el.style.boxShadow = "";
//           }, 3000);
//         }
//       }, 150);
//     },
//     [primaryColor],
//   );

//   const fetchInvoices = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const data = await apiJson(tenant, `/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//           Accept: "application/json",
//         },
//       });

//       let invoicesList = [];
//       if (data.success && Array.isArray(data.invoices)) {
//         invoicesList = data.invoices;
//       } else if (Array.isArray(data)) {
//         invoicesList = data;
//       }

//       setInvoices(invoicesList);
//       setInvoiceCount(invoicesList.length);
//     } catch (_) {}
//   }, [tenant, user?.token]);

//   const fetchBookings = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setLoading(true);
//     setError("");
//     try {
//       const data = await apiJson(tenant, `/bookings`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const list = Array.isArray(data) ? data : data.data || [];
//       setBookings(list);
//       fetchMilestones(list);
//     } catch (e) {
//       setError(e.message);
//       showToast("❌ Could not load bookings. Please retry.", "error", 4000);
//     } finally {
//       setLoading(false);
//     }
//   }, [tenant, user?.token, fetchMilestones, showToast]);

//   const fetchPayments = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setPaymentsLoading(true);
//     try {
//       const [txns, booksRaw] = await Promise.all([
//         apiJson(tenant, `/payment/history`, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             Accept: "application/json",
//           },
//         }),
//         apiJson(tenant, `/bookings`, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             Accept: "application/json",
//           },
//         }),
//       ]);

//       const txnList = Array.isArray(txns) ? txns : [];
//       const books = Array.isArray(booksRaw) ? booksRaw : booksRaw.data || [];
//       const txnBookingIds = new Set(txnList.map((t) => String(t.booking_id)));
//       const missingTxns = books
//         .filter(
//           (b) =>
//             b.booking_status === "confirmed" &&
//             !txnBookingIds.has(String(b.id)),
//         )
//         .map((b) => ({
//           id: `booking_${b.id}`,
//           booking_id: b.id,
//           amount: b.down_payment_amount || b.total_amount || 0,
//           currency: "INR",
//           status: "success",
//           mode: "manual",
//           gateway: "cash / manual",
//           paid_at: b.created_at,
//           _synthetic: true,
//           booking: {
//             id: b.id,
//             plot_number: b.plot_number,
//             plot_type: b.plot_type,
//             booking_status: b.booking_status,
//           },
//         }));
//       setPayments([...txnList, ...missingTxns]);
//     } catch (_) {
//     } finally {
//       setPaymentsLoading(false);
//     }
//   }, [tenant, user?.token]);

//   const fetchFeedbacks = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const data = await apiJson(tenant, `/feedback`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setFeedbacks(Array.isArray(data) ? data : data.data || []);
//     } catch (_) {}
//   }, [tenant, user?.token]);

//   const fetchNotifications = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setNotifsLoading(true);
//     try {
//       const data = await apiJson(tenant, `/notifications`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const list = Array.isArray(data) ? data : data.data || [];
//       setNotifications(list);
//       setUnreadCount(list.filter((n) => !n.is_read).length);
//     } catch (_) {
//     } finally {
//       setNotifsLoading(false);
//     }
//   }, [tenant, user?.token]);

//   useEffect(() => {
//     if (!user?.token || !tenant) {
//       navigate(`/${tenant || ""}`);
//       return;
//     }

//     const loadData = async () => {
//       try {
//         const currencyData = await apiJson(tenant, `/currency`);
//         if (currencyData) {
//           setCurrency({
//             symbol: currencyData.symbol || "₹",
//             code: currencyData.code || "INR",
//             position: currencyData.position || "before",
//           });
//         }
//       } catch (_) {}

//       await Promise.all([
//         fetchCurrentUser(),
//         fetchBookings(),
//         fetchNotifications(),
//         fetchFeedbacks(),
//         fetchPayments(),
//         fetchInvoices(),
//       ]);
//     };

//     loadData();

//     // Check for payment confirmation from URL params
//     const params = new URLSearchParams(window.location.search);
//     const bookingId = params.get("booking");
//     const sessionId = params.get("session_id");
//     if (bookingId && sessionId && tenant && user?.token) {
//       const confirmPayment = async () => {
//         try {
//           await apiJson(tenant, `/payment/stripe/confirm`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//             body: JSON.stringify({
//               booking_id: bookingId,
//               session_id: sessionId,
//             }),
//           });
//           await Promise.all([
//             fetchBookings(),
//             fetchNotifications(),
//             fetchPayments(),
//             fetchInvoices(),
//           ]);
//           showToast(
//             "🎉 Payment confirmed! Your booking is now active.",
//             "booking",
//             5000,
//           );
//         } catch (_) {}
//       };
//       confirmPayment();
//       window.history.replaceState({}, "", window.location.pathname);
//     }

//     // Fetch unread messages count
//     if (tenant && user?.token) {
//       apiJson(tenant, `/messages/unread`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       })
//         .then((d) => setUnreadMessages(d.unread || 0))
//         .catch(() => {});
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, user?.token]);

//   const markRead = async (id) => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/notifications/${id}/read`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)),
//       );
//       setUnreadCount((prev) => Math.max(0, prev - 1));
//     } catch (_) {}
//   };

//   const markAllRead = async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/notifications/read-all`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
//       setUnreadCount(0);
//       showToast("✅ All notifications marked as read", "success", 2500);
//     } catch (_) {}
//   };

//   const handlePay = (id, milestoneId) => {
//     if (milestoneId) {
//       navigate(`/${tenant}/payment/${id}?milestone=${milestoneId}`);
//     } else {
//       navigate(`/${tenant}/payment/${id}`);
//     }
//   };

//   // ── Send Payment Link (agent → client email) ────────────────
//   // const handleSendPaymentLink = useCallback(
//   //   async (bookingId, milestoneId) => {
//   //     if (!tenant || !user?.token) return;
//   //     setSendingLinkId(bookingId);
//   //     try {
//   //       const data = await apiJson(
//   //         tenant,
//   //         `/bookings/${bookingId}/send-payment-link`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //             Accept: "application/json",
//   //             Authorization: `Bearer ${user.token}`,
//   //           },
//   //           body: JSON.stringify({
//   //             milestone_id: milestoneId || undefined,
//   //           }),
//   //         },
//   //       );
//   //       showToast(
//   //         `✉️ Payment link sent to ${data?.sent_to || "the client"}`,
//   //         "success",
//   //         3800,
//   //       );
//   //     } catch (e) {
//   //       showToast("❌ " + e.message, "error", 4000);
//   //     } finally {
//   //       setSendingLinkId(null);
//   //     }
//   //   },
//   //   [tenant, user?.token, showToast],
//   // );

//   const handleSendPaymentLink = useCallback(
//     async (bookingId, milestoneId) => {
//       if (!tenant || !user?.token) return;
//       const key = `${bookingId}-${milestoneId || "main"}`;
//       setSendingLinkKey(key);
//       try {
//         const data = await apiJson(
//           tenant,
//           `/bookings/${bookingId}/send-payment-link`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//             body: JSON.stringify({ milestone_id: milestoneId || undefined }),
//           },
//         );
//         showToast(
//           `✉️ Payment link sent to ${data?.sent_to || "the client"}`,
//           "success",
//           3800,
//         );
//       } catch (e) {
//         showToast("❌ " + e.message, "error", 4000);
//       } finally {
//         setSendingLinkKey(null);
//       }
//     },
//     [tenant, user?.token, showToast],
//   );

//   // ── Record Manual Payment (buyer paying manually, or agent recording a
//   //    payment collected offline). Always pending admin approval. ────────
//   const submitManualPayment = useCallback(
//     async (bookingId, milestoneId, payload) => {
//       if (!tenant || !user?.token) return false;
//       try {
//         await apiJson(tenant, `/bookings/${bookingId}/manual-payment`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `Bearer ${user.token}`,
//           },
//           body: JSON.stringify({
//             ...payload,
//             milestone_id: milestoneId || undefined,
//           }),
//         });
//         showToast(
//           "✅ Payment recorded — awaiting admin approval",
//           "success",
//           4000,
//         );
//         return true;
//       } catch (e) {
//         showToast("❌ " + e.message, "error", 4000);
//         return false;
//       }
//     },
//     [tenant, user?.token, showToast],
//   );

//   const handleLogout = () => {
//     showToast("👋 Logged out successfully", "info", 2500);
//     setTimeout(() => {
//       dispatch(clearUser());
//       navigate(`/${tenant}`);
//     }, 600);
//   };

//   const handleSaved = (updated) => dispatch(setUser(updated));

//   const handleCancel = async (bookingId) => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/bookings/${bookingId}`, {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setBookings((prev) =>
//         prev.map((b) =>
//           b.id === bookingId ? { ...b, booking_status: "cancelled" } : b,
//         ),
//       );
//       showToast("✅ Booking cancelled successfully", "success", 3500);
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//   };

//   const confirmed = bookings.filter(
//     (b) => b.booking_status === "confirmed",
//   ).length;
//   const pending = bookings.filter((b) => b.booking_status === "pending").length;

//   const totalInvested = bookings
//     .filter((b) => b.booking_status === "confirmed")
//     .reduce((s, b) => {
//       const msData = milestoneMap[b.id];
//       if (msData?.milestones?.length) {
//         const paidSum = msData.milestones
//           .filter((m) => m.status === "paid")
//           .reduce((ms, m) => ms + msAmount(m), 0);
//         if (paidSum > 0) return s + paidSum;
//         return (
//           s +
//           parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
//         );
//       }
//       return (
//         s + parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
//       );
//     }, 0);

//   const tabs = [
//     {
//       id: "bookings",
//       label: isAgent ? "Client Bookings" : "My Bookings",
//       count: bookings.length,
//     },
//     { id: "wishlist", label: "Wishlist", count: wishlist.length },
//     { id: "payments", label: "Payments", count: 0 },
//     { id: "invoices", label: "Invoices", count: invoiceCount },
//     { id: "notifications", label: "Notifications", count: unreadCount },
//     { id: "feedback", label: "Feedback", count: 0 },
//     { id: "messages", label: "Messages", count: unreadMessages },
//     { id: "profile", label: "My Profile", count: 0 },
//   ];

//   const logoUrl =
//     settings?.app_logo_dark_url || settings?.app_logo_light_url || null;
//   const appName = settings?.app_name || "Dashboard";

//   return (
//     <div className="dashboard">
//       {/* Header */}
//       <div className="dashboard-header">
//         <div className="dashboard-header-left">
//           <button onClick={() => navigate(-1)} className="dashboard-back-btn">
//             ← Back
//           </button>
//           {logoUrl ? (
//             <img src={logoUrl} alt={appName} className="dashboard-logo" />
//           ) : (
//             <span className="dashboard-logo-text">
//               {isAgent ? `${roleLabel(user.role)} Dashboard` : "My Dashboard"}
//             </span>
//           )}
//         </div>

//         <div className="dashboard-header-right">
//           <div className="dashboard-user-info">
//             <div className="dashboard-user-name">{user?.name}</div>
//             <div className="dashboard-user-role">
//               {isAgent
//                 ? `${roleLabel(user.role)}${user?.broker_company ? " · " + user.broker_company : ""}`
//                 : "Buyer"}
//             </div>
//           </div>
//           <div
//             className="dashboard-avatar"
//             style={{
//               background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//               boxShadow: `0 2px 8px ${primaryColor}30`,
//             }}
//           >
//             {user?.name?.[0]?.toUpperCase()}
//           </div>
//           <ElegantButton variant="secondary" onClick={handleLogout} size="sm">
//             Logout
//           </ElegantButton>
//           <button
//             onClick={() => setActiveTab("notifications")}
//             className="dashboard-notif-btn"
//           >
//             🔔
//             {unreadCount > 0 && (
//               <span className="dashboard-notif-badge">
//                 {unreadCount > 9 ? "9+" : unreadCount}
//               </span>
//             )}
//           </button>
//         </div>
//       </div>

//       <div className="dashboard-container">
//         {/* Welcome */}
//         <div className="dashboard-welcome">
//           <div className="dashboard-welcome-title">
//             Welcome back, {user?.name?.split(" ")[0]}
//           </div>
//           <div className="dashboard-welcome-subtitle">
//             {isAgent
//               ? "Manage your client bookings and track your commissions."
//               : "Track your property bookings and payments."}
//           </div>
//         </div>

//         {/* Stat cards */}
//         <div className="dashboard-stats">
//           <StatCard
//             icon="📋"
//             label="Total Bookings"
//             value={bookings.length}
//             color={primaryColor}
//           />
//           <StatCard
//             icon="✓"
//             label="Confirmed"
//             value={confirmed}
//             color="#16a34a"
//           />
//           <StatCard
//             icon="⏳"
//             label="Pending Payment"
//             value={pending}
//             color="#d97706"
//           />
//           {!isAgent && (
//             <StatCard
//               icon="💰"
//               label="Amount Invested"
//               value={fmtExact(totalInvested)}
//               color={primaryColor}
//             />
//           )}
//         </div>

//         {isAgent && bookings.length > 0 && (
//           <AgentStats
//             bookings={bookings}
//             fmtExact={fmtExact}
//             primaryColor={primaryColor}
//           />
//         )}

//         {/* Tabs */}
//         <div className="dashboard-tabs">
//           {tabs.map((t) => (
//             <TabButton
//               key={t.id}
//               active={activeTab === t.id}
//               onClick={() => setActiveTab(t.id)}
//               label={t.label}
//               count={t.count}
//               primaryColor={primaryColor}
//             />
//           ))}
//         </div>

//         {/* Tab Content */}
//         {activeTab === "bookings" && (
//           <div>
//             {loading && (
//               <div className="dashboard-loading">
//                 <div className="dashboard-loading-icon">⏳</div>
//                 <div className="dashboard-loading-text">
//                   Loading bookings...
//                 </div>
//               </div>
//             )}
//             {error && (
//               <div className="dashboard-error">
//                 <span>⚠ {error}</span>
//                 <ElegantButton
//                   variant="secondary"
//                   onClick={fetchBookings}
//                   size="sm"
//                 >
//                   Retry
//                 </ElegantButton>
//               </div>
//             )}
//             {!loading && Object.keys(milestoneMap).length > 0 && (
//               <DuesBanner
//                 milestoneMap={milestoneMap}
//                 fmtExact={fmtExact}
//                 onNavigate={(path) => navigate(`/${tenant}${path}`)}
//                 primaryColor={primaryColor}
//                 isAgent={isAgent}
//                 onSendLink={handleSendPaymentLink}
//                 onManualSubmit={submitManualPayment}
//                 sendingLinkId={sendingLinkId}
//               />
//             )}
//             {!loading && !error && bookings.length === 0 && (
//               <div className="dashboard-empty">
//                 <div className="dashboard-empty-icon">🏠</div>
//                 <div className="dashboard-empty-title">
//                   {isAgent ? "No client bookings yet" : "No bookings yet"}
//                 </div>
//                 <div className="dashboard-empty-subtitle">
//                   {isAgent
//                     ? "Book a unit for your clients from the unit page."
//                     : "Browse available units to make your first booking."}
//                 </div>
//                 <ElegantButton onClick={() => navigate(`/${tenant}`)}>
//                   Browse Units →
//                 </ElegantButton>
//               </div>
//             )}
//             <div className="dashboard-bookings">
//               {!loading &&
//                 bookings.map((b) => (
//                   <BookingCard
//                     key={b.id}
//                     booking={b}
//                     onPay={handlePay}
//                     onCancel={handleCancel}
//                     onSendPaymentLink={handleSendPaymentLink}
//                     onManualSubmit={submitManualPayment}
//                     sendingLinkId={sendingLinkId}
//                     isAgent={isAgent}
//                     fmtExact={fmtExact}
//                     token={user?.token}
//                     primaryColor={primaryColor}
//                     milestoneMap={milestoneMap}
//                     tenant={tenant}
//                   />
//                 ))}
//             </div>
//           </div>
//         )}

//         {activeTab === "wishlist" && (
//           <WishlistTab
//             wishlist={wishlist}
//             wishedIds={wishedIds}
//             onToggle={handleWishlistToggle}
//             loading={wishLoading}
//             token={user?.token}
//             onNavigate={(path) => navigate(`/${tenant}${path}`)}
//             fmt={fmt}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "payments" && (
//           <PaymentsTab
//             payments={payments}
//             loading={paymentsLoading}
//             fmt={fmt}
//             fmtExact={fmtExact}
//             user={user}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "invoices" && (
//           <InvoicesTab user={user} fmt={fmt} tenant={tenant} />
//         )}
//         {activeTab === "notifications" && (
//           <NotificationsTab
//             notifications={notifications}
//             loading={notifsLoading}
//             unreadCount={unreadCount}
//             onMarkRead={markRead}
//             onMarkAllRead={markAllRead}
//             onNavigate={(path) => navigate(`/${tenant}${path}`)}
//             onSwitchToBookings={switchToBookings}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "feedback" && (
//           <FeedbackTab
//             feedbacks={feedbacks}
//             bookings={bookings}
//             token={user?.token}
//             showToast={showToast}
//             onSubmitted={(newFb) => setFeedbacks((prev) => [newFb, ...prev])}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "messages" && (
//           <MessagesTab user={user} tenant={tenant} />
//         )}
//         {activeTab === "profile" && (
//           <ProfilePanel
//             user={user}
//             onSaved={handleSaved}
//             showToast={showToast}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         )}
//       </div>
//     </div>
//   );
// }

// UserDashboard.jsx
// import { useEffect, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// // import { useSelector, useDispatch } from "react-redux";
// // import { selectUser, setUser, clearUser } from "../redux/authSlice";

// import { useAuth } from "../context/AuthContext";

// import { useToast } from "../context/ToastContext";
// import { useSettings } from "../context/SettingsContext";
// import { useWishlist } from "../hooks/useWishlist";
// import { apiJson } from "../api/apiClient";
// import { apiUrl } from "../apiUrl";
// import WishlistTab from "./WishlistTab";
// import MessagesTab from "./MessagesTab";
// import InvoicesTab from "./InvoicesTab";
// import PaymentsTab from "./PaymentsTab";
// import "../styles/UserDashboard.css";

// const API_BASE = `${apiUrl}/api`;

// // ── Formatters ─────────────────────────────────────────────
// const makeFmt =
//   (symbol = "₹", position = "before") =>
//   (n) => {
//     if (n == null) return "—";
//     const num = new Intl.NumberFormat("en-IN", {
//       maximumFractionDigits: 0,
//     }).format(n);
//     return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
//   };

// const makeFmtExact =
//   (symbol = "₹", position = "before") =>
//   (n) => {
//     if (n == null) return "—";
//     const num = new Intl.NumberFormat("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }).format(n);
//     return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
//   };

// const STATUS_CFG = {
//   confirmed: {
//     color: "#16a34a",
//     bg: "rgba(22,163,74,0.10)",
//     label: "Confirmed",
//   },
//   pending: {
//     color: "#d97706",
//     bg: "rgba(217,119,6,0.10)",
//     label: "Pending Payment",
//   },
//   cancelled: {
//     color: "#dc2626",
//     bg: "rgba(220,38,38,0.10)",
//     label: "Cancelled",
//   },
//   refunded: {
//     color: "#94a3b8",
//     bg: "rgba(148,163,184,0.10)",
//     label: "Refunded",
//   },
// };

// const COMM_CFG = {
//   pending: { color: "#d97706", label: "Pending Approval" },
//   approved: { color: "#2563eb", label: "Approved" },
//   paid: { color: "#16a34a", label: "Paid" },
//   rejected: { color: "#dc2626", label: "Rejected" },
//   refunded: { color: "#94a3b8", label: "Refunded" },
// };

// const msAmount = (m) => parseFloat(m.total_with_tax ?? m.amount ?? 0);

// // ── Role label helper ───────────────────────────────────────
// const roleLabel = (role) =>
//   role === "broker" ? "Broker" : role === "sales" ? "Sales Agent" : "Buyer";

// // ── Elegant Card Component ─────────────────────────────────
// const ElegantCard = ({ children, noPadding, hover, onClick, className }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <div
//       className={`elegant-card ${hover ? "elegant-card-hover" : ""} ${noPadding ? "elegant-card-no-padding" : "elegant-card-padding"} ${onClick ? "elegant-card-clickable" : ""} ${className || ""}`}
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       {children}
//     </div>
//   );
// };

// // ── Elegant Button ─────────────────────────────────────────
// const ElegantButton = ({
//   children,
//   variant = "primary",
//   onClick,
//   disabled,
//   loading,
//   size = "md",
// }) => {
//   const sizeClass = `elegant-btn-${size}`;
//   const variantClass = `elegant-btn-${variant}`;

//   return (
//     <button
//       className={`elegant-btn ${sizeClass} ${variantClass}`}
//       onClick={onClick}
//       disabled={disabled || loading}
//     >
//       {loading && <span className="elegant-btn-spinner"></span>}
//       {children}
//     </button>
//   );
// };

// // ── Elegant Stat Card ──────────────────────────────────────
// const StatCard = ({ icon, label, value, color }) => (
//   <div className="stat-card">
//     <div className="stat-card-content">
//       <div
//         className="stat-card-icon"
//         style={{
//           background: `linear-gradient(135deg, ${color}15, ${color}08)`,
//         }}
//       >
//         {icon}
//       </div>
//       <div>
//         <div className="stat-card-value" style={{ color }}>
//           {value}
//         </div>
//         <div className="stat-card-label">{label}</div>
//       </div>
//     </div>
//   </div>
// );

// // ── Tab Button ─────────────────────────────────────────────
// const TabButton = ({ active, onClick, label, count, primaryColor }) => (
//   <button
//     onClick={onClick}
//     className={`dashboard-tab ${active ? "dashboard-tab-active" : "dashboard-tab-inactive"}`}
//   >
//     {label}
//     {count > 0 && (
//       <span
//         className={`dashboard-tab-count ${active ? "dashboard-tab-count-active" : "dashboard-tab-count-inactive"}`}
//       >
//         {count}
//       </span>
//     )}
//   </button>
// );

// // ── Milestone Row Component ─────────────────────────────────
// const MilestoneRow = ({
//   label,
//   percentage,
//   amount,
//   baseAmount,
//   taxAmount,
//   extraFees,
//   taxLabel,
//   taxRate,
//   hasTax,
//   isPaid,
//   isDue,
//   isOverdue,
//   isWaived,
//   isRefunded,
//   dueDate,
//   paidAt,
//   index,
//   fmtExact,
//   primaryColor,
// }) => {
//   const [showTax, setShowTax] = useState(false);

//   let textColor = "var(--text-muted)";
//   let dotBackground = "transparent";
//   let dotBorder = "var(--card-border)";
//   let dotColor = "var(--text-muted)";

//   if (isRefunded) {
//     textColor = "var(--text-muted)";
//     dotBackground = "transparent";
//     dotBorder = "#94a3b8";
//     dotColor = "#94a3b8";
//   } else if (isPaid) {
//     textColor = primaryColor;
//     dotBackground = primaryColor;
//     dotBorder = primaryColor;
//     dotColor = "#fff";
//   } else if (isOverdue) {
//     textColor = "#dc2626";
//     dotBackground = "transparent";
//     dotBorder = "#dc2626";
//     dotColor = "#dc2626";
//   } else if (isDue) {
//     textColor = "var(--text-dark)";
//     dotBackground = "transparent";
//     dotBorder = primaryColor;
//     dotColor = primaryColor;
//   }

//   const dotContent = isRefunded
//     ? "↺"
//     : isPaid
//       ? "✓"
//       : isWaived
//         ? "–"
//         : index + 1;

//   return (
//     <div className="milestone-row">
//       <div
//         className="milestone-dot"
//         style={{
//           background: dotBackground,
//           border: `2px solid ${dotBorder}`,
//           color: dotColor,
//         }}
//       >
//         {dotContent}
//       </div>
//       <div
//         className="milestone-content"
//         style={{
//           background: isPaid
//             ? `${primaryColor}06`
//             : isRefunded
//               ? "rgba(148,163,184,0.06)"
//               : "var(--page-bg)",
//           border: `1px solid ${isPaid ? primaryColor + "20" : isRefunded ? "#94a3b820" : isOverdue ? "#dc262620" : isDue ? primaryColor + "18" : "var(--card-border)"}`,
//         }}
//       >
//         <div className="milestone-header">
//           <div className="milestone-info">
//             <div className="milestone-label" style={{ color: textColor }}>
//               {label}
//             </div>
//             <div className="milestone-meta">
//               {percentage ? `${percentage}% of total` : ""}
//               {dueDate && !isPaid && !isRefunded && (
//                 <span style={{ marginLeft: percentage ? 8 : 0 }}>
//                   Due: {dueDate}
//                   {isOverdue && (
//                     <span
//                       style={{
//                         color: "#dc2626",
//                         fontWeight: 700,
//                         marginLeft: 6,
//                       }}
//                     >
//                       ⚠ Overdue
//                     </span>
//                   )}
//                 </span>
//               )}
//               {isPaid && paidAt && (
//                 <span style={{ color: "#16a34a", marginLeft: 6 }}>
//                   ✓ Paid {paidAt}
//                 </span>
//               )}
//               {isRefunded && (
//                 <span style={{ color: "#94a3b8", marginLeft: 6 }}>
//                   ↺ Refunded
//                 </span>
//               )}
//               {isDue && !isOverdue && !isRefunded && (
//                 <span style={{ color: "#d97706", marginLeft: 6 }}>
//                   ← Due now
//                 </span>
//               )}
//               {isWaived && (
//                 <span style={{ color: "var(--text-muted)", marginLeft: 6 }}>
//                   Waived
//                 </span>
//               )}
//             </div>
//           </div>
//           <div className="milestone-amount">
//             <div
//               className="milestone-amount-value"
//               style={{ color: textColor }}
//             >
//               {isRefunded ? `−${fmtExact(amount)}` : fmtExact(amount)}
//             </div>
//             {hasTax && !isRefunded && (
//               <button
//                 type="button"
//                 className="milestone-tax-btn"
//                 onClick={() => setShowTax((s) => !s)}
//               >
//                 {taxLabel || "Tax"}
//                 {taxRate > 0 ? ` ${taxRate}%` : ""} {showTax ? "▲" : "▼"}
//               </button>
//             )}
//           </div>
//         </div>

//         {hasTax && showTax && !isRefunded && (
//           <div className="milestone-tax-details">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: "var(--text-muted)",
//                 marginBottom: 4,
//               }}
//             >
//               <span>Base amount</span>
//               <span>{fmtExact(baseAmount)}</span>
//             </div>
//             {(extraFees || 0) > 0 && (
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   color: "var(--text-muted)",
//                   marginBottom: 4,
//                 }}
//               >
//                 <span>Additional fees</span>
//                 <span>{fmtExact(extraFees)}</span>
//               </div>
//             )}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: "#d97706",
//               }}
//             >
//               <span>
//                 {taxLabel || "Tax"}
//                 {taxRate > 0 ? ` (${taxRate}%)` : ""}
//               </span>
//               <span>{fmtExact(taxAmount)}</span>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: primaryColor,
//                 fontWeight: 700,
//                 borderTop: `1px solid ${primaryColor}20`,
//                 paddingTop: 8,
//                 marginTop: 8,
//               }}
//             >
//               <span>Total payable</span>
//               <span>{fmtExact(amount)}</span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // ── Milestone Tracker ───────────────────────────────────────
// const MilestoneTracker = ({
//   bookingId,
//   token,
//   fmtExact,
//   booking,
//   primaryColor,
//   tenant,
// }) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const isBookingRefunded = booking?.booking_status === "refunded";

//   useEffect(() => {
//     if (!bookingId || !token || !tenant) return;

//     const fetchMilestones = async () => {
//       try {
//         const result = await apiJson(
//           tenant,
//           `/bookings/${bookingId}/milestones`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//             },
//           },
//         );
//         setData(result);
//       } catch (err) {
//         console.error("Error fetching milestones:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMilestones();
//   }, [bookingId, token, tenant]);

//   // Show refunded message if booking is refunded
//   if (isBookingRefunded) {
//     return (
//       <div className="milestone-tracker">
//         <div
//           className="refunded-banner"
//           style={{
//             background: "rgba(148,163,184,0.08)",
//             border: "1px solid rgba(148,163,184,0.2)",
//             borderRadius: "12px",
//             padding: "16px",
//             textAlign: "center",
//           }}
//         >
//           <div style={{ fontSize: "32px", marginBottom: "8px" }}>↺</div>
//           <div
//             style={{
//               fontSize: "14px",
//               fontWeight: "700",
//               color: "#64748b",
//               marginBottom: "4px",
//             }}
//           >
//             Booking Refunded
//           </div>
//           <div style={{ fontSize: "12px", color: "var(--text-muted)" }}>
//             This booking has been cancelled and fully refunded.
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!loading && (!data || !data.milestones?.length)) {
//     const plan = booking?.payment_plan;
//     const price = parseFloat(booking?.price || 0);
//     if (!plan?.milestones?.length) {
//       return (
//         <div className="milestone-tracker">
//           <div
//             className="booking-card-expanded"
//             style={{
//               color: "var(--text-muted)",
//               fontSize: 13,
//               padding: "12px 16px",
//               background: "var(--page-bg)",
//               borderRadius: "14px",
//             }}
//           >
//             Full payment — no instalment plan selected
//           </div>
//         </div>
//       );
//     }
//     const isConfirmed = booking.booking_status === "confirmed";
//     const grandTotal = parseFloat(booking.total_amount || price);
//     return (
//       <div className="milestone-tracker">
//         <div className="booking-card-expanded">
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               fontWeight: 700,
//               letterSpacing: "0.8px",
//               textTransform: "uppercase",
//               marginBottom: 12,
//             }}
//           >
//             Payment Schedule — {plan.name}
//           </div>
//           {plan.milestones.map((m, i) => {
//             const amt = m.percentage
//               ? (grandTotal * m.percentage) / 100
//               : m.fixed_amount;
//             const isPaid = i === 0 && isConfirmed;
//             const isDue = i === 0 && !isConfirmed;
//             return (
//               <MilestoneRow
//                 key={i}
//                 label={m.label}
//                 percentage={m.percentage}
//                 amount={amt}
//                 isPaid={isPaid}
//                 isDue={isDue}
//                 isRefunded={false}
//                 index={i}
//                 fmtExact={fmtExact}
//                 primaryColor={primaryColor}
//               />
//             );
//           })}
//         </div>
//       </div>
//     );
//   }

//   if (loading)
//     return (
//       <div className="milestone-tracker">
//         <div
//           className="booking-card-expanded"
//           style={{ color: "var(--text-muted)", fontSize: 12, padding: 12 }}
//         >
//           Loading payment schedule...
//         </div>
//       </div>
//     );

//   const { milestones } = data;
//   const totalAmount = milestones.reduce((s, m) => s + msAmount(m), 0);
//   const paidAmount = milestones
//     .filter((m) => m.status === "paid")
//     .reduce((s, m) => s + msAmount(m), 0);
//   const refundedAmount = milestones
//     .filter((m) => m.status === "refunded")
//     .reduce((s, m) => s + msAmount(m), 0);
//   const balanceDue = totalAmount - paidAmount - refundedAmount;
//   const pct =
//     totalAmount > 0
//       ? Math.round(((paidAmount + refundedAmount) / totalAmount) * 100)
//       : 0;
//   const isFullyRefunded = refundedAmount > 0 && refundedAmount >= totalAmount;

//   return (
//     <div className="milestone-tracker">
//       <div className="milestone-progress">
//         <div className="milestone-progress-header">
//           <span>Payment Progress (incl. taxes)</span>
//           <span className="milestone-progress-percent">{pct}% complete</span>
//         </div>
//         <div className="milestone-progress-bar">
//           <div
//             className="milestone-progress-fill"
//             style={{
//               width: `${pct}%`,
//               background: isFullyRefunded ? "#94a3b8" : primaryColor,
//             }}
//           />
//         </div>
//         <div className="milestone-progress-stats">
//           <span className="milestone-progress-paid">
//             Paid: {fmtExact(paidAmount)}
//           </span>
//           {refundedAmount > 0 && (
//             <span
//               className="milestone-progress-refunded"
//               style={{ color: "#94a3b8" }}
//             >
//               Refunded: {fmtExact(refundedAmount)}
//             </span>
//           )}
//           <span
//             className="milestone-progress-balance"
//             style={{
//               color:
//                 balanceDue > 0
//                   ? "#d97706"
//                   : isFullyRefunded
//                     ? "#94a3b8"
//                     : "#16a34a",
//             }}
//           >
//             {balanceDue > 0
//               ? `Balance: ${fmtExact(balanceDue)}`
//               : isFullyRefunded
//                 ? "✓ Fully Refunded"
//                 : "✓ Fully Paid"}
//           </span>
//         </div>
//       </div>

//       {milestones.map((m, i) => {
//         const isPaid = m.status === "paid";
//         const isOverdue = m.status === "overdue";
//         const isWaived = m.status === "waived";
//         const isRefunded = m.status === "refunded";
//         const isDue =
//           !isPaid &&
//           !isWaived &&
//           !isRefunded &&
//           i ===
//             milestones.findIndex(
//               (x) => x.status === "pending" || x.status === "overdue",
//             );
//         return (
//           <MilestoneRow
//             key={m.id}
//             label={m.label}
//             percentage={m.percentage}
//             amount={msAmount(m)}
//             baseAmount={m.amount}
//             taxAmount={m.tax_amount}
//             extraFees={m.extra_fees}
//             taxLabel={m.tax_label}
//             taxRate={m.tax_rate}
//             hasTax={(m.tax_amount || 0) > 0}
//             isPaid={isPaid}
//             isDue={isDue}
//             isOverdue={isOverdue}
//             isWaived={isWaived}
//             isRefunded={isRefunded}
//             dueDate={m.due_date}
//             paidAt={m.paid_at}
//             index={i}
//             fmtExact={fmtExact}
//             primaryColor={primaryColor}
//           />
//         );
//       })}
//     </div>
//   );
// };

// // ── Inline Manual Payment Form (used in DuesBanner + BookingCard) ──────
// // Always submits as PENDING; admin approval required before it counts as paid.
// const ManualPaymentInline = ({
//   amountDue,
//   fmtExact,
//   submitting,
//   onSubmit,
//   onCancel,
// }) => {
//   const [mode, setMode] = useState("cash");
//   const [reference, setReference] = useState("");
//   const [notes, setNotes] = useState("");

//   return (
//     <div
//       style={{
//         marginTop: 10,
//         padding: 12,
//         borderRadius: 12,
//         background: "var(--page-bg)",
//         border: "1px solid var(--card-border)",
//       }}
//     >
//       <div
//         style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}
//       >
//         <select
//           value={mode}
//           onChange={(e) => setMode(e.target.value)}
//           style={{
//             flex: 1,
//             minWidth: 130,
//             padding: 8,
//             borderRadius: 8,
//             border: "1px solid var(--card-border)",
//             background: "var(--card-bg)",
//             color: "var(--text-dark)",
//           }}
//         >
//           <option value="cash">💵 Cash</option>
//           <option value="cheque">📄 Cheque</option>
//           <option value="bank_transfer">🏦 Bank Transfer</option>
//         </select>
//         <input
//           type="text"
//           placeholder="Reference number (optional)"
//           value={reference}
//           onChange={(e) => setReference(e.target.value)}
//           style={{
//             flex: 1,
//             minWidth: 160,
//             padding: 8,
//             borderRadius: 8,
//             border: "1px solid var(--card-border)",
//             background: "var(--card-bg)",
//             color: "var(--text-dark)",
//           }}
//         />
//       </div>
//       <textarea
//         placeholder="Notes (optional)"
//         value={notes}
//         onChange={(e) => setNotes(e.target.value)}
//         rows={2}
//         style={{
//           width: "100%",
//           padding: 8,
//           borderRadius: 8,
//           border: "1px solid var(--card-border)",
//           background: "var(--card-bg)",
//           color: "var(--text-dark)",
//           marginBottom: 8,
//           resize: "vertical",
//           boxSizing: "border-box",
//         }}
//       />
//       <div
//         style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 10 }}
//       >
//         Amount: <strong>{fmtExact(amountDue)}</strong> · Submitted for admin
//         approval — won't be marked as paid immediately.
//       </div>
//       <div style={{ display: "flex", gap: 8 }}>
//         <ElegantButton
//           size="sm"
//           onClick={() =>
//             onSubmit({ payment_mode: mode, reference_number: reference, notes })
//           }
//           loading={submitting}
//         >
//           Submit for Approval
//         </ElegantButton>
//         <ElegantButton
//           size="sm"
//           variant="ghost"
//           onClick={onCancel}
//           disabled={submitting}
//         >
//           Cancel
//         </ElegantButton>
//       </div>
//     </div>
//   );
// };

// // ── Individual Due Item — Send Link / Pay Online / Record Manual ───────
// const DueItemRow = ({
//   due,
//   fmtExact,
//   onNavigate,
//   isAgent,
//   onSendLink,
//   onManualSubmit,
//   sendingLinkKey,
//   accentColor,
// }) => {
//   const [showManual, setShowManual] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   const isSendingThis = sendingLinkKey === `${due.bookingId}-${due.id}`;

//   const handleManualSubmit = async (payload) => {
//     setSubmitting(true);
//     const ok = await onManualSubmit(due.bookingId, due.id, {
//       ...payload,
//       amount: due.displayAmount,
//     });
//     setSubmitting(false);
//     if (ok) {
//       setSubmitted(true);
//       setShowManual(false);
//     }
//   };

//   return (
//     <div
//       className="dues-item"
//       style={{
//         flexDirection: "column",
//         alignItems: "stretch",
//         borderColor: `${accentColor}30`,
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//         }}
//       >
//         <div>
//           <div className="dues-item-title">{due.label}</div>
//           <div className="dues-item-details">
//             {due.due_date ? `Due: ${due.due_date}` : "No due date set"}
//             {due.status === "overdue" && (
//               <span className="dues-item-overdue">⚠ Overdue</span>
//             )}
//             <span style={{ marginLeft: 8 }}>· Booking #{due.bookingId}</span>
//             {(due.tax_amount || 0) > 0 && (
//               <span className="dues-item-tax">incl. tax</span>
//             )}
//           </div>
//         </div>
//         <div className="dues-item-amount" style={{ color: accentColor }}>
//           <div style={{ fontSize: 18, fontWeight: 800 }}>
//             {fmtExact(due.displayAmount)}
//           </div>
//         </div>
//       </div>

//       {submitted ? (
//         <div
//           style={{
//             marginTop: 10,
//             padding: "8px 12px",
//             borderRadius: 10,
//             background: "rgba(34,197,94,0.08)",
//             border: "1px solid rgba(34,197,94,0.25)",
//             color: "#16a34a",
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           ✓ Submitted — awaiting admin confirmation.
//         </div>
//       ) : (
//         <>
//           <div
//             style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}
//           >
//             {!isAgent && (
//               <ElegantButton
//                 size="sm"
//                 onClick={() =>
//                   onNavigate(`/payment/${due.bookingId}?milestone=${due.id}`)
//                 }
//               >
//                 💳 Pay Online
//               </ElegantButton>
//             )}
//             {isAgent && (
//               <ElegantButton
//                 size="sm"
//                 onClick={() => onSendLink(due.bookingId, due.id)}
//                 loading={isSendingThis}
//               >
//                 ✉️ Send Payment Link
//               </ElegantButton>
//             )}
//             <ElegantButton
//               size="sm"
//               variant="secondary"
//               onClick={() => setShowManual((s) => !s)}
//             >
//               🏦 {showManual ? "Cancel" : "Record Manual Payment"}
//             </ElegantButton>
//           </div>

//           {showManual && (
//             <ManualPaymentInline
//               amountDue={due.displayAmount}
//               fmtExact={fmtExact}
//               submitting={submitting}
//               onSubmit={handleManualSubmit}
//               onCancel={() => setShowManual(false)}
//             />
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// // ── Dues Banner ─────────────────────────────────────────────
// const DuesBanner = ({
//   milestoneMap,
//   fmtExact,
//   onNavigate,
//   primaryColor,
//   isAgent,
//   onSendLink,
//   onManualSubmit,
//   sendingLinkKey,
// }) => {
//   const dues = Object.entries(milestoneMap)
//     .flatMap(([bookingId, data]) =>
//       (data.milestones || [])
//         .filter((m) => m.status === "pending" || m.status === "overdue")
//         .map((m) => ({ ...m, bookingId, displayAmount: msAmount(m) })),
//     )
//     .sort((a, b) => {
//       if (!a.due_date && !b.due_date) return 0;
//       if (!a.due_date) return 1;
//       if (!b.due_date) return -1;
//       return new Date(a.due_date) - new Date(b.due_date);
//     });

//   if (!dues.length) return null;
//   const overdueCount = dues.filter((d) => d.status === "overdue").length;
//   const accentColor = overdueCount > 0 ? "#dc2626" : "#d97706";

//   return (
//     <div className="dues-banner">
//       <ElegantCard hover>
//         <div className="dues-banner-header">
//           <div className="dues-banner-title" style={{ color: accentColor }}>
//             <span style={{ fontSize: 20 }}>⏰</span>
//             Upcoming Payments
//             {overdueCount > 0 && (
//               <span className="dues-banner-badge">{overdueCount} overdue</span>
//             )}
//           </div>
//           <div className="dues-banner-count">
//             {dues.length} payment{dues.length > 1 ? "s" : ""} remaining
//           </div>
//         </div>
//         <div className="dues-list">
//           {dues.map((d, i) => (
//             <DueItemRow
//               key={i}
//               due={d}
//               fmtExact={fmtExact}
//               onNavigate={onNavigate}
//               isAgent={isAgent}
//               onSendLink={onSendLink}
//               onManualSubmit={onManualSubmit}
//               sendingLinkKey={sendingLinkKey}
//               accentColor={d.status === "overdue" ? "#dc2626" : "#d97706"}
//             />
//           ))}
//         </div>
//       </ElegantCard>
//     </div>
//   );
// };

// // ── Booking Card ────────────────────────────────────────────
// const BookingCard = ({
//   booking,
//   onPay,
//   onCancel,
//   onSendPaymentLink,
//   onManualSubmit,
//   sendingLinkKey,
//   isAgent,
//   fmtExact,
//   token,
//   primaryColor,
//   milestoneMap,
//   tenant,
// }) => {
//   const [expanded, setExpanded] = useState(false);
//   const [cancelling, setCancelling] = useState(false);
//   const [confirmCancel, setConfirmCancel] = useState(false);

//   const [showManualForm, setShowManualForm] = useState(false);
//   const [manualSubmitting, setManualSubmitting] = useState(false);
//   const [manualSubmitted, setManualSubmitted] = useState(false);

//   const isRefunded = booking.booking_status === "refunded";
//   const cfg = STATUS_CFG[booking.booking_status] || STATUS_CFG.pending;
//   const plan = booking.payment_plan;
//   const isConfirmed = booking.booking_status === "confirmed";
//   const isPending = booking.booking_status === "pending";

//   const paidMilestones = (booking.milestones || []).filter(
//     (m) => m.status === "paid",
//   );
//   const refundedMilestones = (booking.milestones || []).filter(
//     (m) => m.status === "refunded",
//   );
//   const paidTotal = paidMilestones.reduce((sum, m) => sum + msAmount(m), 0);
//   const refundedTotal = refundedMilestones.reduce(
//     (sum, m) => sum + msAmount(m),
//     0,
//   );
//   const allMilestones = booking.milestones || [];
//   const totalFromMs = allMilestones.reduce((sum, m) => sum + msAmount(m), 0);
//   const grandTotal = parseFloat(booking.total_amount || 0) || totalFromMs;

//   const displayAmt = (() => {
//     if (isRefunded) return refundedTotal;
//     if (isConfirmed && paidTotal > 0) return paidTotal;
//     if (isConfirmed) return grandTotal;
//     const dp = parseFloat(booking.down_payment_amount || 0);
//     if (dp > 0) return dp;
//     return grandTotal;
//   })();

//   const amountLabel = isRefunded
//     ? "Refunded Amount"
//     : isPending
//       ? "Down Payment Due"
//       : isConfirmed && paidTotal > 0
//         ? `Paid (${paidMilestones.length} milestone${paidMilestones.length > 1 ? "s" : ""})`
//         : isConfirmed
//           ? "Total Amount"
//           : "Amount";

//   // Resolve which milestone / amount a manual payment (or a send-payment-link
//   // click) recorded here applies to. Defined before use below.
//   const getManualTarget = () => {
//     const msData = milestoneMap?.[booking.id];
//     const firstPending = msData?.milestones?.find(
//       (m) => m.status === "pending" || m.status === "overdue",
//     );
//     const amount = firstPending
//       ? msAmount(firstPending)
//       : parseFloat(booking.down_payment_amount || booking.total_amount || 0);
//     return { milestoneId: firstPending?.id || null, amount };
//   };

//   // Compute the composite key AFTER getManualTarget exists, so we can
//   // correctly scope the "sending" spinner to this specific booking+milestone.
//   const { milestoneId: resolvedMilestoneId } = getManualTarget();
//   const isSendingThisLink =
//     sendingLinkKey === `${booking.id}-${resolvedMilestoneId || "main"}`;

//   return (
//     <ElegantCard hover>
//       <div className="booking-card-header">
//         <div className="booking-card-info">
//           <div className="booking-card-title">
//             <span className="booking-card-unit">
//               Unit {booking.plot_number}
//             </span>
//             <span
//               className="booking-card-status"
//               style={{
//                 background: cfg.bg,
//                 color: cfg.color,
//                 border: `1px solid ${cfg.color}33`,
//               }}
//             >
//               {cfg.label}
//             </span>
//           </div>
//           <div className="booking-card-details">
//             <span>{booking.plot_type}</span>
//             {booking.area && <span>· {booking.area} sqft</span>}
//             {booking.direction && <span>· {booking.direction}</span>}
//           </div>
//           {isAgent && (booking.client_name || booking.client_phone) && (
//             <div
//               className="booking-card-client"
//               style={{
//                 background: `${primaryColor}06`,
//                 border: `1px solid ${primaryColor}18`,
//               }}
//             >
//               <span style={{ color: "var(--text-muted)" }}>Client: </span>
//               <span style={{ color: primaryColor, fontWeight: 600 }}>
//                 {booking.client_name}
//               </span>
//               {booking.client_phone && (
//                 <span style={{ color: "var(--text-muted)" }}>
//                   {" "}
//                   · {booking.client_phone}
//                 </span>
//               )}
//               {booking.client_email && (
//                 <span style={{ color: "var(--text-muted)" }}>
//                   {" "}
//                   · {booking.client_email}
//                 </span>
//               )}
//             </div>
//           )}
//           <div className="booking-card-id">
//             #{booking.id} ·{" "}
//             {new Date(booking.created_at).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//               year: "numeric",
//             })}
//           </div>
//         </div>

//         <div className="booking-card-amount">
//           <div className="booking-card-amount-label">{amountLabel}</div>
//           <div
//             className="booking-card-amount-value"
//             style={{ color: isRefunded ? "#94a3b8" : primaryColor }}
//           >
//             {isRefunded ? `−${fmtExact(displayAmt)}` : fmtExact(displayAmt)}
//           </div>
//           {isConfirmed && plan && paidTotal > 0 && !isRefunded && (
//             <>
//               {refundedTotal > 0 && (
//                 <div
//                   className="booking-card-refunded"
//                   style={{
//                     fontSize: 12,
//                     color: "#94a3b8",
//                     marginTop: 4,
//                     fontWeight: 600,
//                   }}
//                 >
//                   Refunded: {fmtExact(refundedTotal)}
//                 </div>
//               )}
//               {grandTotal - paidTotal - refundedTotal > 0.01 && (
//                 <div className="booking-card-balance">
//                   Balance: {fmtExact(grandTotal - paidTotal - refundedTotal)}
//                 </div>
//               )}
//             </>
//           )}
//           {isConfirmed &&
//             plan &&
//             paidTotal > 0 &&
//             !isRefunded &&
//             grandTotal - paidTotal - refundedTotal <= 0.01 &&
//             refundedTotal === 0 && (
//               <div className="booking-card-paid">✓ Fully paid (incl. tax)</div>
//             )}
//           {isConfirmed &&
//             plan &&
//             refundedTotal > 0 &&
//             grandTotal - paidTotal - refundedTotal <= 0.01 && (
//               <div
//                 className="booking-card-refunded"
//                 style={{
//                   fontSize: 12,
//                   color: "#94a3b8",
//                   marginTop: 4,
//                   fontWeight: 600,
//                 }}
//               >
//                 ✓ Fully Refunded
//               </div>
//             )}
//           {isPending && grandTotal > 0 && (
//             <div className="booking-card-grand-total">
//               Grand total: {fmtExact(grandTotal)}
//             </div>
//           )}
//         </div>
//       </div>

//       {isAgent && booking.commission_amount && (
//         <div
//           className="booking-card-commission"
//           style={{
//             background: `${primaryColor}06`,
//             border: `1px solid ${primaryColor}18`,
//           }}
//         >
//           <span className="booking-card-commission-label">Commission:</span>
//           <span className="booking-card-commission-value">
//             {fmtExact(booking.commission_amount)}
//           </span>
//           {booking.commission_status &&
//             (() => {
//               const cs =
//                 COMM_CFG[booking.commission_status] || COMM_CFG.pending;
//               return (
//                 <span
//                   className="booking-card-commission-status"
//                   style={{ color: cs.color }}
//                 >
//                   {cs.label}
//                 </span>
//               );
//             })()}
//         </div>
//       )}

//       <div className="booking-card-actions">
//         {isPending && !isAgent && (
//           <ElegantButton
//             onClick={() => {
//               const { milestoneId } = getManualTarget();
//               onPay(booking.id, milestoneId);
//             }}
//             size="sm"
//           >
//             💳 Complete Payment
//           </ElegantButton>
//         )}
//         {isPending && isAgent && (
//           <ElegantButton
//             onClick={() => {
//               const { milestoneId } = getManualTarget();
//               onSendPaymentLink(booking.id, milestoneId);
//             }}
//             size="sm"
//             loading={isSendingThisLink}
//           >
//             ✉️ Send Payment Link
//           </ElegantButton>
//         )}
//         {isPending && !manualSubmitted && (
//           <ElegantButton
//             variant="secondary"
//             onClick={() => setShowManualForm((s) => !s)}
//             size="sm"
//           >
//             🏦 {showManualForm ? "Cancel" : "Record Manual Payment"}
//           </ElegantButton>
//         )}
//         <ElegantButton
//           variant="secondary"
//           onClick={() => setExpanded((e) => !e)}
//           size="sm"
//         >
//           {expanded ? "▲ Less" : "▼ Payment Schedule"}
//         </ElegantButton>
//         {isPending && !confirmCancel && !isRefunded && (
//           <ElegantButton
//             variant="ghost"
//             onClick={() => setConfirmCancel(true)}
//             size="sm"
//           >
//             ✕ Cancel
//           </ElegantButton>
//         )}
//         {isPending && confirmCancel && !isRefunded && (
//           <div className="booking-card-cancel-confirm">
//             <span className="booking-card-cancel-text">Are you sure?</span>
//             <ElegantButton
//               variant="secondary"
//               onClick={async () => {
//                 setCancelling(true);
//                 await onCancel(booking.id);
//                 setCancelling(false);
//                 setConfirmCancel(false);
//               }}
//               size="sm"
//               loading={cancelling}
//             >
//               Yes, Cancel
//             </ElegantButton>
//             <ElegantButton
//               variant="ghost"
//               onClick={() => setConfirmCancel(false)}
//               size="sm"
//             >
//               No
//             </ElegantButton>
//           </div>
//         )}
//       </div>

//       {showManualForm && !manualSubmitted && (
//         <ManualPaymentInline
//           amountDue={getManualTarget().amount}
//           fmtExact={fmtExact}
//           submitting={manualSubmitting}
//           onSubmit={async (payload) => {
//             const { milestoneId, amount } = getManualTarget();
//             setManualSubmitting(true);
//             const ok = await onManualSubmit(booking.id, milestoneId, {
//               ...payload,
//               amount,
//             });
//             setManualSubmitting(false);
//             if (ok) {
//               setManualSubmitted(true);
//               setShowManualForm(false);
//             }
//           }}
//           onCancel={() => setShowManualForm(false)}
//         />
//       )}
//       {manualSubmitted && (
//         <div
//           style={{
//             marginTop: 8,
//             padding: "8px 12px",
//             borderRadius: 10,
//             background: "rgba(34,197,94,0.08)",
//             border: "1px solid rgba(34,197,94,0.25)",
//             color: "#16a34a",
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           ✓ Manual payment submitted — awaiting admin confirmation.
//         </div>
//       )}

//       {isPending && isAgent && !booking.client_email && (
//         <div
//           style={{
//             marginTop: 8,
//             fontSize: 11,
//             color: "#d97706",
//             fontStyle: "italic",
//           }}
//         >
//           ⚠ No client email on file for this booking — the link will be sent
//           once an email is added.
//         </div>
//       )}

//       {expanded && (
//         <div className="booking-card-expanded">
//           <MilestoneTracker
//             bookingId={booking.id}
//             token={token}
//             fmtExact={fmtExact}
//             booking={booking}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         </div>
//       )}
//     </ElegantCard>
//   );
// };

// // ── Profile Panel ───────────────────────────────────────────
// const ProfilePanel = ({ user, onSaved, showToast, primaryColor, tenant }) => {
//   const [form, setForm] = useState({
//     name: user.name || "",
//     phone: user.phone || "",
//     current_password: "",
//     new_password: "",
//     confirm_password: "",
//   });
//   const [saving, setSaving] = useState(false);

//   const handleSave = async () => {
//     if (form.new_password && form.new_password !== form.confirm_password) {
//       showToast("⚠️ New passwords do not match", "warning", 3500);
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = { name: form.name, phone: form.phone };
//       if (form.new_password) {
//         payload.current_password = form.current_password;
//         payload.new_password = form.new_password;
//       }

//       const result = await apiJson(tenant, `/user/profile`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${user.token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       showToast("✅ Profile updated successfully", "success", 3500);
//       setForm((f) => ({
//         ...f,
//         current_password: "",
//         new_password: "",
//         confirm_password: "",
//       }));
//       onSaved({ ...user, name: form.name, phone: form.phone });
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//     setSaving(false);
//   };

//   const isAgent = user.role === "broker" || user.role === "sales";

//   return (
//     <div className="profile-panel">
//       <ElegantCard>
//         <div className="profile-header">
//           <div
//             className="profile-avatar"
//             style={{
//               background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//               boxShadow: `0 4px 14px ${primaryColor}30`,
//             }}
//           >
//             {user.name?.[0]?.toUpperCase()}
//           </div>
//           <div className="profile-info">
//             <div className="profile-name">{user.name}</div>
//             <div className="profile-email">{user.email}</div>
//             <div className="profile-role" style={{ color: primaryColor }}>
//               {isAgent
//                 ? `${roleLabel(user.role)}${user.broker_company ? " · " + user.broker_company : ""}`
//                 : "Buyer"}
//             </div>
//           </div>
//         </div>

//         {isAgent && (
//           <div className="profile-broker-stats">
//             {[
//               {
//                 label: "Commission Rate",
//                 value: `${user.commission_rate || 2}%`,
//               },
//               {
//                 label: "Account Status",
//                 value: user.status || "active",
//                 color: user.status === "active" ? "#16a34a" : "#dc2626",
//               },
//             ].map(({ label, value, color }) => (
//               <div
//                 key={label}
//                 className="profile-broker-stat"
//                 style={{
//                   background: `${primaryColor}06`,
//                   border: `1px solid ${primaryColor}15`,
//                 }}
//               >
//                 <div className="profile-broker-stat-label">{label}</div>
//                 <div
//                   className="profile-broker-stat-value"
//                   style={{ color: color || primaryColor }}
//                 >
//                   {value}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         <div className="profile-section-title">Edit Profile</div>

//         <input
//           type="text"
//           placeholder="Full Name *"
//           value={form.name}
//           onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           className="profile-input"
//         />
//         <input
//           value={user.email}
//           readOnly
//           placeholder="Email"
//           className="profile-input profile-input-readonly"
//         />
//         <input
//           type="tel"
//           placeholder="Phone Number"
//           value={form.phone}
//           onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           className="profile-input"
//         />

//         <div className="profile-password-title">
//           Change Password (leave blank to keep current)
//         </div>
//         <input
//           type="password"
//           placeholder="Current Password"
//           value={form.current_password}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, current_password: e.target.value }))
//           }
//           className="profile-input"
//         />
//         <div className="profile-password-grid">
//           <input
//             type="password"
//             placeholder="New Password"
//             value={form.new_password}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, new_password: e.target.value }))
//             }
//             className="profile-input"
//           />
//           <input
//             type="password"
//             placeholder="Confirm Password"
//             value={form.confirm_password}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, confirm_password: e.target.value }))
//             }
//             className="profile-input"
//           />
//         </div>

//         <ElegantButton
//           onClick={handleSave}
//           disabled={saving || !form.name}
//           loading={saving}
//           size="lg"
//           style={{ width: "100%", marginTop: 8 }}
//         >
//           Save Changes →
//         </ElegantButton>
//       </ElegantCard>
//     </div>
//   );
// };

// // ── Agent Stats (broker or sales) ───────────────────────────
// const AgentStats = ({ bookings, fmtExact, primaryColor }) => {
//   const commPending = bookings
//     .filter((b) => b.commission_status === "pending")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
//   const commApproved = bookings
//     .filter((b) => b.commission_status === "approved")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
//   const commPaid = bookings
//     .filter((b) => b.commission_status === "paid")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);

//   return (
//     <div className="broker-stats">
//       {[
//         {
//           label: "Pending Commission",
//           value: fmtExact(commPending),
//           color: "#d97706",
//           icon: "⏳",
//         },
//         {
//           label: "Approved Commission",
//           value: fmtExact(commApproved),
//           color: "#2563eb",
//           icon: "✓",
//         },
//         {
//           label: "Commission Paid",
//           value: fmtExact(commPaid),
//           color: "#16a34a",
//           icon: "💰",
//         },
//         {
//           label: "Total Clients",
//           value: bookings.length,
//           color: primaryColor,
//           icon: "👥",
//         },
//       ].map(({ label, value, color, icon }) => (
//         <div key={label} className="broker-stat-card">
//           <div className="broker-stat-content">
//             <span className="broker-stat-icon">{icon}</span>
//             <div className="broker-stat-value" style={{ color }}>
//               {value}
//             </div>
//           </div>
//           <div className="broker-stat-label">{label}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// // ── Notifications Tab ──────────────────────────────────────
// const NOTIF_CFG = {
//   payment_reminder: { color: "#d97706", label: "Payment Reminder" },
//   booking_confirmed: { color: "#16a34a", label: "Booking Confirmed" },
//   booking_cancelled: { color: "#dc2626", label: "Booking Cancelled" },
//   project_launch: { color: null, label: "Project Launch" },
//   offer: { color: "#7c3aed", label: "Special Offer" },
//   general: { color: null, label: "General" },
// };

// const NotificationModal = ({
//   notif,
//   onClose,
//   onMarkRead,
//   onNavigate,
//   onSwitchToBookings,
//   primaryColor,
// }) => {
//   const cfg = notif
//     ? { ...(NOTIF_CFG[notif.type] || NOTIF_CFG.general) }
//     : NOTIF_CFG.general;
//   if (!cfg.color) cfg.color = primaryColor;

//   useEffect(() => {
//     if (!notif) return;
//     if (!notif.is_read) onMarkRead(notif.id);
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [notif?.id, onMarkRead, onClose]);

//   if (!notif) return null;

//   const timeAgo = (dateStr) => {
//     const diff = Date.now() - new Date(dateStr).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 1) return "Just now";
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     const d = Math.floor(h / 24);
//     return d < 7
//       ? `${d}d ago`
//       : new Date(dateStr).toLocaleDateString("en-IN", {
//           day: "numeric",
//           month: "short",
//           year: "numeric",
//         });
//   };

//   const handleViewBooking = () => {
//     onClose();
//     if (notif.type === "payment_reminder")
//       onNavigate(`/payment/${notif.booking_id}`);
//     else onSwitchToBookings(notif.booking_id);
//   };

//   return (
//     <div onClick={onClose} className="notification-modal-overlay">
//       <div
//         onClick={(e) => e.stopPropagation()}
//         className="notification-modal"
//         style={{ borderTopColor: cfg.color }}
//       >
//         <div className="notification-modal-header">
//           <div
//             className="notification-modal-icon"
//             style={{
//               background: `${cfg.color}12`,
//               borderColor: `${cfg.color}25`,
//             }}
//           >
//             🔔
//           </div>
//           <div className="notification-modal-info">
//             <div className="notification-modal-title">{notif.title}</div>
//             <div className="notification-modal-meta">
//               <span
//                 className="notification-modal-category"
//                 style={{ background: `${cfg.color}12`, color: cfg.color }}
//               >
//                 {cfg.label}
//               </span>
//               <span className="notification-modal-time">
//                 {timeAgo(notif.created_at)}
//               </span>
//             </div>
//           </div>
//           <button onClick={onClose} className="notification-modal-close">
//             ×
//           </button>
//         </div>
//         <div className="notification-modal-body">
//           <div className="notification-modal-message">{notif.message}</div>
//           <div className="notification-modal-actions">
//             {notif.booking_id && (
//               <ElegantButton onClick={handleViewBooking}>
//                 {notif.type === "payment_reminder"
//                   ? "Complete Payment →"
//                   : "View Booking →"}
//               </ElegantButton>
//             )}
//             <ElegantButton variant="secondary" onClick={onClose}>
//               Close
//             </ElegantButton>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const NotificationsTab = ({
//   notifications,
//   loading,
//   unreadCount,
//   onMarkRead,
//   onMarkAllRead,
//   onNavigate,
//   onSwitchToBookings,
//   primaryColor,
//   tenant,
// }) => {
//   const [filter, setFilter] = useState("all");
//   const [selectedNotif, setSelectedNotif] = useState(null);

//   const filtered = notifications.filter((n) => {
//     if (filter === "unread") return !n.is_read;
//     if (filter === "read") return n.is_read;
//     return true;
//   });

//   const timeAgo = (dateStr) => {
//     const diff = Date.now() - new Date(dateStr).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 1) return "Just now";
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     const d = Math.floor(h / 24);
//     if (d < 7) return `${d}d ago`;
//     return new Date(dateStr).toLocaleDateString("en-IN", {
//       day: "numeric",
//       month: "short",
//     });
//   };

//   if (loading)
//     return (
//       <div className="dashboard-loading">
//         <div className="dashboard-loading-icon">⏳</div>
//         <div className="dashboard-loading-text">Loading notifications...</div>
//       </div>
//     );

//   return (
//     <div className="notifications-tab">
//       {selectedNotif && (
//         <NotificationModal
//           notif={selectedNotif}
//           onClose={() => setSelectedNotif(null)}
//           onMarkRead={onMarkRead}
//           onNavigate={onNavigate}
//           onSwitchToBookings={onSwitchToBookings}
//           primaryColor={primaryColor}
//         />
//       )}
//       <div className="notifications-filter">
//         <div className="notifications-filter-group">
//           {[
//             ["all", "All"],
//             ["unread", "Unread"],
//             ["read", "Read"],
//           ].map(([val, label]) => (
//             <button
//               key={val}
//               onClick={() => setFilter(val)}
//               className={`notifications-filter-btn ${filter === val ? "notifications-filter-active" : "notifications-filter-inactive"}`}
//             >
//               {label}
//               {val === "unread" && unreadCount > 0 && (
//                 <span
//                   className="notifications-badge"
//                   style={{ background: "#d97706", color: "#fff" }}
//                 >
//                   {unreadCount}
//                 </span>
//               )}
//             </button>
//           ))}
//         </div>
//         {unreadCount > 0 && (
//           <ElegantButton variant="secondary" onClick={onMarkAllRead} size="sm">
//             ✓ Mark all read
//           </ElegantButton>
//         )}
//       </div>

//       {filtered.length === 0 && (
//         <div className="dashboard-empty">
//           <div className="dashboard-empty-icon">🔔</div>
//           <div className="dashboard-empty-title">
//             {filter === "unread"
//               ? "No unread notifications"
//               : "No notifications yet"}
//           </div>
//           <div className="dashboard-empty-subtitle">
//             Payment reminders and booking updates will appear here.
//           </div>
//         </div>
//       )}

//       <div className="notifications-list">
//         {filtered.map((n) => {
//           const cfg = { ...(NOTIF_CFG[n.type] || NOTIF_CFG.general) };
//           if (!cfg.color) cfg.color = primaryColor;
//           return (
//             <div
//               key={n.id}
//               onClick={() => setSelectedNotif(n)}
//               className={`notification-item ${n.is_read ? "notification-item-read" : "notification-item-unread"}`}
//             >
//               {!n.is_read && (
//                 <div
//                   className="notification-dot"
//                   style={{ background: cfg.color }}
//                 />
//               )}
//               <div className="notification-content">
//                 <div className="notification-header">
//                   <span
//                     className={`notification-title ${n.is_read ? "notification-title-normal" : "notification-title-bold"}`}
//                   >
//                     {n.title}
//                   </span>
//                   <span
//                     className="notification-category"
//                     style={{ background: `${cfg.color}12`, color: cfg.color }}
//                   >
//                     {cfg.label}
//                   </span>
//                 </div>
//                 <div className="notification-message">
//                   {n.message.length > 100
//                     ? n.message.slice(0, 100) + "…"
//                     : n.message}
//                 </div>
//                 <div className="notification-footer">
//                   <span className="notification-time">
//                     {timeAgo(n.created_at)}
//                   </span>
//                   <span
//                     className="notification-action"
//                     style={{ color: cfg.color }}
//                   >
//                     Click to read →
//                   </span>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Feedback Tab ────────────────────────────────────────────
// const CATEGORY_CFG = {
//   general: { color: "#6b7280" },
//   service: { color: "#2563eb" },
//   unit: { color: null },
//   payment: { color: "#d97706" },
//   staff: { color: "#7c3aed" },
// };

// const StarRating = ({ value, onChange, primaryColor }) => (
//   <div className="feedback-rating-stars">
//     {[1, 2, 3, 4, 5].map((s) => (
//       <button
//         key={s}
//         type="button"
//         onClick={() => onChange(s)}
//         className="feedback-star"
//         style={{ color: s <= value ? primaryColor : "var(--card-border)" }}
//       >
//         ★
//       </button>
//     ))}
//   </div>
// );

// const FeedbackTab = ({
//   feedbacks,
//   bookings,
//   token,
//   onSubmitted,
//   showToast,
//   primaryColor,
//   tenant,
// }) => {
//   const [showForm, setShowForm] = useState(false);
//   const [form, setForm] = useState({
//     rating: 5,
//     category: "general",
//     subject: "",
//     message: "",
//     booking_id: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   const handleSubmit = async () => {
//     if (!form.subject.trim() || !form.message.trim()) {
//       showToast("⚠️ Subject and message are required", "warning", 3500);
//       return;
//     }
//     setSubmitting(true);
//     try {
//       const result = await apiJson(tenant, `/feedback`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           ...form,
//           booking_id: form.booking_id || undefined,
//         }),
//       });

//       showToast(
//         "🙏 Thank you! Your feedback has been submitted",
//         "success",
//         4000,
//       );
//       setForm({
//         rating: 5,
//         category: "general",
//         subject: "",
//         message: "",
//         booking_id: "",
//       });
//       setShowForm(false);
//       onSubmitted(result.feedback);
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//     setSubmitting(false);
//   };

//   const confirmedBookings = bookings.filter(
//     (b) => b.booking_status === "confirmed",
//   );

//   return (
//     <div>
//       <div className="feedback-header">
//         <div>
//           <div className="feedback-title">Your Feedback</div>
//           <div className="feedback-subtitle">Share your experience with us</div>
//         </div>
//         <ElegantButton onClick={() => setShowForm((f) => !f)}>
//           {showForm ? "✕ Cancel" : "+ New Feedback"}
//         </ElegantButton>
//       </div>

//       {showForm && (
//         <div className="feedback-form">
//           <ElegantCard>
//             <div className="feedback-form-title">New Feedback</div>

//             <div className="feedback-rating">
//               <div className="feedback-rating-label">Rating *</div>
//               <StarRating
//                 value={form.rating}
//                 onChange={(r) => setForm((f) => ({ ...f, rating: r }))}
//                 primaryColor={primaryColor}
//               />
//               <div className="feedback-rating-text">
//                 {
//                   ["", "Very Poor", "Poor", "Average", "Good", "Excellent"][
//                     form.rating
//                   ]
//                 }
//               </div>
//             </div>

//             <div className="feedback-category">
//               <div className="feedback-category-label">Category *</div>
//               <div className="feedback-category-group">
//                 {Object.entries(CATEGORY_CFG).map(([cat, cfg]) => {
//                   const catColor = cfg.color || primaryColor;
//                   const isActive = form.category === cat;
//                   return (
//                     <button
//                       key={cat}
//                       type="button"
//                       onClick={() => setForm((f) => ({ ...f, category: cat }))}
//                       className={`feedback-category-btn ${isActive ? "feedback-category-active" : "feedback-category-inactive"}`}
//                     >
//                       {cat}
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             {confirmedBookings.length > 0 && (
//               <select
//                 value={form.booking_id}
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, booking_id: e.target.value }))
//                 }
//                 className="feedback-select"
//               >
//                 <option value="">Select booking (optional)</option>
//                 {confirmedBookings.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     Unit {b.plot_number} — Booking #{b.id}
//                   </option>
//                 ))}
//               </select>
//             )}

//             <input
//               type="text"
//               placeholder="Subject *"
//               value={form.subject}
//               onChange={(e) =>
//                 setForm((f) => ({ ...f, subject: e.target.value }))
//               }
//               className="feedback-input"
//             />

//             <textarea
//               placeholder="Your message..."
//               value={form.message}
//               onChange={(e) =>
//                 setForm((f) => ({ ...f, message: e.target.value }))
//               }
//               rows={4}
//               className="feedback-textarea"
//             />

//             <div className="feedback-actions">
//               <ElegantButton onClick={handleSubmit} loading={submitting}>
//                 Submit Feedback →
//               </ElegantButton>
//               <ElegantButton
//                 variant="secondary"
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </ElegantButton>
//             </div>
//           </ElegantCard>
//         </div>
//       )}

//       {feedbacks.length === 0 && !showForm && (
//         <div className="feedback-empty">
//           <div className="feedback-empty-icon">💬</div>
//           <div className="feedback-empty-title">No feedback yet</div>
//           <div className="feedback-empty-text">
//             Share your experience to help us improve.
//           </div>
//         </div>
//       )}

//       <div className="feedback-list">
//         {feedbacks.map((fb) => {
//           const catColor = CATEGORY_CFG[fb.category]?.color || primaryColor;
//           const ratingColor =
//             fb.rating >= 4 ? "#16a34a" : fb.rating >= 3 ? "#d97706" : "#dc2626";
//           const statusColor =
//             fb.status === "resolved"
//               ? "#16a34a"
//               : fb.status === "reviewed"
//                 ? "#2563eb"
//                 : "#d97706";
//           return (
//             <div key={fb.id} className="feedback-card">
//               <div className="feedback-card-header">
//                 <div className="feedback-card-info">
//                   <div className="feedback-card-tags">
//                     <span className="feedback-card-subject">{fb.subject}</span>
//                     <span
//                       className="feedback-card-category"
//                       style={{ background: `${catColor}12`, color: catColor }}
//                     >
//                       {fb.category}
//                     </span>
//                     <span
//                       className="feedback-card-status"
//                       style={{
//                         background: `${statusColor}12`,
//                         color: statusColor,
//                       }}
//                     >
//                       {fb.status}
//                     </span>
//                   </div>
//                   <div className="feedback-card-date">
//                     {fb.booking ? `Unit ${fb.booking.plot_number} · ` : ""}
//                     {new Date(fb.created_at).toLocaleDateString("en-IN", {
//                       day: "numeric",
//                       month: "short",
//                       year: "numeric",
//                     })}
//                   </div>
//                 </div>
//                 <div
//                   className="feedback-card-rating"
//                   style={{ color: ratingColor }}
//                 >
//                   {"★".repeat(fb.rating)}
//                 </div>
//               </div>
//               <div className="feedback-card-message">{fb.message}</div>
//               {fb.admin_reply && (
//                 <div
//                   className="feedback-card-reply"
//                   style={{
//                     background: "#16a34a08",
//                     border: "1px solid #16a34a20",
//                   }}
//                 >
//                   <div
//                     className="feedback-card-reply-title"
//                     style={{ color: "#16a34a" }}
//                   >
//                     Admin Reply
//                   </div>
//                   <div className="feedback-card-reply-text">
//                     {fb.admin_reply}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Main Dashboard ──────────────────────────────────────────
// export default function UserDashboard() {
//   // const navigate = useNavigate();
//   // const dispatch = useDispatch();
//   // const user = useSelector(selectUser);
//   const navigate = useNavigate();
//   const { user, updateUser, signOut } = useAuth();

//   const { settings } = useSettings();
//   const { tenant } = useParams();

//   const primaryColor = settings?.primary_color || "#c9a96e";

//   const [bookings, setBookings] = useState([]);
//   const [milestoneMap, setMilestoneMap] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [activeTab, setActiveTab] = useState("bookings");
//   const [notifications, setNotifications] = useState([]);
//   const [notifsLoading, setNotifsLoading] = useState(false);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [feedbacks, setFeedbacks] = useState([]);
//   const [payments, setPayments] = useState([]);
//   const [paymentsLoading, setPaymentsLoading] = useState(false);
//   const [unreadMessages, setUnreadMessages] = useState(0);
//   const [invoices, setInvoices] = useState([]);
//   const [invoiceCount, setInvoiceCount] = useState(0);

//   // Single source of truth for "which booking+milestone is currently
//   // sending a payment link" — composite key avoids all buttons on the
//   // same booking lighting up together.
//   const [sendingLinkKey, setSendingLinkKey] = useState(null);

//   const { showToast } = useToast();
//   const {
//     wishlist,
//     wishedIds,
//     toggle: toggleWishRaw,
//     loading: wishLoading,
//   } = useWishlist(tenant, user?.token);

//   const handleWishlistToggle = useCallback(
//     async (plotId) => {
//       const wasWished =
//         wishedIds instanceof Set && wishedIds.has(Number(plotId));
//       await toggleWishRaw(Number(plotId));
//       showToast(
//         wasWished ? "🤍 Removed from Wishlist" : "❤️ Added to Wishlist",
//         wasWished ? "wishlist_remove" : "wishlist_add",
//         2800,
//       );
//     },
//     [wishedIds, toggleWishRaw, showToast],
//   );

//   const [currency, setCurrency] = useState({
//     symbol: "₹",
//     code: "INR",
//     position: "before",
//   });

//   const fmt = useCallback(
//     (n) => makeFmt(currency.symbol, currency.position)(n),
//     [currency],
//   );
//   const fmtExact = useCallback(
//     (n) => makeFmtExact(currency.symbol, currency.position)(n),
//     [currency],
//   );

//   const isAgent = user?.role === "broker" || user?.role === "sales";

//   // ── Refresh the logged-in user's own record from the server ─────────
//   const fetchCurrentUser = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const fresh = await apiJson(tenant, `/user/me`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       // dispatch(setUser({ ...user, ...fresh, token: user.token }));
//       updateUser(fresh);
//     } catch (_) {
//       // Non-fatal — dashboard still works with the cached user object.
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, user?.token]);

//   const fetchMilestones = useCallback(
//     async (bookingsList) => {
//       const targets = bookingsList.filter(
//         (b) =>
//           (b.booking_status === "confirmed" ||
//             b.booking_status === "pending") &&
//           b.payment_plan_id,
//       );
//       if (!targets.length || !tenant) return;

//       const results = await Promise.all(
//         targets.map((b) =>
//           apiJson(tenant, `/bookings/${b.id}/milestones`, {
//             headers: {
//               Authorization: `Bearer ${user?.token}`,
//               Accept: "application/json",
//             },
//           }).catch(() => null),
//         ),
//       );
//       const map = {};
//       targets.forEach((b, i) => {
//         if (results[i]) map[b.id] = results[i];
//       });
//       setMilestoneMap(map);
//     },
//     [user?.token, tenant],
//   );

//   const switchToBookings = useCallback(
//     (bookingId) => {
//       setActiveTab("bookings");
//       if (!bookingId) return;
//       setTimeout(() => {
//         const el = document.getElementById(`booking-card-${bookingId}`);
//         if (el) {
//           el.scrollIntoView({ behavior: "smooth", block: "center" });
//           el.style.boxShadow = `0 0 0 2px ${primaryColor}, 0 0 24px ${primaryColor}30`;
//           el.style.transition = "box-shadow 0.3s";
//           setTimeout(() => {
//             el.style.boxShadow = "";
//           }, 3000);
//         }
//       }, 150);
//     },
//     [primaryColor],
//   );

//   const fetchInvoices = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const data = await apiJson(tenant, `/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//           Accept: "application/json",
//         },
//       });

//       let invoicesList = [];
//       if (data.success && Array.isArray(data.invoices)) {
//         invoicesList = data.invoices;
//       } else if (Array.isArray(data)) {
//         invoicesList = data;
//       }

//       setInvoices(invoicesList);
//       setInvoiceCount(invoicesList.length);
//     } catch (_) {}
//   }, [tenant, user?.token]);

//   const fetchBookings = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setLoading(true);
//     setError("");
//     try {
//       const data = await apiJson(tenant, `/bookings`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const list = Array.isArray(data) ? data : data.data || [];
//       setBookings(list);
//       fetchMilestones(list);
//     } catch (e) {
//       setError(e.message);
//       showToast("❌ Could not load bookings. Please retry.", "error", 4000);
//     } finally {
//       setLoading(false);
//     }
//   }, [tenant, user?.token, fetchMilestones, showToast]);

//   const fetchPayments = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setPaymentsLoading(true);
//     try {
//       const [txns, booksRaw] = await Promise.all([
//         apiJson(tenant, `/payment/history`, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             Accept: "application/json",
//           },
//         }),
//         apiJson(tenant, `/bookings`, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             Accept: "application/json",
//           },
//         }),
//       ]);

//       const txnList = Array.isArray(txns) ? txns : [];
//       const books = Array.isArray(booksRaw) ? booksRaw : booksRaw.data || [];
//       const txnBookingIds = new Set(txnList.map((t) => String(t.booking_id)));
//       const missingTxns = books
//         .filter(
//           (b) =>
//             b.booking_status === "confirmed" &&
//             !txnBookingIds.has(String(b.id)),
//         )
//         .map((b) => ({
//           id: `booking_${b.id}`,
//           booking_id: b.id,
//           amount: b.down_payment_amount || b.total_amount || 0,
//           currency: "INR",
//           status: "success",
//           mode: "manual",
//           gateway: "cash / manual",
//           paid_at: b.created_at,
//           _synthetic: true,
//           booking: {
//             id: b.id,
//             plot_number: b.plot_number,
//             plot_type: b.plot_type,
//             booking_status: b.booking_status,
//           },
//         }));
//       setPayments([...txnList, ...missingTxns]);
//     } catch (_) {
//     } finally {
//       setPaymentsLoading(false);
//     }
//   }, [tenant, user?.token]);

//   const fetchFeedbacks = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const data = await apiJson(tenant, `/feedback`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setFeedbacks(Array.isArray(data) ? data : data.data || []);
//     } catch (_) {}
//   }, [tenant, user?.token]);

//   const fetchNotifications = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setNotifsLoading(true);
//     try {
//       const data = await apiJson(tenant, `/notifications`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const list = Array.isArray(data) ? data : data.data || [];
//       setNotifications(list);
//       setUnreadCount(list.filter((n) => !n.is_read).length);
//     } catch (_) {
//     } finally {
//       setNotifsLoading(false);
//     }
//   }, [tenant, user?.token]);

//   useEffect(() => {
//     if (!user?.token || !tenant) {
//       navigate(`/${tenant || ""}`);
//       return;
//     }

//     const loadData = async () => {
//       try {
//         const currencyData = await apiJson(tenant, `/currency`);
//         if (currencyData) {
//           setCurrency({
//             symbol: currencyData.symbol || "₹",
//             code: currencyData.code || "INR",
//             position: currencyData.position || "before",
//           });
//         }
//       } catch (_) {}

//       await Promise.all([
//         fetchCurrentUser(),
//         fetchBookings(),
//         fetchNotifications(),
//         fetchFeedbacks(),
//         fetchPayments(),
//         fetchInvoices(),
//       ]);
//     };

//     loadData();

//     // Check for payment confirmation from URL params
//     const params = new URLSearchParams(window.location.search);
//     const bookingId = params.get("booking");
//     const sessionId = params.get("session_id");
//     if (bookingId && sessionId && tenant && user?.token) {
//       const confirmPayment = async () => {
//         try {
//           await apiJson(tenant, `/payment/stripe/confirm`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//             body: JSON.stringify({
//               booking_id: bookingId,
//               session_id: sessionId,
//             }),
//           });
//           await Promise.all([
//             fetchBookings(),
//             fetchNotifications(),
//             fetchPayments(),
//             fetchInvoices(),
//           ]);
//           showToast(
//             "🎉 Payment confirmed! Your booking is now active.",
//             "booking",
//             5000,
//           );
//         } catch (_) {}
//       };
//       confirmPayment();
//       window.history.replaceState({}, "", window.location.pathname);
//     }

//     // Fetch unread messages count
//     if (tenant && user?.token) {
//       apiJson(tenant, `/messages/unread`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       })
//         .then((d) => setUnreadMessages(d.unread || 0))
//         .catch(() => {});
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, user?.token]);

//   const markRead = async (id) => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/notifications/${id}/read`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)),
//       );
//       setUnreadCount((prev) => Math.max(0, prev - 1));
//     } catch (_) {}
//   };

//   const markAllRead = async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/notifications/read-all`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
//       setUnreadCount(0);
//       showToast("✅ All notifications marked as read", "success", 2500);
//     } catch (_) {}
//   };

//   const handlePay = (id, milestoneId) => {
//     if (milestoneId) {
//       navigate(`/${tenant}/payment/${id}?milestone=${milestoneId}`);
//     } else {
//       navigate(`/${tenant}/payment/${id}`);
//     }
//   };

//   // ── Send Payment Link (agent → client email) ────────────────
//   // Keyed by `${bookingId}-${milestoneId || "main"}` so multiple pending
//   // milestones on the same booking each get their own independent
//   // loading state, instead of all lighting up together.
//   const handleSendPaymentLink = useCallback(
//     async (bookingId, milestoneId) => {
//       if (!tenant || !user?.token) return;
//       const key = `${bookingId}-${milestoneId || "main"}`;
//       setSendingLinkKey(key);
//       try {
//         const data = await apiJson(
//           tenant,
//           `/bookings/${bookingId}/send-payment-link`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//             body: JSON.stringify({ milestone_id: milestoneId || undefined }),
//           },
//         );
//         showToast(
//           `✉️ Payment link sent to ${data?.sent_to || "the client"}`,
//           "success",
//           3800,
//         );
//       } catch (e) {
//         showToast("❌ " + e.message, "error", 4000);
//       } finally {
//         setSendingLinkKey(null);
//       }
//     },
//     [tenant, user?.token, showToast],
//   );

//   // ── Record Manual Payment (buyer paying manually, or agent recording a
//   //    payment collected offline). Always pending admin approval. ────────
//   const submitManualPayment = useCallback(
//     async (bookingId, milestoneId, payload) => {
//       if (!tenant || !user?.token) return false;
//       try {
//         await apiJson(tenant, `/bookings/${bookingId}/manual-payment`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `Bearer ${user.token}`,
//           },
//           body: JSON.stringify({
//             ...payload,
//             milestone_id: milestoneId || undefined,
//           }),
//         });
//         showToast(
//           "✅ Payment recorded — awaiting admin approval",
//           "success",
//           4000,
//         );
//         return true;
//       } catch (e) {
//         showToast("❌ " + e.message, "error", 4000);
//         return false;
//       }
//     },
//     [tenant, user?.token, showToast],
//   );

//   // const handleLogout = () => {
//   //   showToast("👋 Logged out successfully", "info", 2500);
//   //   setTimeout(() => {
//   //     dispatch(clearUser());
//   //     navigate(`/${tenant}`);
//   //   }, 600);
//   // };

//   const handleLogout = () => {
//   showToast("👋 Logged out successfully", "info", 2500);
//   setTimeout(() => {
//     signOut();
//     navigate(`/${tenant}`);
//   }, 600);
// };

//   // const handleSaved = (updated) => dispatch(setUser(updated));  
//   const handleSaved = (updated) => updateUser(updated);

//   const handleCancel = async (bookingId) => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/bookings/${bookingId}`, {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setBookings((prev) =>
//         prev.map((b) =>
//           b.id === bookingId ? { ...b, booking_status: "cancelled" } : b,
//         ),
//       );
//       showToast("✅ Booking cancelled successfully", "success", 3500);
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//   };

//   const confirmed = bookings.filter(
//     (b) => b.booking_status === "confirmed",
//   ).length;
//   const pending = bookings.filter((b) => b.booking_status === "pending").length;

//   const totalInvested = bookings
//     .filter((b) => b.booking_status === "confirmed")
//     .reduce((s, b) => {
//       const msData = milestoneMap[b.id];
//       if (msData?.milestones?.length) {
//         const paidSum = msData.milestones
//           .filter((m) => m.status === "paid")
//           .reduce((ms, m) => ms + msAmount(m), 0);
//         if (paidSum > 0) return s + paidSum;
//         return (
//           s +
//           parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
//         );
//       }
//       return (
//         s + parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
//       );
//     }, 0);

//   const tabs = [
//     {
//       id: "bookings",
//       label: isAgent ? "Client Bookings" : "My Bookings",
//       count: bookings.length,
//     },
//     { id: "wishlist", label: "Wishlist", count: wishlist.length },
//     { id: "payments", label: "Payments", count: 0 },
//     { id: "invoices", label: "Invoices", count: invoiceCount },
//     { id: "notifications", label: "Notifications", count: unreadCount },
//     { id: "feedback", label: "Feedback", count: 0 },
//     { id: "messages", label: "Messages", count: unreadMessages },
//     { id: "profile", label: "My Profile", count: 0 },
//   ];

//   const logoUrl =
//     settings?.app_logo_dark_url || settings?.app_logo_light_url || null;
//   const appName = settings?.app_name || "Dashboard";

//   return (
//     <div className="dashboard">
//       {/* Header */}
//       <div className="dashboard-header">
//         <div className="dashboard-header-left">
//           <button onClick={() => navigate(-1)} className="dashboard-back-btn">
//             ← Back
//           </button>
//           {logoUrl ? (
//             <img src={logoUrl} alt={appName} className="dashboard-logo" />
//           ) : (
//             <span className="dashboard-logo-text">
//               {isAgent ? `${roleLabel(user.role)} Dashboard` : "My Dashboard"}
//             </span>
//           )}
//         </div>

//         <div className="dashboard-header-right">
//           <div className="dashboard-user-info">
//             <div className="dashboard-user-name">{user?.name}</div>
//             <div className="dashboard-user-role">
//               {isAgent
//                 ? `${roleLabel(user.role)}${user?.broker_company ? " · " + user.broker_company : ""}`
//                 : "Buyer"}
//             </div>
//           </div>
//           <div
//             className="dashboard-avatar"
//             style={{
//               background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//               boxShadow: `0 2px 8px ${primaryColor}30`,
//             }}
//           >
//             {user?.name?.[0]?.toUpperCase()}
//           </div>
//           <ElegantButton variant="secondary" onClick={handleLogout} size="sm">
//             Logout
//           </ElegantButton>
//           <button
//             onClick={() => setActiveTab("notifications")}
//             className="dashboard-notif-btn"
//           >
//             🔔
//             {unreadCount > 0 && (
//               <span className="dashboard-notif-badge">
//                 {unreadCount > 9 ? "9+" : unreadCount}
//               </span>
//             )}
//           </button>
//         </div>
//       </div>

//       <div className="dashboard-container">
//         {/* Welcome */}
//         <div className="dashboard-welcome">
//           <div className="dashboard-welcome-title">
//             Welcome back, {user?.name?.split(" ")[0]}
//           </div>
//           <div className="dashboard-welcome-subtitle">
//             {isAgent
//               ? "Manage your client bookings and track your commissions."
//               : "Track your property bookings and payments."}
//           </div>
//         </div>

//         {/* Stat cards */}
//         <div className="dashboard-stats">
//           <StatCard
//             icon="📋"
//             label="Total Bookings"
//             value={bookings.length}
//             color={primaryColor}
//           />
//           <StatCard
//             icon="✓"
//             label="Confirmed"
//             value={confirmed}
//             color="#16a34a"
//           />
//           <StatCard
//             icon="⏳"
//             label="Pending Payment"
//             value={pending}
//             color="#d97706"
//           />
//           {!isAgent && (
//             <StatCard
//               icon="💰"
//               label="Amount Invested"
//               value={fmtExact(totalInvested)}
//               color={primaryColor}
//             />
//           )}
//         </div>

//         {isAgent && bookings.length > 0 && (
//           <AgentStats
//             bookings={bookings}
//             fmtExact={fmtExact}
//             primaryColor={primaryColor}
//           />
//         )}

//         {/* Tabs */}
//         <div className="dashboard-tabs">
//           {tabs.map((t) => (
//             <TabButton
//               key={t.id}
//               active={activeTab === t.id}
//               onClick={() => setActiveTab(t.id)}
//               label={t.label}
//               count={t.count}
//               primaryColor={primaryColor}
//             />
//           ))}
//         </div>

//         {/* Tab Content */}
//         {activeTab === "bookings" && (
//           <div>
//             {loading && (
//               <div className="dashboard-loading">
//                 <div className="dashboard-loading-icon">⏳</div>
//                 <div className="dashboard-loading-text">
//                   Loading bookings...
//                 </div>
//               </div>
//             )}
//             {error && (
//               <div className="dashboard-error">
//                 <span>⚠ {error}</span>
//                 <ElegantButton
//                   variant="secondary"
//                   onClick={fetchBookings}
//                   size="sm"
//                 >
//                   Retry
//                 </ElegantButton>
//               </div>
//             )}
//             {!loading && Object.keys(milestoneMap).length > 0 && (
//               <DuesBanner
//                 milestoneMap={milestoneMap}
//                 fmtExact={fmtExact}
//                 onNavigate={(path) => navigate(`/${tenant}${path}`)}
//                 primaryColor={primaryColor}
//                 isAgent={isAgent}
//                 onSendLink={handleSendPaymentLink}
//                 onManualSubmit={submitManualPayment}
//                 sendingLinkKey={sendingLinkKey}
//               />
//             )}
//             {!loading && !error && bookings.length === 0 && (
//               <div className="dashboard-empty">
//                 <div className="dashboard-empty-icon">🏠</div>
//                 <div className="dashboard-empty-title">
//                   {isAgent ? "No client bookings yet" : "No bookings yet"}
//                 </div>
//                 <div className="dashboard-empty-subtitle">
//                   {isAgent
//                     ? "Book a unit for your clients from the unit page."
//                     : "Browse available units to make your first booking."}
//                 </div>
//                 <ElegantButton onClick={() => navigate(`/${tenant}`)}>
//                   Browse Units →
//                 </ElegantButton>
//               </div>
//             )}
//             <div className="dashboard-bookings">
//               {!loading &&
//                 bookings.map((b) => (
//                   <BookingCard
//                     key={b.id}
//                     booking={b}
//                     onPay={handlePay}
//                     onCancel={handleCancel}
//                     onSendPaymentLink={handleSendPaymentLink}
//                     onManualSubmit={submitManualPayment}
//                     sendingLinkKey={sendingLinkKey}
//                     isAgent={isAgent}
//                     fmtExact={fmtExact}
//                     token={user?.token}
//                     primaryColor={primaryColor}
//                     milestoneMap={milestoneMap}
//                     tenant={tenant}
//                   />
//                 ))}
//             </div>
//           </div>
//         )}

//         {activeTab === "wishlist" && (
//           <WishlistTab
//             wishlist={wishlist}
//             wishedIds={wishedIds}
//             onToggle={handleWishlistToggle}
//             loading={wishLoading}
//             token={user?.token}
//             onNavigate={(path) => navigate(`/${tenant}${path}`)}
//             fmt={fmt}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "payments" && (
//           <PaymentsTab
//             payments={payments}
//             loading={paymentsLoading}
//             fmt={fmt}
//             fmtExact={fmtExact}
//             user={user}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "invoices" && (
//           <InvoicesTab user={user} fmt={fmt} tenant={tenant} />
//         )}
//         {activeTab === "notifications" && (
//           <NotificationsTab
//             notifications={notifications}
//             loading={notifsLoading}
//             unreadCount={unreadCount}
//             onMarkRead={markRead}
//             onMarkAllRead={markAllRead}
//             onNavigate={(path) => navigate(`/${tenant}${path}`)}
//             onSwitchToBookings={switchToBookings}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "feedback" && (
//           <FeedbackTab
//             feedbacks={feedbacks}
//             bookings={bookings}
//             token={user?.token}
//             showToast={showToast}
//             onSubmitted={(newFb) => setFeedbacks((prev) => [newFb, ...prev])}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         )}
//         {activeTab === "messages" && (
//           <MessagesTab user={user} tenant={tenant} />
//         )}
//         {activeTab === "profile" && (
//           <ProfilePanel
//             user={user}
//             onSaved={handleSaved}
//             showToast={showToast}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         )}
//       </div>
//     </div>
//   );
// }

// // UserDashboard.jsx
// import { useEffect, useState, useCallback } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// // import { useSelector, useDispatch } from "react-redux";
// // import { selectUser, setUser, clearUser } from "../redux/authSlice";

// import { useAuth } from "../context/AuthContext";

// import { useToast } from "../context/ToastContext";
// import { useSettings } from "../context/SettingsContext";
// import { useWishlist } from "../hooks/useWishlist";
// import { apiJson } from "../api/apiClient";
// import { apiUrl } from "../apiUrl";
// import WishlistTab from "./WishlistTab";
// import MessagesTab from "./MessagesTab";
// import InvoicesTab from "./InvoicesTab";
// import PaymentsTab from "./PaymentsTab";
// import "../styles/UserDashboard.css";

// const API_BASE = `${apiUrl}/api`;

// // ── Formatters ─────────────────────────────────────────────
// const makeFmt =
//   (symbol = "₹", position = "before") =>
//   (n) => {
//     if (n == null) return "—";
//     const num = new Intl.NumberFormat("en-IN", {
//       maximumFractionDigits: 0,
//     }).format(n);
//     return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
//   };

// const makeFmtExact =
//   (symbol = "₹", position = "before") =>
//   (n) => {
//     if (n == null) return "—";
//     const num = new Intl.NumberFormat("en-IN", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }).format(n);
//     return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
//   };

// const STATUS_CFG = {
//   confirmed: {
//     color: "#16a34a",
//     bg: "rgba(22,163,74,0.10)",
//     label: "Confirmed",
//   },
//   pending: {
//     color: "#d97706",
//     bg: "rgba(217,119,6,0.10)",
//     label: "Pending Payment",
//   },
//   cancelled: {
//     color: "#dc2626",
//     bg: "rgba(220,38,38,0.10)",
//     label: "Cancelled",
//   },
//   refunded: {
//     color: "#94a3b8",
//     bg: "rgba(148,163,184,0.10)",
//     label: "Refunded",
//   },
// };

// const COMM_CFG = {
//   pending: { color: "#d97706", label: "Pending Approval" },
//   approved: { color: "#2563eb", label: "Approved" },
//   paid: { color: "#16a34a", label: "Paid" },
//   rejected: { color: "#dc2626", label: "Rejected" },
//   refunded: { color: "#94a3b8", label: "Refunded" },
// };

// const msAmount = (m) => parseFloat(m.total_with_tax ?? m.amount ?? 0);

// // ── Role label helper ───────────────────────────────────────
// const roleLabel = (role) =>
//   role === "broker" ? "Broker" : role === "sales" ? "Sales Agent" : "Buyer";

// // ── Elegant Card Component ─────────────────────────────────
// const ElegantCard = ({ children, noPadding, hover, onClick, className }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <div
//       className={`elegant-card ${hover ? "elegant-card-hover" : ""} ${noPadding ? "elegant-card-no-padding" : "elegant-card-padding"} ${onClick ? "elegant-card-clickable" : ""} ${className || ""}`}
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       {children}
//     </div>
//   );
// };

// // ── Elegant Button ─────────────────────────────────────────
// const ElegantButton = ({
//   children,
//   variant = "primary",
//   onClick,
//   disabled,
//   loading,
//   size = "md",
//   className,
// }) => {
//   const sizeClass = `elegant-btn-${size}`;
//   const variantClass = `elegant-btn-${variant}`;

//   return (
//     <button
//       className={`elegant-btn ${sizeClass} ${variantClass} ${className || ""}`}
//       onClick={onClick}
//       disabled={disabled || loading}
//     >
//       {loading && <span className="elegant-btn-spinner"></span>}
//       {children}
//     </button>
//   );
// };

// // ── Elegant Stat Card ──────────────────────────────────────
// const StatCard = ({ icon, label, value, color }) => (
//   <div className="stat-card">
//     <div className="stat-card-content">
//       <div
//         className="stat-card-icon"
//         style={{
//           background: `linear-gradient(135deg, ${color}15, ${color}08)`,
//         }}
//       >
//         {icon}
//       </div>
//       <div>
//         <div className="stat-card-value" style={{ color }}>
//           {value}
//         </div>
//         <div className="stat-card-label">{label}</div>
//       </div>
//     </div>
//   </div>
// );

// // ── Tab Button — now supports an optional icon, used for the vertical
// // rail's tab list. Existing callers that don't pass `icon` render
// // exactly as before. ─────────────────────────────────────────
// const TabButton = ({ active, onClick, label, count, icon }) => (
//   <button
//     onClick={onClick}
//     className={`dashboard-tab ${active ? "dashboard-tab-active" : "dashboard-tab-inactive"}`}
//   >
//     {icon && <span className="dashboard-tab-icon">{icon}</span>}
//     {label}
//     {count > 0 && (
//       <span
//         className={`dashboard-tab-count ${active ? "dashboard-tab-count-active" : "dashboard-tab-count-inactive"}`}
//       >
//         {count}
//       </span>
//     )}
//   </button>
// );

// // ── Milestone Row Component ─────────────────────────────────
// const MilestoneRow = ({
//   label,
//   percentage,
//   amount,
//   baseAmount,
//   taxAmount,
//   extraFees,
//   taxLabel,
//   taxRate,
//   hasTax,
//   isPaid,
//   isDue,
//   isOverdue,
//   isWaived,
//   isRefunded,
//   dueDate,
//   paidAt,
//   index,
//   fmtExact,
//   primaryColor,
// }) => {
//   const [showTax, setShowTax] = useState(false);

//   let textColor = "var(--text-muted)";
//   let dotBackground = "transparent";
//   let dotBorder = "var(--card-border)";
//   let dotColor = "var(--text-muted)";

//   if (isRefunded) {
//     textColor = "var(--text-muted)";
//     dotBackground = "transparent";
//     dotBorder = "#94a3b8";
//     dotColor = "#94a3b8";
//   } else if (isPaid) {
//     textColor = primaryColor;
//     dotBackground = primaryColor;
//     dotBorder = primaryColor;
//     dotColor = "#fff";
//   } else if (isOverdue) {
//     textColor = "#dc2626";
//     dotBackground = "transparent";
//     dotBorder = "#dc2626";
//     dotColor = "#dc2626";
//   } else if (isDue) {
//     textColor = "var(--text-dark)";
//     dotBackground = "transparent";
//     dotBorder = primaryColor;
//     dotColor = primaryColor;
//   }

//   const dotContent = isRefunded
//     ? "↺"
//     : isPaid
//       ? "✓"
//       : isWaived
//         ? "–"
//         : index + 1;

//   return (
//     <div className="milestone-row">
//       <div
//         className="milestone-dot"
//         style={{
//           background: dotBackground,
//           border: `2px solid ${dotBorder}`,
//           color: dotColor,
//         }}
//       >
//         {dotContent}
//       </div>
//       <div
//         className="milestone-content"
//         style={{
//           background: isPaid
//             ? `${primaryColor}06`
//             : isRefunded
//               ? "rgba(148,163,184,0.06)"
//               : "var(--page-bg)",
//           border: `1px solid ${isPaid ? primaryColor + "20" : isRefunded ? "#94a3b820" : isOverdue ? "#dc262620" : isDue ? primaryColor + "18" : "var(--card-border)"}`,
//         }}
//       >
//         <div className="milestone-header">
//           <div className="milestone-info">
//             <div className="milestone-label" style={{ color: textColor }}>
//               {label}
//             </div>
//             <div className="milestone-meta">
//               {percentage ? `${percentage}% of total` : ""}
//               {dueDate && !isPaid && !isRefunded && (
//                 <span style={{ marginLeft: percentage ? 8 : 0 }}>
//                   Due: {dueDate}
//                   {isOverdue && (
//                     <span
//                       style={{
//                         color: "#dc2626",
//                         fontWeight: 700,
//                         marginLeft: 6,
//                       }}
//                     >
//                       ⚠ Overdue
//                     </span>
//                   )}
//                 </span>
//               )}
//               {isPaid && paidAt && (
//                 <span style={{ color: "#16a34a", marginLeft: 6 }}>
//                   ✓ Paid {paidAt}
//                 </span>
//               )}
//               {isRefunded && (
//                 <span style={{ color: "#94a3b8", marginLeft: 6 }}>
//                   ↺ Refunded
//                 </span>
//               )}
//               {isDue && !isOverdue && !isRefunded && (
//                 <span style={{ color: "#d97706", marginLeft: 6 }}>
//                   ← Due now
//                 </span>
//               )}
//               {isWaived && (
//                 <span style={{ color: "var(--text-muted)", marginLeft: 6 }}>
//                   Waived
//                 </span>
//               )}
//             </div>
//           </div>
//           <div className="milestone-amount">
//             <div
//               className="milestone-amount-value"
//               style={{ color: textColor }}
//             >
//               {isRefunded ? `−${fmtExact(amount)}` : fmtExact(amount)}
//             </div>
//             {hasTax && !isRefunded && (
//               <button
//                 type="button"
//                 className="milestone-tax-btn"
//                 onClick={() => setShowTax((s) => !s)}
//               >
//                 {taxLabel || "Tax"}
//                 {taxRate > 0 ? ` ${taxRate}%` : ""} {showTax ? "▲" : "▼"}
//               </button>
//             )}
//           </div>
//         </div>

//         {hasTax && showTax && !isRefunded && (
//           <div className="milestone-tax-details">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: "var(--text-muted)",
//                 marginBottom: 4,
//               }}
//             >
//               <span>Base amount</span>
//               <span>{fmtExact(baseAmount)}</span>
//             </div>
//             {(extraFees || 0) > 0 && (
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   color: "var(--text-muted)",
//                   marginBottom: 4,
//                 }}
//               >
//                 <span>Additional fees</span>
//                 <span>{fmtExact(extraFees)}</span>
//               </div>
//             )}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: "#d97706",
//               }}
//             >
//               <span>
//                 {taxLabel || "Tax"}
//                 {taxRate > 0 ? ` (${taxRate}%)` : ""}
//               </span>
//               <span>{fmtExact(taxAmount)}</span>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 color: primaryColor,
//                 fontWeight: 700,
//                 borderTop: `1px solid ${primaryColor}20`,
//                 paddingTop: 8,
//                 marginTop: 8,
//               }}
//             >
//               <span>Total payable</span>
//               <span>{fmtExact(amount)}</span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // ── Milestone Tracker ───────────────────────────────────────
// const MilestoneTracker = ({
//   bookingId,
//   token,
//   fmtExact,
//   booking,
//   primaryColor,
//   tenant,
// }) => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const isBookingRefunded = booking?.booking_status === "refunded";

//   useEffect(() => {
//     if (!bookingId || !token || !tenant) return;

//     const fetchMilestones = async () => {
//       try {
//         const result = await apiJson(
//           tenant,
//           `/bookings/${bookingId}/milestones`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//             },
//           },
//         );
//         setData(result);
//       } catch (err) {
//         console.error("Error fetching milestones:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMilestones();
//   }, [bookingId, token, tenant]);

//   // Show refunded message if booking is refunded
//   if (isBookingRefunded) {
//     return (
//       <div className="milestone-tracker">
//         <div
//           className="refunded-banner"
//           style={{
//             background: "rgba(148,163,184,0.08)",
//             border: "1px solid rgba(148,163,184,0.2)",
//             borderRadius: "12px",
//             padding: "16px",
//             textAlign: "center",
//           }}
//         >
//           <div style={{ fontSize: "32px", marginBottom: "8px" }}>↺</div>
//           <div
//             style={{
//               fontSize: "14px",
//               fontWeight: "700",
//               color: "#64748b",
//               marginBottom: "4px",
//             }}
//           >
//             Booking Refunded
//           </div>
//           <div style={{ fontSize: "12px", color: "var(--text-muted)" }}>
//             This booking has been cancelled and fully refunded.
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!loading && (!data || !data.milestones?.length)) {
//     const plan = booking?.payment_plan;
//     const price = parseFloat(booking?.price || 0);
//     if (!plan?.milestones?.length) {
//       return (
//         <div className="milestone-tracker">
//           <div
//             className="booking-card-expanded"
//             style={{
//               color: "var(--text-muted)",
//               fontSize: 13,
//               padding: "12px 16px",
//               background: "var(--page-bg)",
//               borderRadius: "14px",
//             }}
//           >
//             Full payment — no instalment plan selected
//           </div>
//         </div>
//       );
//     }
//     const isConfirmed = booking.booking_status === "confirmed";
//     const grandTotal = parseFloat(booking.total_amount || price);
//     return (
//       <div className="milestone-tracker">
//         <div className="booking-card-expanded">
//           <div
//             style={{
//               fontSize: 11,
//               color: "var(--text-muted)",
//               fontWeight: 700,
//               letterSpacing: "0.8px",
//               textTransform: "uppercase",
//               marginBottom: 12,
//             }}
//           >
//             Payment Schedule — {plan.name}
//           </div>
//           {plan.milestones.map((m, i) => {
//             const amt = m.percentage
//               ? (grandTotal * m.percentage) / 100
//               : m.fixed_amount;
//             const isPaid = i === 0 && isConfirmed;
//             const isDue = i === 0 && !isConfirmed;
//             return (
//               <MilestoneRow
//                 key={i}
//                 label={m.label}
//                 percentage={m.percentage}
//                 amount={amt}
//                 isPaid={isPaid}
//                 isDue={isDue}
//                 isRefunded={false}
//                 index={i}
//                 fmtExact={fmtExact}
//                 primaryColor={primaryColor}
//               />
//             );
//           })}
//         </div>
//       </div>
//     );
//   }

//   if (loading)
//     return (
//       <div className="milestone-tracker">
//         <div
//           className="booking-card-expanded"
//           style={{ color: "var(--text-muted)", fontSize: 12, padding: 12 }}
//         >
//           Loading payment schedule...
//         </div>
//       </div>
//     );

//   const { milestones } = data;
//   const totalAmount = milestones.reduce((s, m) => s + msAmount(m), 0);
//   const paidAmount = milestones
//     .filter((m) => m.status === "paid")
//     .reduce((s, m) => s + msAmount(m), 0);
//   const refundedAmount = milestones
//     .filter((m) => m.status === "refunded")
//     .reduce((s, m) => s + msAmount(m), 0);
//   const balanceDue = totalAmount - paidAmount - refundedAmount;
//   const pct =
//     totalAmount > 0
//       ? Math.round(((paidAmount + refundedAmount) / totalAmount) * 100)
//       : 0;
//   const isFullyRefunded = refundedAmount > 0 && refundedAmount >= totalAmount;

//   return (
//     <div className="milestone-tracker">
//       <div className="milestone-progress">
//         <div className="milestone-progress-header">
//           <span>Payment Progress (incl. taxes)</span>
//           <span className="milestone-progress-percent">{pct}% complete</span>
//         </div>
//         <div className="milestone-progress-bar">
//           <div
//             className="milestone-progress-fill"
//             style={{
//               width: `${pct}%`,
//               background: isFullyRefunded ? "#94a3b8" : primaryColor,
//             }}
//           />
//         </div>
//         <div className="milestone-progress-stats">
//           <span className="milestone-progress-paid">
//             Paid: {fmtExact(paidAmount)}
//           </span>
//           {refundedAmount > 0 && (
//             <span
//               className="milestone-progress-refunded"
//               style={{ color: "#94a3b8" }}
//             >
//               Refunded: {fmtExact(refundedAmount)}
//             </span>
//           )}
//           <span
//             className="milestone-progress-balance"
//             style={{
//               color:
//                 balanceDue > 0
//                   ? "#d97706"
//                   : isFullyRefunded
//                     ? "#94a3b8"
//                     : "#16a34a",
//             }}
//           >
//             {balanceDue > 0
//               ? `Balance: ${fmtExact(balanceDue)}`
//               : isFullyRefunded
//                 ? "✓ Fully Refunded"
//                 : "✓ Fully Paid"}
//           </span>
//         </div>
//       </div>

//       {milestones.map((m, i) => {
//         const isPaid = m.status === "paid";
//         const isOverdue = m.status === "overdue";
//         const isWaived = m.status === "waived";
//         const isRefunded = m.status === "refunded";
//         const isDue =
//           !isPaid &&
//           !isWaived &&
//           !isRefunded &&
//           i ===
//             milestones.findIndex(
//               (x) => x.status === "pending" || x.status === "overdue",
//             );
//         return (
//           <MilestoneRow
//             key={m.id}
//             label={m.label}
//             percentage={m.percentage}
//             amount={msAmount(m)}
//             baseAmount={m.amount}
//             taxAmount={m.tax_amount}
//             extraFees={m.extra_fees}
//             taxLabel={m.tax_label}
//             taxRate={m.tax_rate}
//             hasTax={(m.tax_amount || 0) > 0}
//             isPaid={isPaid}
//             isDue={isDue}
//             isOverdue={isOverdue}
//             isWaived={isWaived}
//             isRefunded={isRefunded}
//             dueDate={m.due_date}
//             paidAt={m.paid_at}
//             index={i}
//             fmtExact={fmtExact}
//             primaryColor={primaryColor}
//           />
//         );
//       })}
//     </div>
//   );
// };

// // ── Inline Manual Payment Form (used in DuesBanner + BookingCard) ──────
// // Always submits as PENDING; admin approval required before it counts as paid.
// const ManualPaymentInline = ({
//   amountDue,
//   fmtExact,
//   submitting,
//   onSubmit,
//   onCancel,
// }) => {
//   const [mode, setMode] = useState("cash");
//   const [reference, setReference] = useState("");
//   const [notes, setNotes] = useState("");

//   return (
//     <div
//       style={{
//         marginTop: 10,
//         padding: 12,
//         borderRadius: 12,
//         background: "var(--page-bg)",
//         border: "1px solid var(--card-border)",
//       }}
//     >
//       <div
//         style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}
//       >
//         <select
//           value={mode}
//           onChange={(e) => setMode(e.target.value)}
//           style={{
//             flex: 1,
//             minWidth: 130,
//             padding: 8,
//             borderRadius: 8,
//             border: "1px solid var(--card-border)",
//             background: "var(--card-bg)",
//             color: "var(--text-dark)",
//           }}
//         >
//           <option value="cash">💵 Cash</option>
//           <option value="cheque">📄 Cheque</option>
//           <option value="bank_transfer">🏦 Bank Transfer</option>
//         </select>
//         <input
//           type="text"
//           placeholder="Reference number (optional)"
//           value={reference}
//           onChange={(e) => setReference(e.target.value)}
//           style={{
//             flex: 1,
//             minWidth: 160,
//             padding: 8,
//             borderRadius: 8,
//             border: "1px solid var(--card-border)",
//             background: "var(--card-bg)",
//             color: "var(--text-dark)",
//           }}
//         />
//       </div>
//       <textarea
//         placeholder="Notes (optional)"
//         value={notes}
//         onChange={(e) => setNotes(e.target.value)}
//         rows={2}
//         style={{
//           width: "100%",
//           padding: 8,
//           borderRadius: 8,
//           border: "1px solid var(--card-border)",
//           background: "var(--card-bg)",
//           color: "var(--text-dark)",
//           marginBottom: 8,
//           resize: "vertical",
//           boxSizing: "border-box",
//         }}
//       />
//       <div
//         style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 10 }}
//       >
//         Amount: <strong>{fmtExact(amountDue)}</strong> · Submitted for admin
//         approval — won't be marked as paid immediately.
//       </div>
//       <div style={{ display: "flex", gap: 8 }}>
//         <ElegantButton
//           size="sm"
//           onClick={() =>
//             onSubmit({ payment_mode: mode, reference_number: reference, notes })
//           }
//           loading={submitting}
//         >
//           Submit for Approval
//         </ElegantButton>
//         <ElegantButton
//           size="sm"
//           variant="ghost"
//           onClick={onCancel}
//           disabled={submitting}
//         >
//           Cancel
//         </ElegantButton>
//       </div>
//     </div>
//   );
// };

// // ── Individual Due Item — Send Link / Pay Online / Record Manual ───────
// const DueItemRow = ({
//   due,
//   fmtExact,
//   onNavigate,
//   isAgent,
//   onSendLink,
//   onManualSubmit,
//   sendingLinkKey,
//   accentColor,
// }) => {
//   const [showManual, setShowManual] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   const isSendingThis = sendingLinkKey === `${due.bookingId}-${due.id}`;

//   const handleManualSubmit = async (payload) => {
//     setSubmitting(true);
//     const ok = await onManualSubmit(due.bookingId, due.id, {
//       ...payload,
//       amount: due.displayAmount,
//     });
//     setSubmitting(false);
//     if (ok) {
//       setSubmitted(true);
//       setShowManual(false);
//     }
//   };

//   return (
//     <div
//       className="dues-item"
//       style={{
//         flexDirection: "column",
//         alignItems: "stretch",
//         borderColor: `${accentColor}30`,
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//         }}
//       >
//         <div>
//           <div className="dues-item-title">{due.label}</div>
//           <div className="dues-item-details">
//             {due.due_date ? `Due: ${due.due_date}` : "No due date set"}
//             {due.status === "overdue" && (
//               <span className="dues-item-overdue">⚠ Overdue</span>
//             )}
//             <span style={{ marginLeft: 8 }}>· Booking #{due.bookingId}</span>
//             {(due.tax_amount || 0) > 0 && (
//               <span className="dues-item-tax">incl. tax</span>
//             )}
//           </div>
//         </div>
//         <div className="dues-item-amount" style={{ color: accentColor }}>
//           <div style={{ fontSize: 18, fontWeight: 800 }}>
//             {fmtExact(due.displayAmount)}
//           </div>
//         </div>
//       </div>

//       {submitted ? (
//         <div
//           style={{
//             marginTop: 10,
//             padding: "8px 12px",
//             borderRadius: 10,
//             background: "rgba(34,197,94,0.08)",
//             border: "1px solid rgba(34,197,94,0.25)",
//             color: "#16a34a",
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           ✓ Submitted — awaiting admin confirmation.
//         </div>
//       ) : (
//         <>
//           <div
//             style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}
//           >
//             {!isAgent && (
//               <ElegantButton
//                 size="sm"
//                 onClick={() =>
//                   onNavigate(`/payment/${due.bookingId}?milestone=${due.id}`)
//                 }
//               >
//                 💳 Pay Online
//               </ElegantButton>
//             )}
//             {isAgent && (
//               <ElegantButton
//                 size="sm"
//                 onClick={() => onSendLink(due.bookingId, due.id)}
//                 loading={isSendingThis}
//               >
//                 ✉️ Send Payment Link
//               </ElegantButton>
//             )}
//             <ElegantButton
//               size="sm"
//               variant="secondary"
//               onClick={() => setShowManual((s) => !s)}
//             >
//               🏦 {showManual ? "Cancel" : "Record Manual Payment"}
//             </ElegantButton>
//           </div>

//           {showManual && (
//             <ManualPaymentInline
//               amountDue={due.displayAmount}
//               fmtExact={fmtExact}
//               submitting={submitting}
//               onSubmit={handleManualSubmit}
//               onCancel={() => setShowManual(false)}
//             />
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// // ── Dues Banner ─────────────────────────────────────────────
// const DuesBanner = ({
//   milestoneMap,
//   fmtExact,
//   onNavigate,
//   primaryColor,
//   isAgent,
//   onSendLink,
//   onManualSubmit,
//   sendingLinkKey,
// }) => {
//   const dues = Object.entries(milestoneMap)
//     .flatMap(([bookingId, data]) =>
//       (data.milestones || [])
//         .filter((m) => m.status === "pending" || m.status === "overdue")
//         .map((m) => ({ ...m, bookingId, displayAmount: msAmount(m) })),
//     )
//     .sort((a, b) => {
//       if (!a.due_date && !b.due_date) return 0;
//       if (!a.due_date) return 1;
//       if (!b.due_date) return -1;
//       return new Date(a.due_date) - new Date(b.due_date);
//     });

//   if (!dues.length) return null;
//   const overdueCount = dues.filter((d) => d.status === "overdue").length;
//   const accentColor = overdueCount > 0 ? "#dc2626" : "#d97706";

//   return (
//     <div className="dues-banner">
//       <ElegantCard hover>
//         <div className="dues-banner-header">
//           <div className="dues-banner-title" style={{ color: accentColor }}>
//             <span style={{ fontSize: 20 }}>⏰</span>
//             Upcoming Payments
//             {overdueCount > 0 && (
//               <span className="dues-banner-badge">{overdueCount} overdue</span>
//             )}
//           </div>
//           <div className="dues-banner-count">
//             {dues.length} payment{dues.length > 1 ? "s" : ""} remaining
//           </div>
//         </div>
//         <div className="dues-list">
//           {dues.map((d, i) => (
//             <DueItemRow
//               key={i}
//               due={d}
//               fmtExact={fmtExact}
//               onNavigate={onNavigate}
//               isAgent={isAgent}
//               onSendLink={onSendLink}
//               onManualSubmit={onManualSubmit}
//               sendingLinkKey={sendingLinkKey}
//               accentColor={d.status === "overdue" ? "#dc2626" : "#d97706"}
//             />
//           ))}
//         </div>
//       </ElegantCard>
//     </div>
//   );
// };

// // ── Booking Card ────────────────────────────────────────────
// const BookingCard = ({
//   booking,
//   onPay,
//   onCancel,
//   onSendPaymentLink,
//   onManualSubmit,
//   sendingLinkKey,
//   isAgent,
//   fmtExact,
//   token,
//   primaryColor,
//   milestoneMap,
//   tenant,
// }) => {
//   const [expanded, setExpanded] = useState(false);
//   const [cancelling, setCancelling] = useState(false);
//   const [confirmCancel, setConfirmCancel] = useState(false);

//   const [showManualForm, setShowManualForm] = useState(false);
//   const [manualSubmitting, setManualSubmitting] = useState(false);
//   const [manualSubmitted, setManualSubmitted] = useState(false);

//   const isRefunded = booking.booking_status === "refunded";
//   const cfg = STATUS_CFG[booking.booking_status] || STATUS_CFG.pending;
//   const plan = booking.payment_plan;
//   const isConfirmed = booking.booking_status === "confirmed";
//   const isPending = booking.booking_status === "pending";

//   const paidMilestones = (booking.milestones || []).filter(
//     (m) => m.status === "paid",
//   );
//   const refundedMilestones = (booking.milestones || []).filter(
//     (m) => m.status === "refunded",
//   );
//   const paidTotal = paidMilestones.reduce((sum, m) => sum + msAmount(m), 0);
//   const refundedTotal = refundedMilestones.reduce(
//     (sum, m) => sum + msAmount(m),
//     0,
//   );
//   const allMilestones = booking.milestones || [];
//   const totalFromMs = allMilestones.reduce((sum, m) => sum + msAmount(m), 0);
//   const grandTotal = parseFloat(booking.total_amount || 0) || totalFromMs;

//   const displayAmt = (() => {
//     if (isRefunded) return refundedTotal;
//     if (isConfirmed && paidTotal > 0) return paidTotal;
//     if (isConfirmed) return grandTotal;
//     const dp = parseFloat(booking.down_payment_amount || 0);
//     if (dp > 0) return dp;
//     return grandTotal;
//   })();

//   const amountLabel = isRefunded
//     ? "Refunded Amount"
//     : isPending
//       ? "Down Payment Due"
//       : isConfirmed && paidTotal > 0
//         ? `Paid (${paidMilestones.length} milestone${paidMilestones.length > 1 ? "s" : ""})`
//         : isConfirmed
//           ? "Total Amount"
//           : "Amount";

//   // Resolve which milestone / amount a manual payment (or a send-payment-link
//   // click) recorded here applies to. Defined before use below.
//   const getManualTarget = () => {
//     const msData = milestoneMap?.[booking.id];
//     const firstPending = msData?.milestones?.find(
//       (m) => m.status === "pending" || m.status === "overdue",
//     );
//     const amount = firstPending
//       ? msAmount(firstPending)
//       : parseFloat(booking.down_payment_amount || booking.total_amount || 0);
//     return { milestoneId: firstPending?.id || null, amount };
//   };

//   // Compute the composite key AFTER getManualTarget exists, so we can
//   // correctly scope the "sending" spinner to this specific booking+milestone.
//   const { milestoneId: resolvedMilestoneId } = getManualTarget();
//   const isSendingThisLink =
//     sendingLinkKey === `${booking.id}-${resolvedMilestoneId || "main"}`;

//   return (
//     <ElegantCard hover>
//       <div className="booking-card-header">
//         <div className="booking-card-info">
//           <div className="booking-card-title">
//             <span className="booking-card-unit">
//               Unit {booking.plot_number}
//             </span>
//             <span
//               className="booking-card-status"
//               style={{
//                 background: cfg.bg,
//                 color: cfg.color,
//                 border: `1px solid ${cfg.color}33`,
//               }}
//             >
//               {cfg.label}
//             </span>
//           </div>
//           <div className="booking-card-details">
//             <span>{booking.plot_type}</span>
//             {booking.area && <span>· {booking.area} sqft</span>}
//             {booking.direction && <span>· {booking.direction}</span>}
//           </div>
//           {isAgent && (booking.client_name || booking.client_phone) && (
//             <div
//               className="booking-card-client"
//               style={{
//                 background: `${primaryColor}06`,
//                 border: `1px solid ${primaryColor}18`,
//               }}
//             >
//               <span style={{ color: "var(--text-muted)" }}>Client: </span>
//               <span style={{ color: primaryColor, fontWeight: 600 }}>
//                 {booking.client_name}
//               </span>
//               {booking.client_phone && (
//                 <span style={{ color: "var(--text-muted)" }}>
//                   {" "}
//                   · {booking.client_phone}
//                 </span>
//               )}
//               {booking.client_email && (
//                 <span style={{ color: "var(--text-muted)" }}>
//                   {" "}
//                   · {booking.client_email}
//                 </span>
//               )}
//             </div>
//           )}
//           <div className="booking-card-id">
//             #{booking.id} ·{" "}
//             {new Date(booking.created_at).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//               year: "numeric",
//             })}
//           </div>
//         </div>

//         <div className="booking-card-amount">
//           <div className="booking-card-amount-label">{amountLabel}</div>
//           <div
//             className="booking-card-amount-value"
//             style={{ color: isRefunded ? "#94a3b8" : primaryColor }}
//           >
//             {isRefunded ? `−${fmtExact(displayAmt)}` : fmtExact(displayAmt)}
//           </div>
//           {isConfirmed && plan && paidTotal > 0 && !isRefunded && (
//             <>
//               {refundedTotal > 0 && (
//                 <div
//                   className="booking-card-refunded"
//                   style={{
//                     fontSize: 12,
//                     color: "#94a3b8",
//                     marginTop: 4,
//                     fontWeight: 600,
//                   }}
//                 >
//                   Refunded: {fmtExact(refundedTotal)}
//                 </div>
//               )}
//               {grandTotal - paidTotal - refundedTotal > 0.01 && (
//                 <div className="booking-card-balance">
//                   Balance: {fmtExact(grandTotal - paidTotal - refundedTotal)}
//                 </div>
//               )}
//             </>
//           )}
//           {isConfirmed &&
//             plan &&
//             paidTotal > 0 &&
//             !isRefunded &&
//             grandTotal - paidTotal - refundedTotal <= 0.01 &&
//             refundedTotal === 0 && (
//               <div className="booking-card-paid">✓ Fully paid (incl. tax)</div>
//             )}
//           {isConfirmed &&
//             plan &&
//             refundedTotal > 0 &&
//             grandTotal - paidTotal - refundedTotal <= 0.01 && (
//               <div
//                 className="booking-card-refunded"
//                 style={{
//                   fontSize: 12,
//                   color: "#94a3b8",
//                   marginTop: 4,
//                   fontWeight: 600,
//                 }}
//               >
//                 ✓ Fully Refunded
//               </div>
//             )}
//           {isPending && grandTotal > 0 && (
//             <div className="booking-card-grand-total">
//               Grand total: {fmtExact(grandTotal)}
//             </div>
//           )}
//         </div>
//       </div>

//       {isAgent && booking.commission_amount && (
//         <div
//           className="booking-card-commission"
//           style={{
//             background: `${primaryColor}06`,
//             border: `1px solid ${primaryColor}18`,
//           }}
//         >
//           <span className="booking-card-commission-label">Commission:</span>
//           <span className="booking-card-commission-value">
//             {fmtExact(booking.commission_amount)}
//           </span>
//           {booking.commission_status &&
//             (() => {
//               const cs =
//                 COMM_CFG[booking.commission_status] || COMM_CFG.pending;
//               return (
//                 <span
//                   className="booking-card-commission-status"
//                   style={{ color: cs.color }}
//                 >
//                   {cs.label}
//                 </span>
//               );
//             })()}
//         </div>
//       )}

//       <div className="booking-card-actions">
//         {isPending && !isAgent && (
//           <ElegantButton
//             onClick={() => {
//               const { milestoneId } = getManualTarget();
//               onPay(booking.id, milestoneId);
//             }}
//             size="sm"
//           >
//             💳 Complete Payment
//           </ElegantButton>
//         )}
//         {isPending && isAgent && (
//           <ElegantButton
//             onClick={() => {
//               const { milestoneId } = getManualTarget();
//               onSendPaymentLink(booking.id, milestoneId);
//             }}
//             size="sm"
//             loading={isSendingThisLink}
//           >
//             ✉️ Send Payment Link
//           </ElegantButton>
//         )}
//         {isPending && !manualSubmitted && (
//           <ElegantButton
//             variant="secondary"
//             onClick={() => setShowManualForm((s) => !s)}
//             size="sm"
//           >
//             🏦 {showManualForm ? "Cancel" : "Record Manual Payment"}
//           </ElegantButton>
//         )}
//         <ElegantButton
//           variant="secondary"
//           onClick={() => setExpanded((e) => !e)}
//           size="sm"
//         >
//           {expanded ? "▲ Less" : "▼ Payment Schedule"}
//         </ElegantButton>
//         {isPending && !confirmCancel && !isRefunded && (
//           <ElegantButton
//             variant="ghost"
//             onClick={() => setConfirmCancel(true)}
//             size="sm"
//           >
//             ✕ Cancel
//           </ElegantButton>
//         )}
//         {isPending && confirmCancel && !isRefunded && (
//           <div className="booking-card-cancel-confirm">
//             <span className="booking-card-cancel-text">Are you sure?</span>
//             <ElegantButton
//               variant="secondary"
//               onClick={async () => {
//                 setCancelling(true);
//                 await onCancel(booking.id);
//                 setCancelling(false);
//                 setConfirmCancel(false);
//               }}
//               size="sm"
//               loading={cancelling}
//             >
//               Yes, Cancel
//             </ElegantButton>
//             <ElegantButton
//               variant="ghost"
//               onClick={() => setConfirmCancel(false)}
//               size="sm"
//             >
//               No
//             </ElegantButton>
//           </div>
//         )}
//       </div>

//       {showManualForm && !manualSubmitted && (
//         <ManualPaymentInline
//           amountDue={getManualTarget().amount}
//           fmtExact={fmtExact}
//           submitting={manualSubmitting}
//           onSubmit={async (payload) => {
//             const { milestoneId, amount } = getManualTarget();
//             setManualSubmitting(true);
//             const ok = await onManualSubmit(booking.id, milestoneId, {
//               ...payload,
//               amount,
//             });
//             setManualSubmitting(false);
//             if (ok) {
//               setManualSubmitted(true);
//               setShowManualForm(false);
//             }
//           }}
//           onCancel={() => setShowManualForm(false)}
//         />
//       )}
//       {manualSubmitted && (
//         <div
//           style={{
//             marginTop: 8,
//             padding: "8px 12px",
//             borderRadius: 10,
//             background: "rgba(34,197,94,0.08)",
//             border: "1px solid rgba(34,197,94,0.25)",
//             color: "#16a34a",
//             fontSize: 12,
//             fontWeight: 600,
//           }}
//         >
//           ✓ Manual payment submitted — awaiting admin confirmation.
//         </div>
//       )}

//       {isPending && isAgent && !booking.client_email && (
//         <div
//           style={{
//             marginTop: 8,
//             fontSize: 11,
//             color: "#d97706",
//             fontStyle: "italic",
//           }}
//         >
//           ⚠ No client email on file for this booking — the link will be sent
//           once an email is added.
//         </div>
//       )}

//       {expanded && (
//         <div className="booking-card-expanded">
//           <MilestoneTracker
//             bookingId={booking.id}
//             token={token}
//             fmtExact={fmtExact}
//             booking={booking}
//             primaryColor={primaryColor}
//             tenant={tenant}
//           />
//         </div>
//       )}
//     </ElegantCard>
//   );
// };

// // ── Profile Panel ───────────────────────────────────────────
// const ProfilePanel = ({ user, onSaved, showToast, primaryColor, tenant }) => {
//   const [form, setForm] = useState({
//     name: user.name || "",
//     phone: user.phone || "",
//     current_password: "",
//     new_password: "",
//     confirm_password: "",
//   });
//   const [saving, setSaving] = useState(false);

//   const handleSave = async () => {
//     if (form.new_password && form.new_password !== form.confirm_password) {
//       showToast("⚠️ New passwords do not match", "warning", 3500);
//       return;
//     }
//     setSaving(true);
//     try {
//       const payload = { name: form.name, phone: form.phone };
//       if (form.new_password) {
//         payload.current_password = form.current_password;
//         payload.new_password = form.new_password;
//       }

//       const result = await apiJson(tenant, `/user/profile`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${user.token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       showToast("✅ Profile updated successfully", "success", 3500);
//       setForm((f) => ({
//         ...f,
//         current_password: "",
//         new_password: "",
//         confirm_password: "",
//       }));
//       onSaved({ ...user, name: form.name, phone: form.phone });
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//     setSaving(false);
//   };

//   const isAgent = user.role === "broker" || user.role === "sales";

//   return (
//     <div className="profile-panel">
//       <ElegantCard>
//         <div className="profile-header">
//           <div
//             className="profile-avatar"
//             style={{
//               background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//               boxShadow: `0 4px 14px ${primaryColor}30`,
//             }}
//           >
//             {user.name?.[0]?.toUpperCase()}
//           </div>
//           <div className="profile-info">
//             <div className="profile-name">{user.name}</div>
//             <div className="profile-email">{user.email}</div>
//             <div className="profile-role" style={{ color: primaryColor }}>
//               {isAgent
//                 ? `${roleLabel(user.role)}${user.broker_company ? " · " + user.broker_company : ""}`
//                 : "Buyer"}
//             </div>
//           </div>
//         </div>

//         {isAgent && (
//           <div className="profile-broker-stats">
//             {[
//               {
//                 label: "Commission Rate",
//                 value: `${user.commission_rate || 2}%`,
//               },
//               {
//                 label: "Account Status",
//                 value: user.status || "active",
//                 color: user.status === "active" ? "#16a34a" : "#dc2626",
//               },
//             ].map(({ label, value, color }) => (
//               <div
//                 key={label}
//                 className="profile-broker-stat"
//                 style={{
//                   background: `${primaryColor}06`,
//                   border: `1px solid ${primaryColor}15`,
//                 }}
//               >
//                 <div className="profile-broker-stat-label">{label}</div>
//                 <div
//                   className="profile-broker-stat-value"
//                   style={{ color: color || primaryColor }}
//                 >
//                   {value}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         <div className="profile-section-title">Edit Profile</div>

//         <input
//           type="text"
//           placeholder="Full Name *"
//           value={form.name}
//           onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
//           className="profile-input"
//         />
//         <input
//           value={user.email}
//           readOnly
//           placeholder="Email"
//           className="profile-input profile-input-readonly"
//         />
//         <input
//           type="tel"
//           placeholder="Phone Number"
//           value={form.phone}
//           onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
//           className="profile-input"
//         />

//         <div className="profile-password-title">
//           Change Password (leave blank to keep current)
//         </div>
//         <input
//           type="password"
//           placeholder="Current Password"
//           value={form.current_password}
//           onChange={(e) =>
//             setForm((f) => ({ ...f, current_password: e.target.value }))
//           }
//           className="profile-input"
//         />
//         <div className="profile-password-grid">
//           <input
//             type="password"
//             placeholder="New Password"
//             value={form.new_password}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, new_password: e.target.value }))
//             }
//             className="profile-input"
//           />
//           <input
//             type="password"
//             placeholder="Confirm Password"
//             value={form.confirm_password}
//             onChange={(e) =>
//               setForm((f) => ({ ...f, confirm_password: e.target.value }))
//             }
//             className="profile-input"
//           />
//         </div>

//         <ElegantButton
//           onClick={handleSave}
//           disabled={saving || !form.name}
//           loading={saving}
//           size="lg"
//           style={{ width: "100%", marginTop: 8 }}
//         >
//           Save Changes →
//         </ElegantButton>
//       </ElegantCard>
//     </div>
//   );
// };

// // ── Agent Stats (broker or sales) ───────────────────────────
// const AgentStats = ({ bookings, fmtExact, primaryColor }) => {
//   const commPending = bookings
//     .filter((b) => b.commission_status === "pending")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
//   const commApproved = bookings
//     .filter((b) => b.commission_status === "approved")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
//   const commPaid = bookings
//     .filter((b) => b.commission_status === "paid")
//     .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);

//   return (
//     <div className="broker-stats">
//       {[
//         {
//           label: "Pending Commission",
//           value: fmtExact(commPending),
//           color: "#d97706",
//           icon: "⏳",
//         },
//         {
//           label: "Approved Commission",
//           value: fmtExact(commApproved),
//           color: "#2563eb",
//           icon: "✓",
//         },
//         {
//           label: "Commission Paid",
//           value: fmtExact(commPaid),
//           color: "#16a34a",
//           icon: "💰",
//         },
//         {
//           label: "Total Clients",
//           value: bookings.length,
//           color: primaryColor,
//           icon: "👥",
//         },
//       ].map(({ label, value, color, icon }) => (
//         <div key={label} className="broker-stat-card">
//           <div className="broker-stat-content">
//             <span className="broker-stat-icon">{icon}</span>
//             <div className="broker-stat-value" style={{ color }}>
//               {value}
//             </div>
//           </div>
//           <div className="broker-stat-label">{label}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// // ── Notifications Tab ──────────────────────────────────────
// const NOTIF_CFG = {
//   payment_reminder: { color: "#d97706", label: "Payment Reminder" },
//   booking_confirmed: { color: "#16a34a", label: "Booking Confirmed" },
//   booking_cancelled: { color: "#dc2626", label: "Booking Cancelled" },
//   project_launch: { color: null, label: "Project Launch" },
//   offer: { color: "#7c3aed", label: "Special Offer" },
//   general: { color: null, label: "General" },
// };

// const NotificationModal = ({
//   notif,
//   onClose,
//   onMarkRead,
//   onNavigate,
//   onSwitchToBookings,
//   primaryColor,
// }) => {
//   const cfg = notif
//     ? { ...(NOTIF_CFG[notif.type] || NOTIF_CFG.general) }
//     : NOTIF_CFG.general;
//   if (!cfg.color) cfg.color = primaryColor;

//   useEffect(() => {
//     if (!notif) return;
//     if (!notif.is_read) onMarkRead(notif.id);
//     const onKey = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [notif?.id, onMarkRead, onClose]);

//   if (!notif) return null;

//   const timeAgo = (dateStr) => {
//     const diff = Date.now() - new Date(dateStr).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 1) return "Just now";
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     const d = Math.floor(h / 24);
//     return d < 7
//       ? `${d}d ago`
//       : new Date(dateStr).toLocaleDateString("en-IN", {
//           day: "numeric",
//           month: "short",
//           year: "numeric",
//         });
//   };

//   const handleViewBooking = () => {
//     onClose();
//     if (notif.type === "payment_reminder")
//       onNavigate(`/payment/${notif.booking_id}`);
//     else onSwitchToBookings(notif.booking_id);
//   };

//   return (
//     <div onClick={onClose} className="notification-modal-overlay">
//       <div
//         onClick={(e) => e.stopPropagation()}
//         className="notification-modal"
//         style={{ borderTopColor: cfg.color }}
//       >
//         <div className="notification-modal-header">
//           <div
//             className="notification-modal-icon"
//             style={{
//               background: `${cfg.color}12`,
//               borderColor: `${cfg.color}25`,
//             }}
//           >
//             🔔
//           </div>
//           <div className="notification-modal-info">
//             <div className="notification-modal-title">{notif.title}</div>
//             <div className="notification-modal-meta">
//               <span
//                 className="notification-modal-category"
//                 style={{ background: `${cfg.color}12`, color: cfg.color }}
//               >
//                 {cfg.label}
//               </span>
//               <span className="notification-modal-time">
//                 {timeAgo(notif.created_at)}
//               </span>
//             </div>
//           </div>
//           <button onClick={onClose} className="notification-modal-close">
//             ×
//           </button>
//         </div>
//         <div className="notification-modal-body">
//           <div className="notification-modal-message">{notif.message}</div>
//           <div className="notification-modal-actions">
//             {notif.booking_id && (
//               <ElegantButton onClick={handleViewBooking}>
//                 {notif.type === "payment_reminder"
//                   ? "Complete Payment →"
//                   : "View Booking →"}
//               </ElegantButton>
//             )}
//             <ElegantButton variant="secondary" onClick={onClose}>
//               Close
//             </ElegantButton>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const NotificationsTab = ({
//   notifications,
//   loading,
//   unreadCount,
//   onMarkRead,
//   onMarkAllRead,
//   onNavigate,
//   onSwitchToBookings,
//   primaryColor,
//   tenant,
// }) => {
//   const [filter, setFilter] = useState("all");
//   const [selectedNotif, setSelectedNotif] = useState(null);

//   const filtered = notifications.filter((n) => {
//     if (filter === "unread") return !n.is_read;
//     if (filter === "read") return n.is_read;
//     return true;
//   });

//   const timeAgo = (dateStr) => {
//     const diff = Date.now() - new Date(dateStr).getTime();
//     const m = Math.floor(diff / 60000);
//     if (m < 1) return "Just now";
//     if (m < 60) return `${m}m ago`;
//     const h = Math.floor(m / 60);
//     if (h < 24) return `${h}h ago`;
//     const d = Math.floor(h / 24);
//     if (d < 7) return `${d}d ago`;
//     return new Date(dateStr).toLocaleDateString("en-IN", {
//       day: "numeric",
//       month: "short",
//     });
//   };

//   if (loading)
//     return (
//       <div className="dashboard-loading">
//         <div className="dashboard-loading-icon">⏳</div>
//         <div className="dashboard-loading-text">Loading notifications...</div>
//       </div>
//     );

//   return (
//     <div className="notifications-tab">
//       {selectedNotif && (
//         <NotificationModal
//           notif={selectedNotif}
//           onClose={() => setSelectedNotif(null)}
//           onMarkRead={onMarkRead}
//           onNavigate={onNavigate}
//           onSwitchToBookings={onSwitchToBookings}
//           primaryColor={primaryColor}
//         />
//       )}
//       <div className="notifications-filter">
//         <div className="notifications-filter-group">
//           {[
//             ["all", "All"],
//             ["unread", "Unread"],
//             ["read", "Read"],
//           ].map(([val, label]) => (
//             <button
//               key={val}
//               onClick={() => setFilter(val)}
//               className={`notifications-filter-btn ${filter === val ? "notifications-filter-active" : "notifications-filter-inactive"}`}
//             >
//               {label}
//               {val === "unread" && unreadCount > 0 && (
//                 <span
//                   className="notifications-badge"
//                   style={{ background: "#d97706", color: "#fff" }}
//                 >
//                   {unreadCount}
//                 </span>
//               )}
//             </button>
//           ))}
//         </div>
//         {unreadCount > 0 && (
//           <ElegantButton variant="secondary" onClick={onMarkAllRead} size="sm">
//             ✓ Mark all read
//           </ElegantButton>
//         )}
//       </div>

//       {filtered.length === 0 && (
//         <div className="dashboard-empty">
//           <div className="dashboard-empty-icon">🔔</div>
//           <div className="dashboard-empty-title">
//             {filter === "unread"
//               ? "No unread notifications"
//               : "No notifications yet"}
//           </div>
//           <div className="dashboard-empty-subtitle">
//             Payment reminders and booking updates will appear here.
//           </div>
//         </div>
//       )}

//       <div className="notifications-list">
//         {filtered.map((n) => {
//           const cfg = { ...(NOTIF_CFG[n.type] || NOTIF_CFG.general) };
//           if (!cfg.color) cfg.color = primaryColor;
//           return (
//             <div
//               key={n.id}
//               onClick={() => setSelectedNotif(n)}
//               className={`notification-item ${n.is_read ? "notification-item-read" : "notification-item-unread"}`}
//             >
//               {!n.is_read && (
//                 <div
//                   className="notification-dot"
//                   style={{ background: cfg.color }}
//                 />
//               )}
//               <div className="notification-content">
//                 <div className="notification-header">
//                   <span
//                     className={`notification-title ${n.is_read ? "notification-title-normal" : "notification-title-bold"}`}
//                   >
//                     {n.title}
//                   </span>
//                   <span
//                     className="notification-category"
//                     style={{ background: `${cfg.color}12`, color: cfg.color }}
//                   >
//                     {cfg.label}
//                   </span>
//                 </div>
//                 <div className="notification-message">
//                   {n.message.length > 100
//                     ? n.message.slice(0, 100) + "…"
//                     : n.message}
//                 </div>
//                 <div className="notification-footer">
//                   <span className="notification-time">
//                     {timeAgo(n.created_at)}
//                   </span>
//                   <span
//                     className="notification-action"
//                     style={{ color: cfg.color }}
//                   >
//                     Click to read →
//                   </span>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Feedback Tab ────────────────────────────────────────────
// const CATEGORY_CFG = {
//   general: { color: "#6b7280" },
//   service: { color: "#2563eb" },
//   unit: { color: null },
//   payment: { color: "#d97706" },
//   staff: { color: "#7c3aed" },
// };

// const StarRating = ({ value, onChange, primaryColor }) => (
//   <div className="feedback-rating-stars">
//     {[1, 2, 3, 4, 5].map((s) => (
//       <button
//         key={s}
//         type="button"
//         onClick={() => onChange(s)}
//         className="feedback-star"
//         style={{ color: s <= value ? primaryColor : "var(--card-border)" }}
//       >
//         ★
//       </button>
//     ))}
//   </div>
// );

// const FeedbackTab = ({
//   feedbacks,
//   bookings,
//   token,
//   onSubmitted,
//   showToast,
//   primaryColor,
//   tenant,
// }) => {
//   const [showForm, setShowForm] = useState(false);
//   const [form, setForm] = useState({
//     rating: 5,
//     category: "general",
//     subject: "",
//     message: "",
//     booking_id: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   const handleSubmit = async () => {
//     if (!form.subject.trim() || !form.message.trim()) {
//       showToast("⚠️ Subject and message are required", "warning", 3500);
//       return;
//     }
//     setSubmitting(true);
//     try {
//       const result = await apiJson(tenant, `/feedback`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           ...form,
//           booking_id: form.booking_id || undefined,
//         }),
//       });

//       showToast(
//         "🙏 Thank you! Your feedback has been submitted",
//         "success",
//         4000,
//       );
//       setForm({
//         rating: 5,
//         category: "general",
//         subject: "",
//         message: "",
//         booking_id: "",
//       });
//       setShowForm(false);
//       onSubmitted(result.feedback);
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//     setSubmitting(false);
//   };

//   const confirmedBookings = bookings.filter(
//     (b) => b.booking_status === "confirmed",
//   );

//   return (
//     <div>
//       <div className="feedback-header">
//         <div>
//           <div className="feedback-title">Your Feedback</div>
//           <div className="feedback-subtitle">Share your experience with us</div>
//         </div>
//         <ElegantButton onClick={() => setShowForm((f) => !f)}>
//           {showForm ? "✕ Cancel" : "+ New Feedback"}
//         </ElegantButton>
//       </div>

//       {showForm && (
//         <div className="feedback-form">
//           <ElegantCard>
//             <div className="feedback-form-title">New Feedback</div>

//             <div className="feedback-rating">
//               <div className="feedback-rating-label">Rating *</div>
//               <StarRating
//                 value={form.rating}
//                 onChange={(r) => setForm((f) => ({ ...f, rating: r }))}
//                 primaryColor={primaryColor}
//               />
//               <div className="feedback-rating-text">
//                 {
//                   ["", "Very Poor", "Poor", "Average", "Good", "Excellent"][
//                     form.rating
//                   ]
//                 }
//               </div>
//             </div>

//             <div className="feedback-category">
//               <div className="feedback-category-label">Category *</div>
//               <div className="feedback-category-group">
//                 {Object.entries(CATEGORY_CFG).map(([cat, cfg]) => {
//                   const catColor = cfg.color || primaryColor;
//                   const isActive = form.category === cat;
//                   return (
//                     <button
//                       key={cat}
//                       type="button"
//                       onClick={() => setForm((f) => ({ ...f, category: cat }))}
//                       className={`feedback-category-btn ${isActive ? "feedback-category-active" : "feedback-category-inactive"}`}
//                     >
//                       {cat}
//                     </button>
//                   );
//                 })}
//               </div>
//             </div>

//             {confirmedBookings.length > 0 && (
//               <select
//                 value={form.booking_id}
//                 onChange={(e) =>
//                   setForm((f) => ({ ...f, booking_id: e.target.value }))
//                 }
//                 className="feedback-select"
//               >
//                 <option value="">Select booking (optional)</option>
//                 {confirmedBookings.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     Unit {b.plot_number} — Booking #{b.id}
//                   </option>
//                 ))}
//               </select>
//             )}

//             <input
//               type="text"
//               placeholder="Subject *"
//               value={form.subject}
//               onChange={(e) =>
//                 setForm((f) => ({ ...f, subject: e.target.value }))
//               }
//               className="feedback-input"
//             />

//             <textarea
//               placeholder="Your message..."
//               value={form.message}
//               onChange={(e) =>
//                 setForm((f) => ({ ...f, message: e.target.value }))
//               }
//               rows={4}
//               className="feedback-textarea"
//             />

//             <div className="feedback-actions">
//               <ElegantButton onClick={handleSubmit} loading={submitting}>
//                 Submit Feedback →
//               </ElegantButton>
//               <ElegantButton
//                 variant="secondary"
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </ElegantButton>
//             </div>
//           </ElegantCard>
//         </div>
//       )}

//       {feedbacks.length === 0 && !showForm && (
//         <div className="feedback-empty">
//           <div className="feedback-empty-icon">💬</div>
//           <div className="feedback-empty-title">No feedback yet</div>
//           <div className="feedback-empty-text">
//             Share your experience to help us improve.
//           </div>
//         </div>
//       )}

//       <div className="feedback-list">
//         {feedbacks.map((fb) => {
//           const catColor = CATEGORY_CFG[fb.category]?.color || primaryColor;
//           const ratingColor =
//             fb.rating >= 4 ? "#16a34a" : fb.rating >= 3 ? "#d97706" : "#dc2626";
//           const statusColor =
//             fb.status === "resolved"
//               ? "#16a34a"
//               : fb.status === "reviewed"
//                 ? "#2563eb"
//                 : "#d97706";
//           return (
//             <div key={fb.id} className="feedback-card">
//               <div className="feedback-card-header">
//                 <div className="feedback-card-info">
//                   <div className="feedback-card-tags">
//                     <span className="feedback-card-subject">{fb.subject}</span>
//                     <span
//                       className="feedback-card-category"
//                       style={{ background: `${catColor}12`, color: catColor }}
//                     >
//                       {fb.category}
//                     </span>
//                     <span
//                       className="feedback-card-status"
//                       style={{
//                         background: `${statusColor}12`,
//                         color: statusColor,
//                       }}
//                     >
//                       {fb.status}
//                     </span>
//                   </div>
//                   <div className="feedback-card-date">
//                     {fb.booking ? `Unit ${fb.booking.plot_number} · ` : ""}
//                     {new Date(fb.created_at).toLocaleDateString("en-IN", {
//                       day: "numeric",
//                       month: "short",
//                       year: "numeric",
//                     })}
//                   </div>
//                 </div>
//                 <div
//                   className="feedback-card-rating"
//                   style={{ color: ratingColor }}
//                 >
//                   {"★".repeat(fb.rating)}
//                 </div>
//               </div>
//               <div className="feedback-card-message">{fb.message}</div>
//               {fb.admin_reply && (
//                 <div
//                   className="feedback-card-reply"
//                   style={{
//                     background: "#16a34a08",
//                     border: "1px solid #16a34a20",
//                   }}
//                 >
//                   <div
//                     className="feedback-card-reply-title"
//                     style={{ color: "#16a34a" }}
//                   >
//                     Admin Reply
//                   </div>
//                   <div className="feedback-card-reply-text">
//                     {fb.admin_reply}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// // ── Main Dashboard ──────────────────────────────────────────
// export default function UserDashboard() {
//   // const navigate = useNavigate();
//   // const dispatch = useDispatch();
//   // const user = useSelector(selectUser);
//   const navigate = useNavigate();
//   const { user, updateUser, signOut } = useAuth();

//   const { settings } = useSettings();
//   const { tenant } = useParams();

//   const primaryColor = settings?.primary_color || "#c9a96e";

//   const [bookings, setBookings] = useState([]);
//   const [milestoneMap, setMilestoneMap] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [activeTab, setActiveTab] = useState("bookings");
//   const [notifications, setNotifications] = useState([]);
//   const [notifsLoading, setNotifsLoading] = useState(false);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [feedbacks, setFeedbacks] = useState([]);
//   const [payments, setPayments] = useState([]);
//   const [paymentsLoading, setPaymentsLoading] = useState(false);
//   const [unreadMessages, setUnreadMessages] = useState(0);
//   const [invoices, setInvoices] = useState([]);
//   const [invoiceCount, setInvoiceCount] = useState(0);

//   // Single source of truth for "which booking+milestone is currently
//   // sending a payment link" — composite key avoids all buttons on the
//   // same booking lighting up together.
//   const [sendingLinkKey, setSendingLinkKey] = useState(null);

//   const { showToast } = useToast();
//   const {
//     wishlist,
//     wishedIds,
//     toggle: toggleWishRaw,
//     loading: wishLoading,
//   } = useWishlist(tenant, user?.token);

//   const handleWishlistToggle = useCallback(
//     async (plotId) => {
//       const wasWished =
//         wishedIds instanceof Set && wishedIds.has(Number(plotId));
//       await toggleWishRaw(Number(plotId));
//       showToast(
//         wasWished ? "🤍 Removed from Wishlist" : "❤️ Added to Wishlist",
//         wasWished ? "wishlist_remove" : "wishlist_add",
//         2800,
//       );
//     },
//     [wishedIds, toggleWishRaw, showToast],
//   );

//   const [currency, setCurrency] = useState({
//     symbol: "₹",
//     code: "INR",
//     position: "before",
//   });

//   const fmt = useCallback(
//     (n) => makeFmt(currency.symbol, currency.position)(n),
//     [currency],
//   );
//   const fmtExact = useCallback(
//     (n) => makeFmtExact(currency.symbol, currency.position)(n),
//     [currency],
//   );

//   const isAgent = user?.role === "broker" || user?.role === "sales";

//   // ── Refresh the logged-in user's own record from the server ─────────
//   const fetchCurrentUser = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const fresh = await apiJson(tenant, `/user/me`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       // dispatch(setUser({ ...user, ...fresh, token: user.token }));
//       updateUser(fresh);
//     } catch (_) {
//       // Non-fatal — dashboard still works with the cached user object.
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, user?.token]);

//   const fetchMilestones = useCallback(
//     async (bookingsList) => {
//       const targets = bookingsList.filter(
//         (b) =>
//           (b.booking_status === "confirmed" ||
//             b.booking_status === "pending") &&
//           b.payment_plan_id,
//       );
//       if (!targets.length || !tenant) return;

//       const results = await Promise.all(
//         targets.map((b) =>
//           apiJson(tenant, `/bookings/${b.id}/milestones`, {
//             headers: {
//               Authorization: `Bearer ${user?.token}`,
//               Accept: "application/json",
//             },
//           }).catch(() => null),
//         ),
//       );
//       const map = {};
//       targets.forEach((b, i) => {
//         if (results[i]) map[b.id] = results[i];
//       });
//       setMilestoneMap(map);
//     },
//     [user?.token, tenant],
//   );

//   const switchToBookings = useCallback(
//     (bookingId) => {
//       setActiveTab("bookings");
//       if (!bookingId) return;
//       setTimeout(() => {
//         const el = document.getElementById(`booking-card-${bookingId}`);
//         if (el) {
//           el.scrollIntoView({ behavior: "smooth", block: "center" });
//           el.style.boxShadow = `0 0 0 2px ${primaryColor}, 0 0 24px ${primaryColor}30`;
//           el.style.transition = "box-shadow 0.3s";
//           setTimeout(() => {
//             el.style.boxShadow = "";
//           }, 3000);
//         }
//       }, 150);
//     },
//     [primaryColor],
//   );

//   const fetchInvoices = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const data = await apiJson(tenant, `/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//           Accept: "application/json",
//         },
//       });

//       let invoicesList = [];
//       if (data.success && Array.isArray(data.invoices)) {
//         invoicesList = data.invoices;
//       } else if (Array.isArray(data)) {
//         invoicesList = data;
//       }

//       setInvoices(invoicesList);
//       setInvoiceCount(invoicesList.length);
//     } catch (_) {}
//   }, [tenant, user?.token]);

//   const fetchBookings = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setLoading(true);
//     setError("");
//     try {
//       const data = await apiJson(tenant, `/bookings`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const list = Array.isArray(data) ? data : data.data || [];
//       setBookings(list);
//       fetchMilestones(list);
//     } catch (e) {
//       setError(e.message);
//       showToast("❌ Could not load bookings. Please retry.", "error", 4000);
//     } finally {
//       setLoading(false);
//     }
//   }, [tenant, user?.token, fetchMilestones, showToast]);

//   const fetchPayments = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setPaymentsLoading(true);
//     try {
//       const [txns, booksRaw] = await Promise.all([
//         apiJson(tenant, `/payment/history`, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             Accept: "application/json",
//           },
//         }),
//         apiJson(tenant, `/bookings`, {
//           headers: {
//             Authorization: `Bearer ${user.token}`,
//             Accept: "application/json",
//           },
//         }),
//       ]);

//       const txnList = Array.isArray(txns) ? txns : [];
//       const books = Array.isArray(booksRaw) ? booksRaw : booksRaw.data || [];
//       const txnBookingIds = new Set(txnList.map((t) => String(t.booking_id)));
//       const missingTxns = books
//         .filter(
//           (b) =>
//             b.booking_status === "confirmed" &&
//             !txnBookingIds.has(String(b.id)),
//         )
//         .map((b) => ({
//           id: `booking_${b.id}`,
//           booking_id: b.id,
//           amount: b.down_payment_amount || b.total_amount || 0,
//           currency: "INR",
//           status: "success",
//           mode: "manual",
//           gateway: "cash / manual",
//           paid_at: b.created_at,
//           _synthetic: true,
//           booking: {
//             id: b.id,
//             plot_number: b.plot_number,
//             plot_type: b.plot_type,
//             booking_status: b.booking_status,
//           },
//         }));
//       setPayments([...txnList, ...missingTxns]);
//     } catch (_) {
//     } finally {
//       setPaymentsLoading(false);
//     }
//   }, [tenant, user?.token]);

//   const fetchFeedbacks = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       const data = await apiJson(tenant, `/feedback`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setFeedbacks(Array.isArray(data) ? data : data.data || []);
//     } catch (_) {}
//   }, [tenant, user?.token]);

//   const fetchNotifications = useCallback(async () => {
//     if (!tenant || !user?.token) return;
//     setNotifsLoading(true);
//     try {
//       const data = await apiJson(tenant, `/notifications`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const list = Array.isArray(data) ? data : data.data || [];
//       setNotifications(list);
//       setUnreadCount(list.filter((n) => !n.is_read).length);
//     } catch (_) {
//     } finally {
//       setNotifsLoading(false);
//     }
//   }, [tenant, user?.token]);

//   useEffect(() => {
//     if (!user?.token || !tenant) {
//       navigate(`/${tenant || ""}`);
//       return;
//     }

//     const loadData = async () => {
//       try {
//         const currencyData = await apiJson(tenant, `/currency`);
//         if (currencyData) {
//           setCurrency({
//             symbol: currencyData.symbol || "₹",
//             code: currencyData.code || "INR",
//             position: currencyData.position || "before",
//           });
//         }
//       } catch (_) {}

//       await Promise.all([
//         fetchCurrentUser(),
//         fetchBookings(),
//         fetchNotifications(),
//         fetchFeedbacks(),
//         fetchPayments(),
//         fetchInvoices(),
//       ]);
//     };

//     loadData();

//     // Check for payment confirmation from URL params
//     const params = new URLSearchParams(window.location.search);
//     const bookingId = params.get("booking");
//     const sessionId = params.get("session_id");
//     if (bookingId && sessionId && tenant && user?.token) {
//       const confirmPayment = async () => {
//         try {
//           await apiJson(tenant, `/payment/stripe/confirm`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//             body: JSON.stringify({
//               booking_id: bookingId,
//               session_id: sessionId,
//             }),
//           });
//           await Promise.all([
//             fetchBookings(),
//             fetchNotifications(),
//             fetchPayments(),
//             fetchInvoices(),
//           ]);
//           showToast(
//             "🎉 Payment confirmed! Your booking is now active.",
//             "booking",
//             5000,
//           );
//         } catch (_) {}
//       };
//       confirmPayment();
//       window.history.replaceState({}, "", window.location.pathname);
//     }

//     // Fetch unread messages count
//     if (tenant && user?.token) {
//       apiJson(tenant, `/messages/unread`, {
//         headers: { Authorization: `Bearer ${user.token}` },
//       })
//         .then((d) => setUnreadMessages(d.unread || 0))
//         .catch(() => {});
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenant, user?.token]);

//   const markRead = async (id) => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/notifications/${id}/read`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setNotifications((prev) =>
//         prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)),
//       );
//       setUnreadCount((prev) => Math.max(0, prev - 1));
//     } catch (_) {}
//   };

//   const markAllRead = async () => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/notifications/read-all`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
//       setUnreadCount(0);
//       showToast("✅ All notifications marked as read", "success", 2500);
//     } catch (_) {}
//   };

//   const handlePay = (id, milestoneId) => {
//     if (milestoneId) {
//       navigate(`/${tenant}/payment/${id}?milestone=${milestoneId}`);
//     } else {
//       navigate(`/${tenant}/payment/${id}`);
//     }
//   };

//   // ── Send Payment Link (agent → client email) ────────────────
//   // Keyed by `${bookingId}-${milestoneId || "main"}` so multiple pending
//   // milestones on the same booking each get their own independent
//   // loading state, instead of all lighting up together.
//   const handleSendPaymentLink = useCallback(
//     async (bookingId, milestoneId) => {
//       if (!tenant || !user?.token) return;
//       const key = `${bookingId}-${milestoneId || "main"}`;
//       setSendingLinkKey(key);
//       try {
//         const data = await apiJson(
//           tenant,
//           `/bookings/${bookingId}/send-payment-link`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//               Authorization: `Bearer ${user.token}`,
//             },
//             body: JSON.stringify({ milestone_id: milestoneId || undefined }),
//           },
//         );
//         showToast(
//           `✉️ Payment link sent to ${data?.sent_to || "the client"}`,
//           "success",
//           3800,
//         );
//       } catch (e) {
//         showToast("❌ " + e.message, "error", 4000);
//       } finally {
//         setSendingLinkKey(null);
//       }
//     },
//     [tenant, user?.token, showToast],
//   );

//   // ── Record Manual Payment (buyer paying manually, or agent recording a
//   //    payment collected offline). Always pending admin approval. ────────
//   const submitManualPayment = useCallback(
//     async (bookingId, milestoneId, payload) => {
//       if (!tenant || !user?.token) return false;
//       try {
//         await apiJson(tenant, `/bookings/${bookingId}/manual-payment`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//             Authorization: `Bearer ${user.token}`,
//           },
//           body: JSON.stringify({
//             ...payload,
//             milestone_id: milestoneId || undefined,
//           }),
//         });
//         showToast(
//           "✅ Payment recorded — awaiting admin approval",
//           "success",
//           4000,
//         );
//         return true;
//       } catch (e) {
//         showToast("❌ " + e.message, "error", 4000);
//         return false;
//       }
//     },
//     [tenant, user?.token, showToast],
//   );

//   // const handleLogout = () => {
//   //   showToast("👋 Logged out successfully", "info", 2500);
//   //   setTimeout(() => {
//   //     dispatch(clearUser());
//   //     navigate(`/${tenant}`);
//   //   }, 600);
//   // };

//   const handleLogout = () => {
//     showToast("👋 Logged out successfully", "info", 2500);
//     setTimeout(() => {
//       signOut();
//       navigate(`/${tenant}`);
//     }, 600);
//   };

//   // const handleSaved = (updated) => dispatch(setUser(updated));
//   const handleSaved = (updated) => updateUser(updated);

//   const handleCancel = async (bookingId) => {
//     if (!tenant || !user?.token) return;
//     try {
//       await apiJson(tenant, `/bookings/${bookingId}`, {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       setBookings((prev) =>
//         prev.map((b) =>
//           b.id === bookingId ? { ...b, booking_status: "cancelled" } : b,
//         ),
//       );
//       showToast("✅ Booking cancelled successfully", "success", 3500);
//     } catch (e) {
//       showToast("❌ " + e.message, "error", 4000);
//     }
//   };

//   const confirmed = bookings.filter(
//     (b) => b.booking_status === "confirmed",
//   ).length;
//   const pending = bookings.filter((b) => b.booking_status === "pending").length;

//   const totalInvested = bookings
//     .filter((b) => b.booking_status === "confirmed")
//     .reduce((s, b) => {
//       const msData = milestoneMap[b.id];
//       if (msData?.milestones?.length) {
//         const paidSum = msData.milestones
//           .filter((m) => m.status === "paid")
//           .reduce((ms, m) => ms + msAmount(m), 0);
//         if (paidSum > 0) return s + paidSum;
//         return (
//           s +
//           parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
//         );
//       }
//       return (
//         s + parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
//       );
//     }, 0);

//   // ── Tabs — icons added so the vertical rail has a readable glyph
//   // alongside each label. Behavior/counts unchanged. ─────────────
//   const tabs = [
//     {
//       id: "bookings",
//       label: isAgent ? "Client Bookings" : "My Bookings",
//       count: bookings.length,
//       icon: "📋",
//     },
//     { id: "wishlist", label: "Wishlist", count: wishlist.length, icon: "❤️" },
//     { id: "payments", label: "Payments", count: 0, icon: "💳" },
//     { id: "invoices", label: "Invoices", count: invoiceCount, icon: "🧾" },
//     {
//       id: "notifications",
//       label: "Notifications",
//       count: unreadCount,
//       icon: "🔔",
//     },
//     { id: "feedback", label: "Feedback", count: 0, icon: "💬" },
//     { id: "messages", label: "Messages", count: unreadMessages, icon: "✉️" },
//     { id: "profile", label: "My Profile", count: 0, icon: "👤" },
//   ];

//   const logoUrl =
//     settings?.app_logo_dark_url || settings?.app_logo_light_url || null;
//   const appName = settings?.app_name || "Dashboard";

//   // ── Theme — colors & fonts pulled from the tenant's own backend
//   // settings instead of hardcoded defaults, matching the same pattern
//   // used on UnitPage. Falls back to whatever UserDashboard.css already
//   // defines globally whenever a given setting isn't present.
//   const themeVars = {
//     ...(settings?.primary_color && { "--primary-color": settings.primary_color }),
//     ...(settings?.primary_hover_color && { "--primary-hover": settings.primary_hover_color }),
//     ...(settings?.page_bg_color && { "--page-bg": settings.page_bg_color }),
//     ...(settings?.card_bg_color && { "--card-bg": settings.card_bg_color }),
//     ...(settings?.card_border_color && { "--card-border": settings.card_border_color }),
//     ...(settings?.text_dark_color && { "--text-dark": settings.text_dark_color }),
//     ...(settings?.text_muted_color && { "--text-muted": settings.text_muted_color }),
//     ...(settings?.font_heading && { "--font-heading": settings.font_heading }),
//     ...(settings?.font_body && { "--font-body": settings.font_body }),
//   };

//   return (
//     <div className="dashboard" style={themeVars}>
//       {/* ── Vertical nav rail — replaces the old horizontal header.
//            Same handlers as before (navigate(-1), setActiveTab,
//            handleLogout) — only the layout moved from a top bar to a
//            left-hand column. ── */}
//       <div className="dashboard-rail">
//         <button onClick={() => navigate(-1)} className="dash-rail-back">
//           ← Back
//         </button>

//         {logoUrl ? (
//           <img src={logoUrl} alt={appName} className="dash-rail-logo" />
//         ) : (
//           <span className="dash-rail-logo-text">
//             {isAgent ? `${roleLabel(user.role)} Dashboard` : "My Dashboard"}
//           </span>
//         )}

//         <div className="dash-rail-user">
//           <div
//             className="dashboard-avatar dash-rail-avatar"
//             style={{
//               background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//               boxShadow: `0 2px 8px ${primaryColor}30`,
//             }}
//           >
//             {user?.name?.[0]?.toUpperCase()}
//           </div>
//           <div className="dash-rail-user-text">
//             <div className="dash-rail-user-name">{user?.name}</div>
//             <div className="dash-rail-user-role">
//               {isAgent
//                 ? `${roleLabel(user.role)}${user?.broker_company ? " · " + user.broker_company : ""}`
//                 : "Buyer"}
//             </div>
//           </div>
//         </div>

//         <button
//           onClick={() => setActiveTab("notifications")}
//           className="dash-rail-notif"
//         >
//           🔔 Notifications
//           {unreadCount > 0 && (
//             <span className="dashboard-notif-badge">
//               {unreadCount > 9 ? "9+" : unreadCount}
//             </span>
//           )}
//         </button>

//         <div className="dashboard-rail-tabs">
//           {tabs.map((t) => (
//             <TabButton
//               key={t.id}
//               active={activeTab === t.id}
//               onClick={() => setActiveTab(t.id)}
//               label={t.label}
//               count={t.count}
//               icon={t.icon}
//             />
//           ))}
//         </div>

//         <div className="rail-spacer" />

//         <ElegantButton
//           variant="secondary"
//           onClick={handleLogout}
//           size="sm"
//           className="dash-rail-logout"
//         >
//           Logout
//         </ElegantButton>
//       </div>

//       {/* ── Main content column ── */}
//       <div className="dashboard-main">
//         <div className="dashboard-container">
//           {/* Welcome */}
//           <div className="dashboard-welcome">
//             <div className="dashboard-welcome-title">
//               Welcome back, {user?.name?.split(" ")[0]}
//             </div>
//             <div className="dashboard-welcome-subtitle">
//               {isAgent
//                 ? "Manage your client bookings and track your commissions."
//                 : "Track your property bookings and payments."}
//             </div>
//           </div>

//           {/* Stat cards */}
//           <div className="dashboard-stats">
//             <StatCard
//               icon="📋"
//               label="Total Bookings"
//               value={bookings.length}
//               color={primaryColor}
//             />
//             <StatCard
//               icon="✓"
//               label="Confirmed"
//               value={confirmed}
//               color="#16a34a"
//             />
//             <StatCard
//               icon="⏳"
//               label="Pending Payment"
//               value={pending}
//               color="#d97706"
//             />
//             {!isAgent && (
//               <StatCard
//                 icon="💰"
//                 label="Amount Invested"
//                 value={fmtExact(totalInvested)}
//                 color={primaryColor}
//               />
//             )}
//           </div>

//           {isAgent && bookings.length > 0 && (
//             <AgentStats
//               bookings={bookings}
//               fmtExact={fmtExact}
//               primaryColor={primaryColor}
//             />
//           )}

//           {/* Tab Content — horizontal tab bar removed; tabs now live in
//               the rail above. Everything below is unchanged. */}
//           {activeTab === "bookings" && (
//             <div>
//               {loading && (
//                 <div className="dashboard-loading">
//                   <div className="dashboard-loading-icon">⏳</div>
//                   <div className="dashboard-loading-text">
//                     Loading bookings...
//                   </div>
//                 </div>
//               )}
//               {error && (
//                 <div className="dashboard-error">
//                   <span>⚠ {error}</span>
//                   <ElegantButton
//                     variant="secondary"
//                     onClick={fetchBookings}
//                     size="sm"
//                   >
//                     Retry
//                   </ElegantButton>
//                 </div>
//               )}
//               {!loading && Object.keys(milestoneMap).length > 0 && (
//                 <DuesBanner
//                   milestoneMap={milestoneMap}
//                   fmtExact={fmtExact}
//                   onNavigate={(path) => navigate(`/${tenant}${path}`)}
//                   primaryColor={primaryColor}
//                   isAgent={isAgent}
//                   onSendLink={handleSendPaymentLink}
//                   onManualSubmit={submitManualPayment}
//                   sendingLinkKey={sendingLinkKey}
//                 />
//               )}
//               {!loading && !error && bookings.length === 0 && (
//                 <div className="dashboard-empty">
//                   <div className="dashboard-empty-icon">🏠</div>
//                   <div className="dashboard-empty-title">
//                     {isAgent ? "No client bookings yet" : "No bookings yet"}
//                   </div>
//                   <div className="dashboard-empty-subtitle">
//                     {isAgent
//                       ? "Book a unit for your clients from the unit page."
//                       : "Browse available units to make your first booking."}
//                   </div>
//                   <ElegantButton onClick={() => navigate(`/${tenant}`)}>
//                     Browse Units →
//                   </ElegantButton>
//                 </div>
//               )}
//               <div className="dashboard-bookings">
//                 {!loading &&
//                   bookings.map((b) => (
//                     <BookingCard
//                       key={b.id}
//                       booking={b}
//                       onPay={handlePay}
//                       onCancel={handleCancel}
//                       onSendPaymentLink={handleSendPaymentLink}
//                       onManualSubmit={submitManualPayment}
//                       sendingLinkKey={sendingLinkKey}
//                       isAgent={isAgent}
//                       fmtExact={fmtExact}
//                       token={user?.token}
//                       primaryColor={primaryColor}
//                       milestoneMap={milestoneMap}
//                       tenant={tenant}
//                     />
//                   ))}
//               </div>
//             </div>
//           )}

//           {activeTab === "wishlist" && (
//             <WishlistTab
//               wishlist={wishlist}
//               wishedIds={wishedIds}
//               onToggle={handleWishlistToggle}
//               loading={wishLoading}
//               token={user?.token}
//               onNavigate={(path) => navigate(`/${tenant}${path}`)}
//               fmt={fmt}
//               tenant={tenant}
//             />
//           )}
//           {activeTab === "payments" && (
//             <PaymentsTab
//               payments={payments}
//               loading={paymentsLoading}
//               fmt={fmt}
//               fmtExact={fmtExact}
//               user={user}
//               tenant={tenant}
//             />
//           )}
//           {activeTab === "invoices" && (
//             <InvoicesTab user={user} fmt={fmt} tenant={tenant} />
//           )}
//           {activeTab === "notifications" && (
//             <NotificationsTab
//               notifications={notifications}
//               loading={notifsLoading}
//               unreadCount={unreadCount}
//               onMarkRead={markRead}
//               onMarkAllRead={markAllRead}
//               onNavigate={(path) => navigate(`/${tenant}${path}`)}
//               onSwitchToBookings={switchToBookings}
//               primaryColor={primaryColor}
//               tenant={tenant}
//             />
//           )}
//           {activeTab === "feedback" && (
//             <FeedbackTab
//               feedbacks={feedbacks}
//               bookings={bookings}
//               token={user?.token}
//               showToast={showToast}
//               onSubmitted={(newFb) => setFeedbacks((prev) => [newFb, ...prev])}
//               primaryColor={primaryColor}
//               tenant={tenant}
//             />
//           )}
//           {activeTab === "messages" && (
//             <MessagesTab user={user} tenant={tenant} />
//           )}
//           {activeTab === "profile" && (
//             <ProfilePanel
//               user={user}
//               onSaved={handleSaved}
//               showToast={showToast}
//               primaryColor={primaryColor}
//               tenant={tenant}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// UserDashboard.jsx
import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { selectUser, setUser, clearUser } from "../redux/authSlice";

import { useAuth } from "../context/AuthContext";

import { useToast } from "../context/ToastContext";
import { useSettings } from "../context/SettingsContext";
import { useWishlist } from "../hooks/useWishlist";
import { apiJson } from "../api/apiClient";
import { apiUrl } from "../apiUrl";
import WishlistTab from "./WishlistTab";
import MessagesTab from "./MessagesTab";
import InvoicesTab from "./InvoicesTab";
import PaymentsTab from "./PaymentsTab";
import "../styles/UserDashboard.css";

const API_BASE = `${apiUrl}/api`;

// ── Formatters ─────────────────────────────────────────────
const makeFmt =
  (symbol = "₹", position = "before") =>
  (n) => {
    if (n == null) return "—";
    const num = new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(n);
    return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
  };

const makeFmtExact =
  (symbol = "₹", position = "before") =>
  (n) => {
    if (n == null) return "—";
    const num = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
    return position === "after" ? `${num} ${symbol}` : `${symbol} ${num}`;
  };

const STATUS_CFG = {
  confirmed: {
    color: "#16a34a",
    bg: "rgba(22,163,74,0.10)",
    label: "Confirmed",
  },
  pending: {
    color: "#d97706",
    bg: "rgba(217,119,6,0.10)",
    label: "Pending Payment",
  },
  cancelled: {
    color: "#dc2626",
    bg: "rgba(220,38,38,0.10)",
    label: "Cancelled",
  },
  refunded: {
    color: "#94a3b8",
    bg: "rgba(148,163,184,0.10)",
    label: "Refunded",
  },
};

const COMM_CFG = {
  pending: { color: "#d97706", label: "Pending Approval" },
  approved: { color: "#2563eb", label: "Approved" },
  paid: { color: "#16a34a", label: "Paid" },
  rejected: { color: "#dc2626", label: "Rejected" },
  refunded: { color: "#94a3b8", label: "Refunded" },
};

const msAmount = (m) => parseFloat(m.total_with_tax ?? m.amount ?? 0);

// ── Role label helper ───────────────────────────────────────
const roleLabel = (role) =>
  role === "broker" ? "Broker" : role === "sales" ? "Sales Agent" : "Buyer";

// ── Elegant Card Component ─────────────────────────────────
const ElegantCard = ({ children, noPadding, hover, onClick, className }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className={`elegant-card ${hover ? "elegant-card-hover" : ""} ${noPadding ? "elegant-card-no-padding" : "elegant-card-padding"} ${onClick ? "elegant-card-clickable" : ""} ${className || ""}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  );
};

// ── Elegant Button ─────────────────────────────────────────
const ElegantButton = ({
  children,
  variant = "primary",
  onClick,
  disabled,
  loading,
  size = "md",
  className,
}) => {
  const sizeClass = `elegant-btn-${size}`;
  const variantClass = `elegant-btn-${variant}`;

  return (
    <button
      className={`elegant-btn ${sizeClass} ${variantClass} ${className || ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && <span className="elegant-btn-spinner"></span>}
      {children}
    </button>
  );
};

// ── Elegant Stat Card ──────────────────────────────────────
const StatCard = ({ icon, label, value, color }) => (
  <div className="stat-card">
    <div className="stat-card-content">
      <div
        className="stat-card-icon"
        style={{
          background: `linear-gradient(135deg, ${color}15, ${color}08)`,
        }}
      >
        {icon}
      </div>
      <div>
        <div className="stat-card-value" style={{ color }}>
          {value}
        </div>
        <div className="stat-card-label">{label}</div>
      </div>
    </div>
  </div>
);

// ── Tab Button — now supports an optional icon, used for the vertical
// rail's tab list. Existing callers that don't pass `icon` render
// exactly as before. ─────────────────────────────────────────
const TabButton = ({ active, onClick, label, count, icon }) => (
  <button
    onClick={onClick}
    className={`dashboard-tab ${active ? "dashboard-tab-active" : "dashboard-tab-inactive"}`}
  >
    {icon && <span className="dashboard-tab-icon">{icon}</span>}
    {label}
    {count > 0 && (
      <span
        className={`dashboard-tab-count ${active ? "dashboard-tab-count-active" : "dashboard-tab-count-inactive"}`}
      >
        {count}
      </span>
    )}
  </button>
);

// ── Milestone Row Component ─────────────────────────────────
const MilestoneRow = ({
  label,
  percentage,
  amount,
  baseAmount,
  taxAmount,
  extraFees,
  taxLabel,
  taxRate,
  hasTax,
  isPaid,
  isDue,
  isOverdue,
  isWaived,
  isRefunded,
  dueDate,
  paidAt,
  index,
  fmtExact,
  primaryColor,
}) => {
  const [showTax, setShowTax] = useState(false);

  let textColor = "var(--text-muted)";
  let dotBackground = "transparent";
  let dotBorder = "var(--card-border)";
  let dotColor = "var(--text-muted)";

  if (isRefunded) {
    textColor = "var(--text-muted)";
    dotBackground = "transparent";
    dotBorder = "#94a3b8";
    dotColor = "#94a3b8";
  } else if (isPaid) {
    textColor = primaryColor;
    dotBackground = primaryColor;
    dotBorder = primaryColor;
    dotColor = "#fff";
  } else if (isOverdue) {
    textColor = "#dc2626";
    dotBackground = "transparent";
    dotBorder = "#dc2626";
    dotColor = "#dc2626";
  } else if (isDue) {
    textColor = "var(--text-dark)";
    dotBackground = "transparent";
    dotBorder = primaryColor;
    dotColor = primaryColor;
  }

  const dotContent = isRefunded
    ? "↺"
    : isPaid
      ? "✓"
      : isWaived
        ? "–"
        : index + 1;

  return (
    <div className="milestone-row">
      <div
        className="milestone-dot"
        style={{
          background: dotBackground,
          border: `2px solid ${dotBorder}`,
          color: dotColor,
        }}
      >
        {dotContent}
      </div>
      <div
        className="milestone-content"
        style={{
          background: isPaid
            ? `${primaryColor}06`
            : isRefunded
              ? "rgba(148,163,184,0.06)"
              : "var(--page-bg)",
          border: `1px solid ${isPaid ? primaryColor + "20" : isRefunded ? "#94a3b820" : isOverdue ? "#dc262620" : isDue ? primaryColor + "18" : "var(--card-border)"}`,
        }}
      >
        <div className="milestone-header">
          <div className="milestone-info">
            <div className="milestone-label" style={{ color: textColor }}>
              {label}
            </div>
            <div className="milestone-meta">
              {percentage ? `${percentage}% of total` : ""}
              {dueDate && !isPaid && !isRefunded && (
                <span style={{ marginLeft: percentage ? 8 : 0 }}>
                  Due: {dueDate}
                  {isOverdue && (
                    <span
                      style={{
                        color: "#dc2626",
                        fontWeight: 700,
                        marginLeft: 6,
                      }}
                    >
                      ⚠ Overdue
                    </span>
                  )}
                </span>
              )}
              {isPaid && paidAt && (
                <span style={{ color: "#16a34a", marginLeft: 6 }}>
                  ✓ Paid {paidAt}
                </span>
              )}
              {isRefunded && (
                <span style={{ color: "#94a3b8", marginLeft: 6 }}>
                  ↺ Refunded
                </span>
              )}
              {isDue && !isOverdue && !isRefunded && (
                <span style={{ color: "#d97706", marginLeft: 6 }}>
                  ← Due now
                </span>
              )}
              {isWaived && (
                <span style={{ color: "var(--text-muted)", marginLeft: 6 }}>
                  Waived
                </span>
              )}
            </div>
          </div>
          <div className="milestone-amount">
            <div
              className="milestone-amount-value"
              style={{ color: textColor }}
            >
              {isRefunded ? `−${fmtExact(amount)}` : fmtExact(amount)}
            </div>
            {hasTax && !isRefunded && (
              <button
                type="button"
                className="milestone-tax-btn"
                onClick={() => setShowTax((s) => !s)}
              >
                {taxLabel || "Tax"}
                {taxRate > 0 ? ` ${taxRate}%` : ""} {showTax ? "▲" : "▼"}
              </button>
            )}
          </div>
        </div>

        {hasTax && showTax && !isRefunded && (
          <div className="milestone-tax-details">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "var(--text-muted)",
                marginBottom: 4,
              }}
            >
              <span>Base amount</span>
              <span>{fmtExact(baseAmount)}</span>
            </div>
            {(extraFees || 0) > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "var(--text-muted)",
                  marginBottom: 4,
                }}
              >
                <span>Additional fees</span>
                <span>{fmtExact(extraFees)}</span>
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "#d97706",
              }}
            >
              <span>
                {taxLabel || "Tax"}
                {taxRate > 0 ? ` (${taxRate}%)` : ""}
              </span>
              <span>{fmtExact(taxAmount)}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: primaryColor,
                fontWeight: 700,
                borderTop: `1px solid ${primaryColor}20`,
                paddingTop: 8,
                marginTop: 8,
              }}
            >
              <span>Total payable</span>
              <span>{fmtExact(amount)}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ── Milestone Tracker ───────────────────────────────────────
const MilestoneTracker = ({
  bookingId,
  token,
  fmtExact,
  booking,
  primaryColor,
  tenant,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const isBookingRefunded = booking?.booking_status === "refunded";

  useEffect(() => {
    if (!bookingId || !token || !tenant) return;

    const fetchMilestones = async () => {
      try {
        const result = await apiJson(
          tenant,
          `/bookings/${bookingId}/milestones`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          },
        );
        setData(result);
      } catch (err) {
        console.error("Error fetching milestones:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMilestones();
  }, [bookingId, token, tenant]);

  // Show refunded message if booking is refunded
  if (isBookingRefunded) {
    return (
      <div className="milestone-tracker">
        <div
          className="refunded-banner"
          style={{
            background: "rgba(148,163,184,0.08)",
            border: "1px solid rgba(148,163,184,0.2)",
            borderRadius: "12px",
            padding: "16px",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "32px", marginBottom: "8px" }}>↺</div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#64748b",
              marginBottom: "4px",
            }}
          >
            Booking Refunded
          </div>
          <div style={{ fontSize: "12px", color: "var(--text-muted)" }}>
            This booking has been cancelled and fully refunded.
          </div>
        </div>
      </div>
    );
  }

  if (!loading && (!data || !data.milestones?.length)) {
    const plan = booking?.payment_plan;
    const price = parseFloat(booking?.price || 0);
    if (!plan?.milestones?.length) {
      return (
        <div className="milestone-tracker">
          <div
            className="booking-card-expanded"
            style={{
              color: "var(--text-muted)",
              fontSize: 13,
              padding: "12px 16px",
              background: "var(--page-bg)",
              borderRadius: "14px",
            }}
          >
            Full payment — no instalment plan selected
          </div>
        </div>
      );
    }
    const isConfirmed = booking.booking_status === "confirmed";
    const grandTotal = parseFloat(booking.total_amount || price);
    return (
      <div className="milestone-tracker">
        <div className="booking-card-expanded">
          <div
            style={{
              fontSize: 11,
              color: "var(--text-muted)",
              fontWeight: 700,
              letterSpacing: "0.8px",
              textTransform: "uppercase",
              marginBottom: 12,
            }}
          >
            Payment Schedule — {plan.name}
          </div>
          {plan.milestones.map((m, i) => {
            const amt = m.percentage
              ? (grandTotal * m.percentage) / 100
              : m.fixed_amount;
            const isPaid = i === 0 && isConfirmed;
            const isDue = i === 0 && !isConfirmed;
            return (
              <MilestoneRow
                key={i}
                label={m.label}
                percentage={m.percentage}
                amount={amt}
                isPaid={isPaid}
                isDue={isDue}
                isRefunded={false}
                index={i}
                fmtExact={fmtExact}
                primaryColor={primaryColor}
              />
            );
          })}
        </div>
      </div>
    );
  }

  if (loading)
    return (
      <div className="milestone-tracker">
        <div
          className="booking-card-expanded"
          style={{ color: "var(--text-muted)", fontSize: 12, padding: 12 }}
        >
          Loading payment schedule...
        </div>
      </div>
    );

  const { milestones } = data;
  const totalAmount = milestones.reduce((s, m) => s + msAmount(m), 0);
  const paidAmount = milestones
    .filter((m) => m.status === "paid")
    .reduce((s, m) => s + msAmount(m), 0);
  const refundedAmount = milestones
    .filter((m) => m.status === "refunded")
    .reduce((s, m) => s + msAmount(m), 0);
  const balanceDue = totalAmount - paidAmount - refundedAmount;
  const pct =
    totalAmount > 0
      ? Math.round(((paidAmount + refundedAmount) / totalAmount) * 100)
      : 0;
  const isFullyRefunded = refundedAmount > 0 && refundedAmount >= totalAmount;

  return (
    <div className="milestone-tracker">
      <div className="milestone-progress">
        <div className="milestone-progress-header">
          <span>Payment Progress (incl. taxes)</span>
          <span className="milestone-progress-percent">{pct}% complete</span>
        </div>
        <div className="milestone-progress-bar">
          <div
            className="milestone-progress-fill"
            style={{
              width: `${pct}%`,
              background: isFullyRefunded ? "#94a3b8" : primaryColor,
            }}
          />
        </div>
        <div className="milestone-progress-stats">
          <span className="milestone-progress-paid">
            Paid: {fmtExact(paidAmount)}
          </span>
          {refundedAmount > 0 && (
            <span
              className="milestone-progress-refunded"
              style={{ color: "#94a3b8" }}
            >
              Refunded: {fmtExact(refundedAmount)}
            </span>
          )}
          <span
            className="milestone-progress-balance"
            style={{
              color:
                balanceDue > 0
                  ? "#d97706"
                  : isFullyRefunded
                    ? "#94a3b8"
                    : "#16a34a",
            }}
          >
            {balanceDue > 0
              ? `Balance: ${fmtExact(balanceDue)}`
              : isFullyRefunded
                ? "✓ Fully Refunded"
                : "✓ Fully Paid"}
          </span>
        </div>
      </div>

      {milestones.map((m, i) => {
        const isPaid = m.status === "paid";
        const isOverdue = m.status === "overdue";
        const isWaived = m.status === "waived";
        const isRefunded = m.status === "refunded";
        const isDue =
          !isPaid &&
          !isWaived &&
          !isRefunded &&
          i ===
            milestones.findIndex(
              (x) => x.status === "pending" || x.status === "overdue",
            );
        return (
          <MilestoneRow
            key={m.id}
            label={m.label}
            percentage={m.percentage}
            amount={msAmount(m)}
            baseAmount={m.amount}
            taxAmount={m.tax_amount}
            extraFees={m.extra_fees}
            taxLabel={m.tax_label}
            taxRate={m.tax_rate}
            hasTax={(m.tax_amount || 0) > 0}
            isPaid={isPaid}
            isDue={isDue}
            isOverdue={isOverdue}
            isWaived={isWaived}
            isRefunded={isRefunded}
            dueDate={m.due_date}
            paidAt={m.paid_at}
            index={i}
            fmtExact={fmtExact}
            primaryColor={primaryColor}
          />
        );
      })}
    </div>
  );
};

// ── Inline Manual Payment Form (used in DuesBanner + BookingCard) ──────
// Always submits as PENDING; admin approval required before it counts as paid.
const ManualPaymentInline = ({
  amountDue,
  fmtExact,
  submitting,
  onSubmit,
  onCancel,
}) => {
  const [mode, setMode] = useState("cash");
  const [reference, setReference] = useState("");
  const [notes, setNotes] = useState("");

  return (
    <div
      style={{
        marginTop: 10,
        padding: 12,
        // borderRadius: 12,
        background: "var(--page-bg)",
        border: "1px solid var(--card-border)",
      }}
    >
      <div
        style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}
      >
        <select
          value={mode}
          onChange={(e) => setMode(e.target.value)}
          style={{
            flex: 1,
            minWidth: 130,
            padding: 8,
            // borderRadius: 8,
            border: "1px solid var(--card-border)",
            background: "var(--card-bg)",
            color: "var(--text-dark)",
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="cheque">📄 Cheque</option>
          <option value="bank_transfer">🏦 Bank Transfer</option>
        </select>
        <input
          type="text"
          placeholder="Reference number (optional)"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
          style={{
            flex: 1,
            minWidth: 160,
            padding: 8,
            // borderRadius: 8,
            border: "1px solid var(--card-border)",
            background: "var(--card-bg)",
            color: "var(--text-dark)",
          }}
        />
      </div>
      <textarea
        placeholder="Notes (optional)"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={2}
        style={{
          width: "100%",
          padding: 8,
          // borderRadius: 8,
          border: "1px solid var(--card-border)",
          background: "var(--card-bg)",
          color: "var(--text-dark)",
          marginBottom: 8,
          resize: "vertical",
          boxSizing: "border-box",
        }}
      />
      <div
        style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 10 }}
      >
        Amount: <strong>{fmtExact(amountDue)}</strong> · Submitted for admin
        approval — won't be marked as paid immediately.
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <ElegantButton
          size="sm"
          onClick={() =>
            onSubmit({ payment_mode: mode, reference_number: reference, notes })
          }
          loading={submitting}
        >
          Submit for Approval
        </ElegantButton>
        <ElegantButton
          size="sm"
          variant="ghost"
          onClick={onCancel}
          disabled={submitting}
        >
          Cancel
        </ElegantButton>
      </div>
    </div>
  );
};

// ── Individual Due Item — Send Link / Pay Online / Record Manual ───────
const DueItemRow = ({
  due,
  fmtExact,
  onNavigate,
  isAgent,
  onSendLink,
  onManualSubmit,
  sendingLinkKey,
  accentColor,
}) => {
  const [showManual, setShowManual] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const isSendingThis = sendingLinkKey === `${due.bookingId}-${due.id}`;

  const handleManualSubmit = async (payload) => {
    setSubmitting(true);
    const ok = await onManualSubmit(due.bookingId, due.id, {
      ...payload,
      amount: due.displayAmount,
    });
    setSubmitting(false);
    if (ok) {
      setSubmitted(true);
      setShowManual(false);
    }
  };

  return (
    <div
      className="dues-item"
      style={{
        flexDirection: "column",
        alignItems: "stretch",
        borderColor: `${accentColor}30`,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div>
          <div className="dues-item-title">{due.label}</div>
          <div className="dues-item-details">
            {due.due_date ? `Due: ${due.due_date}` : "No due date set"}
            {due.status === "overdue" && (
              <span className="dues-item-overdue">⚠ Overdue</span>
            )}
            <span style={{ marginLeft: 8 }}>· Booking #{due.bookingId}</span>
            {(due.tax_amount || 0) > 0 && (
              <span className="dues-item-tax">incl. tax</span>
            )}
          </div>
        </div>
        <div className="dues-item-amount" style={{ color: accentColor }}>
          <div style={{ fontSize: 18, fontWeight: 800 }}>
            {fmtExact(due.displayAmount)}
          </div>
        </div>
      </div>

      {submitted ? (
        <div
          style={{
            marginTop: 10,
            padding: "8px 12px",
            // borderRadius: 10,
            background: "rgba(34,197,94,0.08)",
            border: "1px solid rgba(34,197,94,0.25)",
            color: "#16a34a",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          ✓ Submitted — awaiting admin confirmation.
        </div>
      ) : (
        <>
          <div
            style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}
          >
            {!isAgent && (
              <ElegantButton
                size="sm"
                onClick={() =>
                  onNavigate(`/payment/${due.bookingId}?milestone=${due.id}`)
                }
              >
                💳 Pay Online
              </ElegantButton>
            )}
            {isAgent && (
              <ElegantButton
                size="sm"
                onClick={() => onSendLink(due.bookingId, due.id)}
                loading={isSendingThis}
              >
                ✉️ Send Payment Link
              </ElegantButton>
            )}
            <ElegantButton
              size="sm"
              variant="secondary"
              onClick={() => setShowManual((s) => !s)}
            >
              🏦 {showManual ? "Cancel" : "Record Manual Payment"}
            </ElegantButton>
          </div>

          {showManual && (
            <ManualPaymentInline
              amountDue={due.displayAmount}
              fmtExact={fmtExact}
              submitting={submitting}
              onSubmit={handleManualSubmit}
              onCancel={() => setShowManual(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

// ── Dues Banner ─────────────────────────────────────────────
const DuesBanner = ({
  milestoneMap,
  fmtExact,
  onNavigate,
  primaryColor,
  isAgent,
  onSendLink,
  onManualSubmit,
  sendingLinkKey,
}) => {
  const dues = Object.entries(milestoneMap)
    .flatMap(([bookingId, data]) =>
      (data.milestones || [])
        .filter((m) => m.status === "pending" || m.status === "overdue")
        .map((m) => ({ ...m, bookingId, displayAmount: msAmount(m) })),
    )
    .sort((a, b) => {
      if (!a.due_date && !b.due_date) return 0;
      if (!a.due_date) return 1;
      if (!b.due_date) return -1;
      return new Date(a.due_date) - new Date(b.due_date);
    });

  if (!dues.length) return null;
  const overdueCount = dues.filter((d) => d.status === "overdue").length;
  const accentColor = overdueCount > 0 ? "#dc2626" : "#d97706";

  return (
    <div className="dues-banner">
      <ElegantCard hover>
        <div className="dues-banner-header">
          <div className="dues-banner-title" style={{ color: accentColor }}>
            <span style={{ fontSize: 20 }}>⏰</span>
            Upcoming Payments
            {overdueCount > 0 && (
              <span className="dues-banner-badge">{overdueCount} overdue</span>
            )}
          </div>
          <div className="dues-banner-count">
            {dues.length} payment{dues.length > 1 ? "s" : ""} remaining
          </div>
        </div>
        <div className="dues-list">
          {dues.map((d, i) => (
            <DueItemRow
              key={i}
              due={d}
              fmtExact={fmtExact}
              onNavigate={onNavigate}
              isAgent={isAgent}
              onSendLink={onSendLink}
              onManualSubmit={onManualSubmit}
              sendingLinkKey={sendingLinkKey}
              accentColor={d.status === "overdue" ? "#dc2626" : "#d97706"}
            />
          ))}
        </div>
      </ElegantCard>
    </div>
  );
};

// ── Booking Card ────────────────────────────────────────────
const BookingCard = ({
  booking,
  onPay,
  onCancel,
  onSendPaymentLink,
  onManualSubmit,
  sendingLinkKey,
  isAgent,
  fmtExact,
  token,
  primaryColor,
  milestoneMap,
  tenant,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);

  const [showManualForm, setShowManualForm] = useState(false);
  const [manualSubmitting, setManualSubmitting] = useState(false);
  const [manualSubmitted, setManualSubmitted] = useState(false);

  const isRefunded = booking.booking_status === "refunded";
  const cfg = STATUS_CFG[booking.booking_status] || STATUS_CFG.pending;
  const plan = booking.payment_plan;
  const isConfirmed = booking.booking_status === "confirmed";
  const isPending = booking.booking_status === "pending";

  const paidMilestones = (booking.milestones || []).filter(
    (m) => m.status === "paid",
  );
  const refundedMilestones = (booking.milestones || []).filter(
    (m) => m.status === "refunded",
  );
  const paidTotal = paidMilestones.reduce((sum, m) => sum + msAmount(m), 0);
  const refundedTotal = refundedMilestones.reduce(
    (sum, m) => sum + msAmount(m),
    0,
  );
  const allMilestones = booking.milestones || [];
  const totalFromMs = allMilestones.reduce((sum, m) => sum + msAmount(m), 0);
  const grandTotal = parseFloat(booking.total_amount || 0) || totalFromMs;

  const displayAmt = (() => {
    if (isRefunded) return refundedTotal;
    if (isConfirmed && paidTotal > 0) return paidTotal;
    if (isConfirmed) return grandTotal;
    const dp = parseFloat(booking.down_payment_amount || 0);
    if (dp > 0) return dp;
    return grandTotal;
  })();

  const amountLabel = isRefunded
    ? "Refunded Amount"
    : isPending
      ? "Down Payment Due"
      : isConfirmed && paidTotal > 0
        ? `Paid (${paidMilestones.length} milestone${paidMilestones.length > 1 ? "s" : ""})`
        : isConfirmed
          ? "Total Amount"
          : "Amount";

  // Resolve which milestone / amount a manual payment (or a send-payment-link
  // click) recorded here applies to. Defined before use below.
  const getManualTarget = () => {
    const msData = milestoneMap?.[booking.id];
    const firstPending = msData?.milestones?.find(
      (m) => m.status === "pending" || m.status === "overdue",
    );
    const amount = firstPending
      ? msAmount(firstPending)
      : parseFloat(booking.down_payment_amount || booking.total_amount || 0);
    return { milestoneId: firstPending?.id || null, amount };
  };

  // Compute the composite key AFTER getManualTarget exists, so we can
  // correctly scope the "sending" spinner to this specific booking+milestone.
  const { milestoneId: resolvedMilestoneId } = getManualTarget();
  const isSendingThisLink =
    sendingLinkKey === `${booking.id}-${resolvedMilestoneId || "main"}`;

  return (
    <ElegantCard hover>
      <div className="booking-card-header">
        <div className="booking-card-info">
          <div className="booking-card-title">
            <span className="booking-card-unit">
              Unit {booking.plot_number}
            </span>
            <span
              className="booking-card-status"
              style={{
                background: cfg.bg,
                color: cfg.color,
                border: `1px solid ${cfg.color}33`,
              }}
            >
              {cfg.label}
            </span>
          </div>
          <div className="booking-card-details">
            <span>{booking.plot_type}</span>
            {booking.area && <span>· {booking.area} sqft</span>}
            {booking.direction && <span>· {booking.direction}</span>}
          </div>
          {isAgent && (booking.client_name || booking.client_phone) && (
            <div
              className="booking-card-client"
              style={{
                background: `${primaryColor}06`,
                border: `1px solid ${primaryColor}18`,
              }}
            >
              <span style={{ color: "var(--text-muted)" }}>Client: </span>
              <span style={{ color: primaryColor, fontWeight: 600 }}>
                {booking.client_name}
              </span>
              {booking.client_phone && (
                <span style={{ color: "var(--text-muted)" }}>
                  {" "}
                  · {booking.client_phone}
                </span>
              )}
              {booking.client_email && (
                <span style={{ color: "var(--text-muted)" }}>
                  {" "}
                  · {booking.client_email}
                </span>
              )}
            </div>
          )}
          <div className="booking-card-id">
            #{booking.id} ·{" "}
            {new Date(booking.created_at).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </div>
        </div>

        <div className="booking-card-amount">
          <div className="booking-card-amount-label">{amountLabel}</div>
          <div
            className="booking-card-amount-value"
            style={{ color: isRefunded ? "#94a3b8" : primaryColor }}
          >
            {isRefunded ? `−${fmtExact(displayAmt)}` : fmtExact(displayAmt)}
          </div>
          {isConfirmed && plan && paidTotal > 0 && !isRefunded && (
            <>
              {refundedTotal > 0 && (
                <div
                  className="booking-card-refunded"
                  style={{
                    fontSize: 12,
                    color: "#94a3b8",
                    marginTop: 4,
                    fontWeight: 600,
                  }}
                >
                  Refunded: {fmtExact(refundedTotal)}
                </div>
              )}
              {grandTotal - paidTotal - refundedTotal > 0.01 && (
                <div className="booking-card-balance">
                  Balance: {fmtExact(grandTotal - paidTotal - refundedTotal)}
                </div>
              )}
            </>
          )}
          {isConfirmed &&
            plan &&
            paidTotal > 0 &&
            !isRefunded &&
            grandTotal - paidTotal - refundedTotal <= 0.01 &&
            refundedTotal === 0 && (
              <div className="booking-card-paid">✓ Fully paid (incl. tax)</div>
            )}
          {isConfirmed &&
            plan &&
            refundedTotal > 0 &&
            grandTotal - paidTotal - refundedTotal <= 0.01 && (
              <div
                className="booking-card-refunded"
                style={{
                  fontSize: 12,
                  color: "#94a3b8",
                  marginTop: 4,
                  fontWeight: 600,
                }}
              >
                ✓ Fully Refunded
              </div>
            )}
          {isPending && grandTotal > 0 && (
            <div className="booking-card-grand-total">
              Grand total: {fmtExact(grandTotal)}
            </div>
          )}
        </div>
      </div>

      {isAgent && booking.commission_amount && (
        <div
          className="booking-card-commission"
          style={{
            background: `${primaryColor}06`,
            border: `1px solid ${primaryColor}18`,
          }}
        >
          <span className="booking-card-commission-label">Commission:</span>
          <span className="booking-card-commission-value">
            {fmtExact(booking.commission_amount)}
          </span>
          {booking.commission_status &&
            (() => {
              const cs =
                COMM_CFG[booking.commission_status] || COMM_CFG.pending;
              return (
                <span
                  className="booking-card-commission-status"
                  style={{ color: cs.color }}
                >
                  {cs.label}
                </span>
              );
            })()}
        </div>
      )}

      <div className="booking-card-actions">
        {isPending && !isAgent && (
          <ElegantButton
            onClick={() => {
              const { milestoneId } = getManualTarget();
              onPay(booking.id, milestoneId);
            }}
            size="sm"
          >
            💳 Complete Payment
          </ElegantButton>
        )}
        {isPending && isAgent && (
          <ElegantButton
            onClick={() => {
              const { milestoneId } = getManualTarget();
              onSendPaymentLink(booking.id, milestoneId);
            }}
            size="sm"
            loading={isSendingThisLink}
          >
            ✉️ Send Payment Link
          </ElegantButton>
        )}
        {isPending && !manualSubmitted && (
          <ElegantButton
            variant="secondary"
            onClick={() => setShowManualForm((s) => !s)}
            size="sm"
          >
            🏦 {showManualForm ? "Cancel" : "Record Manual Payment"}
          </ElegantButton>
        )}
        <ElegantButton
          variant="secondary"
          onClick={() => setExpanded((e) => !e)}
          size="sm"
        >
          {expanded ? "▲ Less" : "▼ Payment Schedule"}
        </ElegantButton>
        {isPending && !confirmCancel && !isRefunded && (
          <ElegantButton
            variant="ghost"
            onClick={() => setConfirmCancel(true)}
            size="sm"
          >
            ✕ Cancel
          </ElegantButton>
        )}
        {isPending && confirmCancel && !isRefunded && (
          <div className="booking-card-cancel-confirm">
            <span className="booking-card-cancel-text">Are you sure?</span>
            <ElegantButton
              variant="secondary"
              onClick={async () => {
                setCancelling(true);
                await onCancel(booking.id);
                setCancelling(false);
                setConfirmCancel(false);
              }}
              size="sm"
              loading={cancelling}
            >
              Yes, Cancel
            </ElegantButton>
            <ElegantButton
              variant="ghost"
              onClick={() => setConfirmCancel(false)}
              size="sm"
            >
              No
            </ElegantButton>
          </div>
        )}
      </div>

      {showManualForm && !manualSubmitted && (
        <ManualPaymentInline
          amountDue={getManualTarget().amount}
          fmtExact={fmtExact}
          submitting={manualSubmitting}
          onSubmit={async (payload) => {
            const { milestoneId, amount } = getManualTarget();
            setManualSubmitting(true);
            const ok = await onManualSubmit(booking.id, milestoneId, {
              ...payload,
              amount,
            });
            setManualSubmitting(false);
            if (ok) {
              setManualSubmitted(true);
              setShowManualForm(false);
            }
          }}
          onCancel={() => setShowManualForm(false)}
        />
      )}
      {manualSubmitted && (
        <div
          style={{
            marginTop: 8,
            padding: "8px 12px",
            // borderRadius: 10,
            background: "rgba(34,197,94,0.08)",
            border: "1px solid rgba(34,197,94,0.25)",
            color: "#16a34a",
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          ✓ Manual payment submitted — awaiting admin confirmation.
        </div>
      )}

      {isPending && isAgent && !booking.client_email && (
        <div
          style={{
            marginTop: 8,
            fontSize: 11,
            color: "#d97706",
            fontStyle: "italic",
          }}
        >
          ⚠ No client email on file for this booking — the link will be sent
          once an email is added.
        </div>
      )}

      {expanded && (
        <div className="booking-card-expanded">
          <MilestoneTracker
            bookingId={booking.id}
            token={token}
            fmtExact={fmtExact}
            booking={booking}
            primaryColor={primaryColor}
            tenant={tenant}
          />
        </div>
      )}
    </ElegantCard>
  );
};

// ── Profile Panel ───────────────────────────────────────────
const ProfilePanel = ({ user, onSaved, showToast, primaryColor, tenant }) => {
  const [form, setForm] = useState({
    name: user.name || "",
    phone: user.phone || "",
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (form.new_password && form.new_password !== form.confirm_password) {
      showToast("⚠️ New passwords do not match", "warning", 3500);
      return;
    }
    setSaving(true);
    try {
      const payload = { name: form.name, phone: form.phone };
      if (form.new_password) {
        payload.current_password = form.current_password;
        payload.new_password = form.new_password;
      }

      const result = await apiJson(tenant, `/user/profile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify(payload),
      });

      showToast("✅ Profile updated successfully", "success", 3500);
      setForm((f) => ({
        ...f,
        current_password: "",
        new_password: "",
        confirm_password: "",
      }));
      onSaved({ ...user, name: form.name, phone: form.phone });
    } catch (e) {
      showToast("❌ " + e.message, "error", 4000);
    }
    setSaving(false);
  };

  const isAgent = user.role === "broker" || user.role === "sales";

  return (
    <div className="profile-panel">
      <ElegantCard>
        <div className="profile-header">
          <div
            className="profile-avatar"
            style={{
              background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
              boxShadow: `0 4px 14px ${primaryColor}30`,
            }}
          >
            {user.name?.[0]?.toUpperCase()}
          </div>
          <div className="profile-info">
            <div className="profile-name">{user.name}</div>
            <div className="profile-email">{user.email}</div>
            <div className="profile-role" style={{ color: primaryColor }}>
              {isAgent
                ? `${roleLabel(user.role)}${user.broker_company ? " · " + user.broker_company : ""}`
                : "Buyer"}
            </div>
          </div>
        </div>

        {isAgent && (
          <div className="profile-broker-stats">
            {[
              {
                label: "Commission Rate",
                value: `${user.commission_rate || 2}%`,
              },
              {
                label: "Account Status",
                value: user.status || "active",
                color: user.status === "active" ? "#16a34a" : "#dc2626",
              },
            ].map(({ label, value, color }) => (
              <div
                key={label}
                className="profile-broker-stat"
                style={{
                  background: `${primaryColor}06`,
                  border: `1px solid ${primaryColor}15`,
                }}
              >
                <div className="profile-broker-stat-label">{label}</div>
                <div
                  className="profile-broker-stat-value"
                  style={{ color: color || primaryColor }}
                >
                  {value}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="profile-section-title">Edit Profile</div>

        <input
          type="text"
          placeholder="Full Name *"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          className="profile-input"
        />
        <input
          value={user.email}
          readOnly
          placeholder="Email"
          className="profile-input profile-input-readonly"
        />
        <input
          type="tel"
          placeholder="Phone Number"
          value={form.phone}
          onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
          className="profile-input"
        />

        <div className="profile-password-title">
          Change Password (leave blank to keep current)
        </div>
        <input
          type="password"
          placeholder="Current Password"
          value={form.current_password}
          onChange={(e) =>
            setForm((f) => ({ ...f, current_password: e.target.value }))
          }
          className="profile-input"
        />
        <div className="profile-password-grid">
          <input
            type="password"
            placeholder="New Password"
            value={form.new_password}
            onChange={(e) =>
              setForm((f) => ({ ...f, new_password: e.target.value }))
            }
            className="profile-input"
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={form.confirm_password}
            onChange={(e) =>
              setForm((f) => ({ ...f, confirm_password: e.target.value }))
            }
            className="profile-input"
          />
        </div>

        <ElegantButton
          onClick={handleSave}
          disabled={saving || !form.name}
          loading={saving}
          size="lg"
          style={{ width: "100%", marginTop: 8 }}
        >
          Save Changes →
        </ElegantButton>
      </ElegantCard>
    </div>
  );
};

// ── Agent Stats (broker or sales) ───────────────────────────
const AgentStats = ({ bookings, fmtExact, primaryColor }) => {
  const commPending = bookings
    .filter((b) => b.commission_status === "pending")
    .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
  const commApproved = bookings
    .filter((b) => b.commission_status === "approved")
    .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);
  const commPaid = bookings
    .filter((b) => b.commission_status === "paid")
    .reduce((s, b) => s + parseFloat(b.commission_amount || 0), 0);

  return (
    <div className="broker-stats">
      {[
        {
          label: "Pending Commission",
          value: fmtExact(commPending),
          color: "#d97706",
          icon: "⏳",
        },
        {
          label: "Approved Commission",
          value: fmtExact(commApproved),
          color: "#2563eb",
          icon: "✓",
        },
        {
          label: "Commission Paid",
          value: fmtExact(commPaid),
          color: "#16a34a",
          icon: "💰",
        },
        {
          label: "Total Clients",
          value: bookings.length,
          color: primaryColor,
          icon: "👥",
        },
      ].map(({ label, value, color, icon }) => (
        <div key={label} className="broker-stat-card">
          <div className="broker-stat-content">
            <span className="broker-stat-icon">{icon}</span>
            <div className="broker-stat-value" style={{ color }}>
              {value}
            </div>
          </div>
          <div className="broker-stat-label">{label}</div>
        </div>
      ))}
    </div>
  );
};

// ── Notifications Tab ──────────────────────────────────────
const NOTIF_CFG = {
  payment_reminder: { color: "#d97706", label: "Payment Reminder" },
  booking_confirmed: { color: "#16a34a", label: "Booking Confirmed" },
  booking_cancelled: { color: "#dc2626", label: "Booking Cancelled" },
  project_launch: { color: null, label: "Project Launch" },
  offer: { color: "#7c3aed", label: "Special Offer" },
  general: { color: null, label: "General" },
};

const NotificationModal = ({
  notif,
  onClose,
  onMarkRead,
  onNavigate,
  onSwitchToBookings,
  primaryColor,
}) => {
  const cfg = notif
    ? { ...(NOTIF_CFG[notif.type] || NOTIF_CFG.general) }
    : NOTIF_CFG.general;
  if (!cfg.color) cfg.color = primaryColor;

  useEffect(() => {
    if (!notif) return;
    if (!notif.is_read) onMarkRead(notif.id);
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [notif?.id, onMarkRead, onClose]);

  if (!notif) return null;

  const timeAgo = (dateStr) => {
    const diff = Date.now() - new Date(dateStr).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 1) return "Just now";
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    const d = Math.floor(h / 24);
    return d < 7
      ? `${d}d ago`
      : new Date(dateStr).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
  };

  const handleViewBooking = () => {
    onClose();
    if (notif.type === "payment_reminder")
      onNavigate(`/payment/${notif.booking_id}`);
    else onSwitchToBookings(notif.booking_id);
  };

  return (
    <div onClick={onClose} className="notification-modal-overlay">
      <div
        onClick={(e) => e.stopPropagation()}
        className="notification-modal"
        style={{ borderTopColor: cfg.color }}
      >
        <div className="notification-modal-header">
          <div
            className="notification-modal-icon"
            style={{
              background: `${cfg.color}12`,
              borderColor: `${cfg.color}25`,
            }}
          >
            🔔
          </div>
          <div className="notification-modal-info">
            <div className="notification-modal-title">{notif.title}</div>
            <div className="notification-modal-meta">
              <span
                className="notification-modal-category"
                style={{ background: `${cfg.color}12`, color: cfg.color }}
              >
                {cfg.label}
              </span>
              <span className="notification-modal-time">
                {timeAgo(notif.created_at)}
              </span>
            </div>
          </div>
          <button onClick={onClose} className="notification-modal-close">
            ×
          </button>
        </div>
        <div className="notification-modal-body">
          <div className="notification-modal-message">{notif.message}</div>
          <div className="notification-modal-actions">
            {notif.booking_id && (
              <ElegantButton onClick={handleViewBooking}>
                {notif.type === "payment_reminder"
                  ? "Complete Payment →"
                  : "View Booking →"}
              </ElegantButton>
            )}
            <ElegantButton variant="secondary" onClick={onClose}>
              Close
            </ElegantButton>
          </div>
        </div>
      </div>
    </div>
  );
};

const NotificationsTab = ({
  notifications,
  loading,
  unreadCount,
  onMarkRead,
  onMarkAllRead,
  onNavigate,
  onSwitchToBookings,
  primaryColor,
  tenant,
}) => {
  const [filter, setFilter] = useState("all");
  const [selectedNotif, setSelectedNotif] = useState(null);

  const filtered = notifications.filter((n) => {
    if (filter === "unread") return !n.is_read;
    if (filter === "read") return n.is_read;
    return true;
  });

  const timeAgo = (dateStr) => {
    const diff = Date.now() - new Date(dateStr).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 1) return "Just now";
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    const d = Math.floor(h / 24);
    if (d < 7) return `${d}d ago`;
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
    });
  };

  if (loading)
    return (
      <div className="dashboard-loading">
        <div className="dashboard-loading-icon">⏳</div>
        <div className="dashboard-loading-text">Loading notifications...</div>
      </div>
    );

  return (
    <div className="notifications-tab">
      {selectedNotif && (
        <NotificationModal
          notif={selectedNotif}
          onClose={() => setSelectedNotif(null)}
          onMarkRead={onMarkRead}
          onNavigate={onNavigate}
          onSwitchToBookings={onSwitchToBookings}
          primaryColor={primaryColor}
        />
      )}
      <div className="notifications-filter">
        <div className="notifications-filter-group">
          {[
            ["all", "All"],
            ["unread", "Unread"],
            ["read", "Read"],
          ].map(([val, label]) => (
            <button
              key={val}
              onClick={() => setFilter(val)}
              className={`notifications-filter-btn ${filter === val ? "notifications-filter-active" : "notifications-filter-inactive"}`}
            >
              {label}
              {val === "unread" && unreadCount > 0 && (
                <span
                  className="notifications-badge"
                  style={{ background: "#d97706", color: "#fff" }}
                >
                  {unreadCount}
                </span>
              )}
            </button>
          ))}
        </div>
        {unreadCount > 0 && (
          <ElegantButton variant="secondary" onClick={onMarkAllRead} size="sm">
            ✓ Mark all read
          </ElegantButton>
        )}
      </div>

      {filtered.length === 0 && (
        <div className="dashboard-empty">
          <div className="dashboard-empty-icon">🔔</div>
          <div className="dashboard-empty-title">
            {filter === "unread"
              ? "No unread notifications"
              : "No notifications yet"}
          </div>
          <div className="dashboard-empty-subtitle">
            Payment reminders and booking updates will appear here.
          </div>
        </div>
      )}

      <div className="notifications-list">
        {filtered.map((n) => {
          const cfg = { ...(NOTIF_CFG[n.type] || NOTIF_CFG.general) };
          if (!cfg.color) cfg.color = primaryColor;
          return (
            <div
              key={n.id}
              onClick={() => setSelectedNotif(n)}
              className={`notification-item ${n.is_read ? "notification-item-read" : "notification-item-unread"}`}
            >
              {!n.is_read && (
                <div
                  className="notification-dot"
                  style={{ background: cfg.color }}
                />
              )}
              <div className="notification-content">
                <div className="notification-header">
                  <span
                    className={`notification-title ${n.is_read ? "notification-title-normal" : "notification-title-bold"}`}
                  >
                    {n.title}
                  </span>
                  <span
                    className="notification-category"
                    style={{ background: `${cfg.color}12`, color: cfg.color }}
                  >
                    {cfg.label}
                  </span>
                </div>
                <div className="notification-message">
                  {n.message.length > 100
                    ? n.message.slice(0, 100) + "…"
                    : n.message}
                </div>
                <div className="notification-footer">
                  <span className="notification-time">
                    {timeAgo(n.created_at)}
                  </span>
                  <span
                    className="notification-action"
                    style={{ color: cfg.color }}
                  >
                    Click to read →
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ── Feedback Tab ────────────────────────────────────────────
const CATEGORY_CFG = {
  general: { color: "#6b7280" },
  service: { color: "#2563eb" },
  unit: { color: null },
  payment: { color: "#d97706" },
  staff: { color: "#7c3aed" },
};

const StarRating = ({ value, onChange, primaryColor }) => (
  <div className="feedback-rating-stars">
    {[1, 2, 3, 4, 5].map((s) => (
      <button
        key={s}
        type="button"
        onClick={() => onChange(s)}
        className="feedback-star"
        style={{ color: s <= value ? primaryColor : "var(--card-border)" }}
      >
        ★
      </button>
    ))}
  </div>
);

const FeedbackTab = ({
  feedbacks,
  bookings,
  token,
  onSubmitted,
  showToast,
  primaryColor,
  tenant,
}) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    rating: 5,
    category: "general",
    subject: "",
    message: "",
    booking_id: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!form.subject.trim() || !form.message.trim()) {
      showToast("⚠️ Subject and message are required", "warning", 3500);
      return;
    }
    setSubmitting(true);
    try {
      const result = await apiJson(tenant, `/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...form,
          booking_id: form.booking_id || undefined,
        }),
      });

      showToast(
        "🙏 Thank you! Your feedback has been submitted",
        "success",
        4000,
      );
      setForm({
        rating: 5,
        category: "general",
        subject: "",
        message: "",
        booking_id: "",
      });
      setShowForm(false);
      onSubmitted(result.feedback);
    } catch (e) {
      showToast("❌ " + e.message, "error", 4000);
    }
    setSubmitting(false);
  };

  const confirmedBookings = bookings.filter(
    (b) => b.booking_status === "confirmed",
  );

  return (
    <div>
      <div className="feedback-header">
        <div>
          <div className="feedback-title">Your Feedback</div>
          <div className="feedback-subtitle">Share your experience with us</div>
        </div>
        <ElegantButton onClick={() => setShowForm((f) => !f)}>
          {showForm ? "✕ Cancel" : "+ New Feedback"}
        </ElegantButton>
      </div>

      {showForm && (
        <div className="feedback-form">
          <ElegantCard>
            <div className="feedback-form-title">New Feedback</div>

            <div className="feedback-rating">
              <div className="feedback-rating-label">Rating *</div>
              <StarRating
                value={form.rating}
                onChange={(r) => setForm((f) => ({ ...f, rating: r }))}
                primaryColor={primaryColor}
              />
              <div className="feedback-rating-text">
                {
                  ["", "Very Poor", "Poor", "Average", "Good", "Excellent"][
                    form.rating
                  ]
                }
              </div>
            </div>

            <div className="feedback-category">
              <div className="feedback-category-label">Category *</div>
              <div className="feedback-category-group">
                {Object.entries(CATEGORY_CFG).map(([cat, cfg]) => {
                  const catColor = cfg.color || primaryColor;
                  const isActive = form.category === cat;
                  return (
                    <button
                      key={cat}
                      type="button"
                      onClick={() => setForm((f) => ({ ...f, category: cat }))}
                      className={`feedback-category-btn ${isActive ? "feedback-category-active" : "feedback-category-inactive"}`}
                    >
                      {cat}
                    </button>
                  );
                })}
              </div>
            </div>

            {confirmedBookings.length > 0 && (
              <select
                value={form.booking_id}
                onChange={(e) =>
                  setForm((f) => ({ ...f, booking_id: e.target.value }))
                }
                className="feedback-select"
              >
                <option value="">Select booking (optional)</option>
                {confirmedBookings.map((b) => (
                  <option key={b.id} value={b.id}>
                    Unit {b.plot_number} — Booking #{b.id}
                  </option>
                ))}
              </select>
            )}

            <input
              type="text"
              placeholder="Subject *"
              value={form.subject}
              onChange={(e) =>
                setForm((f) => ({ ...f, subject: e.target.value }))
              }
              className="feedback-input"
            />

            <textarea
              placeholder="Your message..."
              value={form.message}
              onChange={(e) =>
                setForm((f) => ({ ...f, message: e.target.value }))
              }
              rows={4}
              className="feedback-textarea"
            />

            <div className="feedback-actions">
              <ElegantButton onClick={handleSubmit} loading={submitting}>
                Submit Feedback →
              </ElegantButton>
              <ElegantButton
                variant="secondary"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </ElegantButton>
            </div>
          </ElegantCard>
        </div>
      )}

      {feedbacks.length === 0 && !showForm && (
        <div className="feedback-empty">
          <div className="feedback-empty-icon">💬</div>
          <div className="feedback-empty-title">No feedback yet</div>
          <div className="feedback-empty-text">
            Share your experience to help us improve.
          </div>
        </div>
      )}

      <div className="feedback-list">
        {feedbacks.map((fb) => {
          const catColor = CATEGORY_CFG[fb.category]?.color || primaryColor;
          const ratingColor =
            fb.rating >= 4 ? "#16a34a" : fb.rating >= 3 ? "#d97706" : "#dc2626";
          const statusColor =
            fb.status === "resolved"
              ? "#16a34a"
              : fb.status === "reviewed"
                ? "#2563eb"
                : "#d97706";
          return (
            <div key={fb.id} className="feedback-card">
              <div className="feedback-card-header">
                <div className="feedback-card-info">
                  <div className="feedback-card-tags">
                    <span className="feedback-card-subject">{fb.subject}</span>
                    <span
                      className="feedback-card-category"
                      style={{ background: `${catColor}12`, color: catColor }}
                    >
                      {fb.category}
                    </span>
                    <span
                      className="feedback-card-status"
                      style={{
                        background: `${statusColor}12`,
                        color: statusColor,
                      }}
                    >
                      {fb.status}
                    </span>
                  </div>
                  <div className="feedback-card-date">
                    {fb.booking ? `Unit ${fb.booking.plot_number} · ` : ""}
                    {new Date(fb.created_at).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </div>
                </div>
                <div
                  className="feedback-card-rating"
                  style={{ color: ratingColor }}
                >
                  {"★".repeat(fb.rating)}
                </div>
              </div>
              <div className="feedback-card-message">{fb.message}</div>
              {fb.admin_reply && (
                <div
                  className="feedback-card-reply"
                  style={{
                    background: "#16a34a08",
                    border: "1px solid #16a34a20",
                  }}
                >
                  <div
                    className="feedback-card-reply-title"
                    style={{ color: "#16a34a" }}
                  >
                    Admin Reply
                  </div>
                  <div className="feedback-card-reply-text">
                    {fb.admin_reply}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ── Main Dashboard ──────────────────────────────────────────
export default function UserDashboard() {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const user = useSelector(selectUser);
  const navigate = useNavigate();
  const { user, updateUser, signOut, initializing: authInitializing } = useAuth();

  const { settings } = useSettings();
  const { tenant } = useParams();

  const primaryColor = settings?.primary_color || "#c9a96e";

  const [bookings, setBookings] = useState([]);
  const [milestoneMap, setMilestoneMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("bookings");
  const [notifications, setNotifications] = useState([]);
  const [notifsLoading, setNotifsLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [feedbacks, setFeedbacks] = useState([]);
  const [payments, setPayments] = useState([]);
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [invoices, setInvoices] = useState([]);
  const [invoiceCount, setInvoiceCount] = useState(0);

  // Single source of truth for "which booking+milestone is currently
  // sending a payment link" — composite key avoids all buttons on the
  // same booking lighting up together.
  const [sendingLinkKey, setSendingLinkKey] = useState(null);

  const { showToast } = useToast();
  const {
    wishlist,
    wishedIds,
    toggle: toggleWishRaw,
    loading: wishLoading,
  } = useWishlist(tenant, user?.token);

  const handleWishlistToggle = useCallback(
    async (plotId) => {
      const wasWished =
        wishedIds instanceof Set && wishedIds.has(Number(plotId));
      await toggleWishRaw(Number(plotId));
      showToast(
        wasWished ? "🤍 Removed from Wishlist" : "❤️ Added to Wishlist",
        wasWished ? "wishlist_remove" : "wishlist_add",
        2800,
      );
    },
    [wishedIds, toggleWishRaw, showToast],
  );

  const [currency, setCurrency] = useState({
    symbol: "₹",
    code: "INR",
    position: "before",
  });

  const fmt = useCallback(
    (n) => makeFmt(currency.symbol, currency.position)(n),
    [currency],
  );
  const fmtExact = useCallback(
    (n) => makeFmtExact(currency.symbol, currency.position)(n),
    [currency],
  );

  const isAgent = user?.role === "broker" || user?.role === "sales";

  // ── Refresh the logged-in user's own record from the server ─────────
  const fetchCurrentUser = useCallback(async () => {
    if (!tenant || !user?.token) return;
    try {
      const fresh = await apiJson(tenant, `/user/me`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      // dispatch(setUser({ ...user, ...fresh, token: user.token }));
      updateUser(fresh);
    } catch (_) {
      // Non-fatal — dashboard still works with the cached user object.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant, user?.token]);

  const fetchMilestones = useCallback(
    async (bookingsList) => {
      const targets = bookingsList.filter(
        (b) =>
          (b.booking_status === "confirmed" ||
            b.booking_status === "pending") &&
          b.payment_plan_id,
      );
      if (!targets.length || !tenant) return;

      const results = await Promise.all(
        targets.map((b) =>
          apiJson(tenant, `/bookings/${b.id}/milestones`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
              Accept: "application/json",
            },
          }).catch(() => null),
        ),
      );
      const map = {};
      targets.forEach((b, i) => {
        if (results[i]) map[b.id] = results[i];
      });
      setMilestoneMap(map);
    },
    [user?.token, tenant],
  );

  const switchToBookings = useCallback(
    (bookingId) => {
      setActiveTab("bookings");
      if (!bookingId) return;
      setTimeout(() => {
        const el = document.getElementById(`booking-card-${bookingId}`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.style.boxShadow = `0 0 0 2px ${primaryColor}, 0 0 24px ${primaryColor}30`;
          el.style.transition = "box-shadow 0.3s";
          setTimeout(() => {
            el.style.boxShadow = "";
          }, 3000);
        }
      }, 150);
    },
    [primaryColor],
  );

  const fetchInvoices = useCallback(async () => {
    if (!tenant || !user?.token) return;
    try {
      const data = await apiJson(tenant, `/invoices`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Accept: "application/json",
        },
      });

      let invoicesList = [];
      if (data.success && Array.isArray(data.invoices)) {
        invoicesList = data.invoices;
      } else if (Array.isArray(data)) {
        invoicesList = data;
      }

      setInvoices(invoicesList);
      setInvoiceCount(invoicesList.length);
    } catch (_) {}
  }, [tenant, user?.token]);

  const fetchBookings = useCallback(async () => {
    if (!tenant || !user?.token) return;
    setLoading(true);
    setError("");
    try {
      const data = await apiJson(tenant, `/bookings`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      const list = Array.isArray(data) ? data : data.data || [];
      setBookings(list);
      fetchMilestones(list);
    } catch (e) {
      setError(e.message);
      showToast("❌ Could not load bookings. Please retry.", "error", 4000);
    } finally {
      setLoading(false);
    }
  }, [tenant, user?.token, fetchMilestones, showToast]);

  const fetchPayments = useCallback(async () => {
    if (!tenant || !user?.token) return;
    setPaymentsLoading(true);
    try {
      const [txns, booksRaw] = await Promise.all([
        apiJson(tenant, `/payment/history`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        }),
        apiJson(tenant, `/bookings`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
        }),
      ]);

      const txnList = Array.isArray(txns) ? txns : [];
      const books = Array.isArray(booksRaw) ? booksRaw : booksRaw.data || [];
      const txnBookingIds = new Set(txnList.map((t) => String(t.booking_id)));
      const missingTxns = books
        .filter(
          (b) =>
            b.booking_status === "confirmed" &&
            !txnBookingIds.has(String(b.id)),
        )
        .map((b) => ({
          id: `booking_${b.id}`,
          booking_id: b.id,
          amount: b.down_payment_amount || b.total_amount || 0,
          currency: "INR",
          status: "success",
          mode: "manual",
          gateway: "cash / manual",
          paid_at: b.created_at,
          _synthetic: true,
          booking: {
            id: b.id,
            plot_number: b.plot_number,
            plot_type: b.plot_type,
            booking_status: b.booking_status,
          },
        }));
      setPayments([...txnList, ...missingTxns]);
    } catch (_) {
    } finally {
      setPaymentsLoading(false);
    }
  }, [tenant, user?.token]);

  const fetchFeedbacks = useCallback(async () => {
    if (!tenant || !user?.token) return;
    try {
      const data = await apiJson(tenant, `/feedback`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      setFeedbacks(Array.isArray(data) ? data : data.data || []);
    } catch (_) {}
  }, [tenant, user?.token]);

  const fetchNotifications = useCallback(async () => {
    if (!tenant || !user?.token) return;
    setNotifsLoading(true);
    try {
      const data = await apiJson(tenant, `/notifications`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      const list = Array.isArray(data) ? data : data.data || [];
      setNotifications(list);
      setUnreadCount(list.filter((n) => !n.is_read).length);
    } catch (_) {
    } finally {
      setNotifsLoading(false);
    }
  }, [tenant, user?.token]);

  useEffect(() => {
    // Auth is still reading localStorage / restoring the session — don't
    // judge "logged out" from a `user` that hasn't been resolved yet.
    // Without this, a hard refresh sees `user === null` on the very first
    // render (before AuthProvider's own restore effect has run, since
    // child effects fire before parent effects on mount) and redirects
    // home even though the session is actually still valid.
    if (authInitializing) return;

    if (!user?.token || !tenant) {
      navigate(`/${tenant || ""}`);
      return;
    }

    const loadData = async () => {
      try {
        const currencyData = await apiJson(tenant, `/currency`);
        if (currencyData) {
          setCurrency({
            symbol: currencyData.symbol || "₹",
            code: currencyData.code || "INR",
            position: currencyData.position || "before",
          });
        }
      } catch (_) {}

      await Promise.all([
        fetchCurrentUser(),
        fetchBookings(),
        fetchNotifications(),
        fetchFeedbacks(),
        fetchPayments(),
        fetchInvoices(),
      ]);
    };

    loadData();

    // Check for payment confirmation from URL params
    const params = new URLSearchParams(window.location.search);
    const bookingId = params.get("booking");
    const sessionId = params.get("session_id");
    if (bookingId && sessionId && tenant && user?.token) {
      const confirmPayment = async () => {
        try {
          await apiJson(tenant, `/payment/stripe/confirm`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${user.token}`,
            },
            body: JSON.stringify({
              booking_id: bookingId,
              session_id: sessionId,
            }),
          });
          await Promise.all([
            fetchBookings(),
            fetchNotifications(),
            fetchPayments(),
            fetchInvoices(),
          ]);
          showToast(
            "🎉 Payment confirmed! Your booking is now active.",
            "booking",
            5000,
          );
        } catch (_) {}
      };
      confirmPayment();
      window.history.replaceState({}, "", window.location.pathname);
    }

    // Fetch unread messages count
    if (tenant && user?.token) {
      apiJson(tenant, `/messages/unread`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
        .then((d) => setUnreadMessages(d.unread || 0))
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant, user?.token, authInitializing]);

  const markRead = async (id) => {
    if (!tenant || !user?.token) return;
    try {
      await apiJson(tenant, `/notifications/${id}/read`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, is_read: true } : n)),
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (_) {}
  };

  const markAllRead = async () => {
    if (!tenant || !user?.token) return;
    try {
      await apiJson(tenant, `/notifications/read-all`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
      setUnreadCount(0);
      showToast("✅ All notifications marked as read", "success", 2500);
    } catch (_) {}
  };

  const handlePay = (id, milestoneId) => {
    if (milestoneId) {
      navigate(`/${tenant}/payment/${id}?milestone=${milestoneId}`);
    } else {
      navigate(`/${tenant}/payment/${id}`);
    }
  };

  // ── Send Payment Link (agent → client email) ────────────────
  // Keyed by `${bookingId}-${milestoneId || "main"}` so multiple pending
  // milestones on the same booking each get their own independent
  // loading state, instead of all lighting up together.
  const handleSendPaymentLink = useCallback(
    async (bookingId, milestoneId) => {
      if (!tenant || !user?.token) return;
      const key = `${bookingId}-${milestoneId || "main"}`;
      setSendingLinkKey(key);
      try {
        const data = await apiJson(
          tenant,
          `/bookings/${bookingId}/send-payment-link`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${user.token}`,
            },
            body: JSON.stringify({ milestone_id: milestoneId || undefined }),
          },
        );
        showToast(
          `✉️ Payment link sent to ${data?.sent_to || "the client"}`,
          "success",
          3800,
        );
      } catch (e) {
        showToast("❌ " + e.message, "error", 4000);
      } finally {
        setSendingLinkKey(null);
      }
    },
    [tenant, user?.token, showToast],
  );

  // ── Record Manual Payment (buyer paying manually, or agent recording a
  //    payment collected offline). Always pending admin approval. ────────
  const submitManualPayment = useCallback(
    async (bookingId, milestoneId, payload) => {
      if (!tenant || !user?.token) return false;
      try {
        await apiJson(tenant, `/bookings/${bookingId}/manual-payment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${user.token}`,
          },
          body: JSON.stringify({
            ...payload,
            milestone_id: milestoneId || undefined,
          }),
        });
        showToast(
          "✅ Payment recorded — awaiting admin approval",
          "success",
          4000,
        );
        return true;
      } catch (e) {
        showToast("❌ " + e.message, "error", 4000);
        return false;
      }
    },
    [tenant, user?.token, showToast],
  );

  // const handleLogout = () => {
  //   showToast("👋 Logged out successfully", "info", 2500);
  //   setTimeout(() => {
  //     dispatch(clearUser());
  //     navigate(`/${tenant}`);
  //   }, 600);
  // };

  const handleLogout = () => {
    showToast("👋 Logged out successfully", "info", 2500);
    setTimeout(() => {
      signOut();
      navigate(`/${tenant}`);
    }, 600);
  };

  // const handleSaved = (updated) => dispatch(setUser(updated));
  const handleSaved = (updated) => updateUser(updated);

  const handleCancel = async (bookingId) => {
    if (!tenant || !user?.token) return;
    try {
      await apiJson(tenant, `/bookings/${bookingId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      setBookings((prev) =>
        prev.map((b) =>
          b.id === bookingId ? { ...b, booking_status: "cancelled" } : b,
        ),
      );
      showToast("✅ Booking cancelled successfully", "success", 3500);
    } catch (e) {
      showToast("❌ " + e.message, "error", 4000);
    }
  };

  const confirmed = bookings.filter(
    (b) => b.booking_status === "confirmed",
  ).length;
  const pending = bookings.filter((b) => b.booking_status === "pending").length;

  const totalInvested = bookings
    .filter((b) => b.booking_status === "confirmed")
    .reduce((s, b) => {
      const msData = milestoneMap[b.id];
      if (msData?.milestones?.length) {
        const paidSum = msData.milestones
          .filter((m) => m.status === "paid")
          .reduce((ms, m) => ms + msAmount(m), 0);
        if (paidSum > 0) return s + paidSum;
        return (
          s +
          parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
        );
      }
      return (
        s + parseFloat(b.down_payment_amount || b.total_amount || b.price || 0)
      );
    }, 0);

  // ── Tabs — icons added so the vertical rail has a readable glyph
  // alongside each label. Behavior/counts unchanged. ─────────────
  const tabs = [
    {
      id: "bookings",
      label: isAgent ? "Client Bookings" : "My Bookings",
      count: bookings.length,
      icon: "📋",
    },
    { id: "wishlist", label: "Wishlist", count: wishlist.length, icon: "❤️" },
    { id: "payments", label: "Payments", count: 0, icon: "💳" },
    { id: "invoices", label: "Invoices", count: invoiceCount, icon: "🧾" },
    {
      id: "notifications",
      label: "Notifications",
      count: unreadCount,
      icon: "🔔",
    },
    { id: "feedback", label: "Feedback", count: 0, icon: "💬" },
    { id: "messages", label: "Messages", count: unreadMessages, icon: "✉️" },
    { id: "profile", label: "My Profile", count: 0, icon: "👤" },
  ];

  const logoUrl =
    settings?.app_logo_dark_url || settings?.app_logo_light_url || null;
  const appName = settings?.app_name || "Dashboard";

  // ── Theme — colors & fonts pulled from the tenant's own backend
  // settings instead of hardcoded defaults, matching the same pattern
  // used on UnitPage. Falls back to whatever UserDashboard.css already
  // defines globally whenever a given setting isn't present.
  const themeVars = {
    ...(settings?.primary_color && { "--primary-color": settings.primary_color }),
    ...(settings?.primary_hover_color && { "--primary-hover": settings.primary_hover_color }),
    ...(settings?.page_bg_color && { "--page-bg": settings.page_bg_color }),
    ...(settings?.card_bg_color && { "--card-bg": settings.card_bg_color }),
    ...(settings?.card_border_color && { "--card-border": settings.card_border_color }),
    ...(settings?.text_dark_color && { "--text-dark": settings.text_dark_color }),
    ...(settings?.text_muted_color && { "--text-muted": settings.text_muted_color }),
    ...(settings?.font_heading && { "--font-heading": settings.font_heading }),
    ...(settings?.font_body && { "--font-body": settings.font_body }),
  };

  // ── Auth still restoring the session (reading localStorage on mount) —
  // render a lightweight loading state instead of the dashboard shell,
  // which would otherwise access `user.name` etc. on a still-null user.
  if (authInitializing) {
    return (
      <div className="dashboard-loading" style={{ minHeight: "100vh" }}>
        <div className="dashboard-loading-icon">⏳</div>
        <div className="dashboard-loading-text">Loading…</div>
      </div>
    );
  }

  return (
    <div className="dashboard" style={themeVars}>
      {/* ── Vertical nav rail — replaces the old horizontal header.
           Same handlers as before (navigate(-1), setActiveTab,
           handleLogout) — only the layout moved from a top bar to a
           left-hand column. ── */}
      <div className="dashboard-rail">
        <button onClick={() => navigate(-1)} className="dash-rail-back">
          ← Back
        </button>

        {logoUrl ? (
          <img src={logoUrl} alt={appName} className="dash-rail-logo" />
        ) : (
          <span className="dash-rail-logo-text">
            {isAgent ? `${roleLabel(user.role)} Dashboard` : "My Dashboard"}
          </span>
        )}

        <div className="dash-rail-user">
          <div
            className="dashboard-avatar dash-rail-avatar"
            style={{
              background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
              boxShadow: `0 2px 8px ${primaryColor}30`,
            }}
          >
            {user?.name?.[0]?.toUpperCase()}
          </div>
          <div className="dash-rail-user-text">
            <div className="dash-rail-user-name">{user?.name}</div>
            <div className="dash-rail-user-role">
              {isAgent
                ? `${roleLabel(user.role)}${user?.broker_company ? " · " + user.broker_company : ""}`
                : "Buyer"}
            </div>
          </div>
        </div>

        {/* <button
          onClick={() => setActiveTab("notifications")}
          className="dash-rail-notif"
        >
          🔔 Notifications
          {unreadCount > 0 && (
            <span className="dashboard-notif-badge">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </button> */}

        <div className="dashboard-rail-tabs">
          {tabs.map((t) => (
            <TabButton
              key={t.id}
              active={activeTab === t.id}
              onClick={() => setActiveTab(t.id)}
              label={t.label}
              count={t.count}
              icon={t.icon}
            />
          ))}
        </div>

        <div className="rail-spacer" />

        <ElegantButton
          variant="secondary"
          onClick={handleLogout}
          size="sm"
          className="dash-rail-logout"
        >
          Logout
        </ElegantButton>
      </div>

      {/* ── Main content column ── */}
      <div className="dashboard-main">
        <div className="dashboard-container">
          {/* Welcome */}
          <div className="dashboard-welcome">
            <div className="dashboard-welcome-title">
              Welcome back, {user?.name?.split(" ")[0]}
            </div>
            <div className="dashboard-welcome-subtitle">
              {isAgent
                ? "Manage your client bookings and track your commissions."
                : "Track your property bookings and payments."}
            </div>
          </div>

          {/* Stat cards */}
          <div className="dashboard-stats">
            <StatCard
              icon="📋"
              label="Total Bookings"
              value={bookings.length}
              color={primaryColor}
            />
            <StatCard
              icon="✓"
              label="Confirmed"
              value={confirmed}
              color="#16a34a"
            />
            <StatCard
              icon="⏳"
              label="Pending Payment"
              value={pending}
              color="#d97706"
            />
            {!isAgent && (
              <StatCard
                icon="💰"
                label="Amount Invested"
                value={fmtExact(totalInvested)}
                color={primaryColor}
              />
            )}
          </div>

          {isAgent && bookings.length > 0 && (
            <AgentStats
              bookings={bookings}
              fmtExact={fmtExact}
              primaryColor={primaryColor}
            />
          )}

          {/* Tab Content — horizontal tab bar removed; tabs now live in
              the rail above. Everything below is unchanged. */}
          {activeTab === "bookings" && (
            <div>
              {loading && (
                <div className="dashboard-loading">
                  <div className="dashboard-loading-icon">⏳</div>
                  <div className="dashboard-loading-text">
                    Loading bookings...
                  </div>
                </div>
              )}
              {error && (
                <div className="dashboard-error">
                  <span>⚠ {error}</span>
                  <ElegantButton
                    variant="secondary"
                    onClick={fetchBookings}
                    size="sm"
                  >
                    Retry
                  </ElegantButton>
                </div>
              )}
              {!loading && Object.keys(milestoneMap).length > 0 && (
                <DuesBanner
                  milestoneMap={milestoneMap}
                  fmtExact={fmtExact}
                  onNavigate={(path) => navigate(`/${tenant}${path}`)}
                  primaryColor={primaryColor}
                  isAgent={isAgent}
                  onSendLink={handleSendPaymentLink}
                  onManualSubmit={submitManualPayment}
                  sendingLinkKey={sendingLinkKey}
                />
              )}
              {!loading && !error && bookings.length === 0 && (
                <div className="dashboard-empty">
                  <div className="dashboard-empty-icon">🏠</div>
                  <div className="dashboard-empty-title">
                    {isAgent ? "No client bookings yet" : "No bookings yet"}
                  </div>
                  <div className="dashboard-empty-subtitle">
                    {isAgent
                      ? "Book a unit for your clients from the unit page."
                      : "Browse available units to make your first booking."}
                  </div>
                  <ElegantButton onClick={() => navigate(`/${tenant}`)}>
                    Browse Units →
                  </ElegantButton>
                </div>
              )}
              <div className="dashboard-bookings">
                {!loading &&
                  bookings.map((b) => (
                    <BookingCard
                      key={b.id}
                      booking={b}
                      onPay={handlePay}
                      onCancel={handleCancel}
                      onSendPaymentLink={handleSendPaymentLink}
                      onManualSubmit={submitManualPayment}
                      sendingLinkKey={sendingLinkKey}
                      isAgent={isAgent}
                      fmtExact={fmtExact}
                      token={user?.token}
                      primaryColor={primaryColor}
                      milestoneMap={milestoneMap}
                      tenant={tenant}
                    />
                  ))}
              </div>
            </div>
          )}

          {activeTab === "wishlist" && (
            <WishlistTab
              wishlist={wishlist}
              wishedIds={wishedIds}
              onToggle={handleWishlistToggle}
              loading={wishLoading}
              token={user?.token}
              onNavigate={(path) => navigate(`/${tenant}${path}`)}
              fmt={fmt}
              tenant={tenant}
            />
          )}
          {activeTab === "payments" && (
            <PaymentsTab
              payments={payments}
              loading={paymentsLoading}
              fmt={fmt}
              fmtExact={fmtExact}
              user={user}
              tenant={tenant}
            />
          )}
          {activeTab === "invoices" && (
            <InvoicesTab user={user} fmt={fmt} tenant={tenant} />
          )}
          {activeTab === "notifications" && (
            <NotificationsTab
              notifications={notifications}
              loading={notifsLoading}
              unreadCount={unreadCount}
              onMarkRead={markRead}
              onMarkAllRead={markAllRead}
              onNavigate={(path) => navigate(`/${tenant}${path}`)}
              onSwitchToBookings={switchToBookings}
              primaryColor={primaryColor}
              tenant={tenant}
            />
          )}
          {activeTab === "feedback" && (
            <FeedbackTab
              feedbacks={feedbacks}
              bookings={bookings}
              token={user?.token}
              showToast={showToast}
              onSubmitted={(newFb) => setFeedbacks((prev) => [newFb, ...prev])}
              primaryColor={primaryColor}
              tenant={tenant}
            />
          )}
          {activeTab === "messages" && (
            <MessagesTab user={user} tenant={tenant} />
          )}
          {activeTab === "profile" && (
            <ProfilePanel
              user={user}
              onSaved={handleSaved}
              showToast={showToast}
              primaryColor={primaryColor}
              tenant={tenant}
            />
          )}
        </div>
      </div>
    </div>
  );
}
